export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  Json: { input: any; output: any; }
  MongoDate: { input: string; output: string; }
  ObjectId: { input: string; output: string; }
};

export type __AddessAutocomplete = {
  error?: Maybe<Scalars['Boolean']['output']>;
  suggestions: Array<__AddessAutocompleteItem>;
};

export type __AddessAutocompleteDetails = {
  address?: Maybe<__AddessAutocompleteDetailsAddress>;
  error?: Maybe<Scalars['Boolean']['output']>;
};

export type __AddessAutocompleteDetailsAddress = {
  apartment?: Maybe<Scalars['String']['output']>;
  city?: Maybe<Scalars['String']['output']>;
  postCode?: Maybe<Scalars['String']['output']>;
  state?: Maybe<Scalars['String']['output']>;
  street: Scalars['String']['output'];
};

export type __AddessAutocompleteItem = {
  mainText?: Maybe<Scalars['String']['output']>;
  placeId: Scalars['String']['output'];
  secondaryText?: Maybe<Scalars['String']['output']>;
};

export type __AdminAuth = {
  tokenEmail?: Maybe<Scalars['String']['output']>;
};

export type __AdminSub = {
  _id: Scalars['ObjectId']['output'];
  isActive?: Maybe<Scalars['Boolean']['output']>;
  sellerId?: Maybe<Scalars['ObjectId']['output']>;
  type: __EnumAdminSubsType;
  userId?: Maybe<Scalars['ObjectId']['output']>;
};

export type __AdminSubs = {
  info?: Maybe<__PaginationInfo>;
  items?: Maybe<Array<__AdminSub>>;
};

export type __AppLogsInput = {
  log?: InputMaybe<Array<__AppLogsInputLog>>;
};

export const __AppLogsInputAction = {
  Bug: 'Bug',
  Enter: 'Enter',
  Error: 'Error',
  Event: 'Event',
  Exit: 'Exit',
  Info: 'Info',
  Move: 'Move',
  Reenter: 'Reenter',
  Scroll: 'Scroll',
  Warn: 'Warn'
} as const;

export type __AppLogsInputAction = typeof __AppLogsInputAction[keyof typeof __AppLogsInputAction];
export type __AppLogsInputLog = {
  action?: InputMaybe<__AppLogsInputAction>;
  errJson?: InputMaybe<Scalars['String']['input']>;
  eventJson?: InputMaybe<Scalars['String']['input']>;
  from?: InputMaybe<__AppLogsInputLogRoute>;
  m?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  referrer?: InputMaybe<Scalars['String']['input']>;
  screenHeight?: InputMaybe<Scalars['Int']['input']>;
  screenWidth?: InputMaybe<Scalars['Int']['input']>;
  time?: InputMaybe<Scalars['String']['input']>;
  timezone?: InputMaybe<Scalars['String']['input']>;
  to?: InputMaybe<__AppLogsInputLogRoute>;
};

export type __AppLogsInputLogRoute = {
  fullPath?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  path?: InputMaybe<Scalars['String']['input']>;
  query?: InputMaybe<Array<__AppLogsInputLogRouteQuery>>;
};

export type __AppLogsInputLogRouteQuery = {
  key?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type __AppLogsResult = {
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type __AssignVariantToProductDelete = {
  delete: Scalars['Boolean']['input'];
  variantId: Scalars['ObjectId']['input'];
};

export type __AssignVariantToProductSeperate = {
  seperate: Scalars['Boolean']['input'];
  variantId: Scalars['ObjectId']['input'];
};

export type __AuthCodeRef = {
  _id: Scalars['ObjectId']['output'];
  codeRefNumber: Scalars['Int']['output'];
};

export type __BankTransferInvoice = {
  invoiceNr: Scalars['String']['output'];
  payUntil?: Maybe<Scalars['MongoDate']['output']>;
  price?: Maybe<Scalars['Float']['output']>;
  uiPrice?: Maybe<__Price2>;
};

export type __BuyerAddress = {
  _fullname?: Maybe<Scalars['String']['output']>;
  _id: Scalars['ObjectId']['output'];
  apartment?: Maybe<Scalars['String']['output']>;
  city: Scalars['String']['output'];
  country: __BuyerAddressCountry;
  deliveryInstruction?: Maybe<Scalars['String']['output']>;
  lastname?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  postCode: Scalars['String']['output'];
  state?: Maybe<Scalars['String']['output']>;
  street: Scalars['String']['output'];
  tel?: Maybe<Scalars['String']['output']>;
  type?: Maybe<__EnumAddressType>;
};

export type __BuyerAddressCountry = {
  _full?: Maybe<__BuyerAddressCountryFull>;
  iso2: Scalars['String']['output'];
};

export type __BuyerAddressCountryFull = {
  country?: Maybe<__MarketCountry>;
  iso2: Scalars['String']['output'];
};

export type __BuyerAddressDefault = {
  city?: Maybe<Scalars['String']['output']>;
  countryName?: Maybe<__Text>;
  iso2: Scalars['String']['output'];
  postCode?: Maybe<Scalars['String']['output']>;
};

export type __BuyerAddressDoc = {
  _id: Scalars['ObjectId']['output'];
  addressDefaultId?: Maybe<Scalars['ObjectId']['output']>;
  addresses: Array<__BuyerAddress>;
  invoices: Array<__BuyerInvoice>;
  lockerIds?: Maybe<Array<Scalars['String']['output']>>;
};

export type __BuyerAddressNode = {
  _lockersAndAddress?: Maybe<__BuyerAddressNodeLockersAndAddress>;
  doc: __BuyerAddressDoc;
  id: Scalars['ObjectId']['output'];
};

export type __BuyerAddressNodeLockersAndAddress = {
  doc?: Maybe<__BuyerAddressDoc>;
  lockers?: Maybe<__CheckoutDraftLockers>;
};

export type __BuyerB2b = {
  business?: Maybe<__SellerBusiness>;
  id: Scalars['String']['output'];
  request?: Maybe<__SellerBusinessRequest>;
  seller?: Maybe<__SellerPublic>;
};

export type __BuyerBoardCheck = {
  boardIds?: Maybe<Array<Scalars['String']['output']>>;
  id: Scalars['String']['output'];
};

export type __BuyerBoardResponse = __MutationResponeMsg & {
  board?: Maybe<__BuyerProductBoard>;
  check?: Maybe<Array<__BuyerBoardCheck>>;
  responseInfo: __ResponseInfo;
};

export type __BuyerBoardsAll = {
  cursorNext?: Maybe<Scalars['String']['output']>;
  items?: Maybe<Array<__BuyerProductBoard>>;
};

export type __BuyerBundleProducts = {
  bundle?: Maybe<__SellerBundle>;
  bundleId: Scalars['ObjectId']['output'];
  items: Array<__BuyerBundleProductsItem>;
};

export type __BuyerBundleProductsItem = {
  _uiPrice: __ProductListingBoxUiPrice;
  item: __ProductListing;
  priceBase: __Price2;
  pricePublic: __Price2;
};

export type __BuyerBundles = {
  cursorNext?: Maybe<Scalars['String']['output']>;
  items?: Maybe<Array<__SellerBundle>>;
};

export type __BuyerCart = {
  id: Scalars['String']['output'];
  items: Array<__BuyerCartItem>;
  sellers: Array<__BuyerCartShop>;
};

export type __BuyerCartItem = {
  _uiPrice: __ProductListingBoxUiPrice;
  action?: Maybe<__CartProductActionType>;
  available?: Maybe<__CartAvailability>;
  groupId: Scalars['ObjectId']['output'];
  priceTotal: __Price2Total;
  priceTotalOld?: Maybe<__Price2Total>;
  priceUnit: Scalars['Float']['output'];
  productId: Scalars['ObjectId']['output'];
  qty: Scalars['Float']['output'];
  sellerId: Scalars['ObjectId']['output'];
  stockLeft?: Maybe<Scalars['Float']['output']>;
  title: Scalars['String']['output'];
};

export type __BuyerCartShop = {
  checkoutType: __EnumSellerCheckoutType;
  discounts?: Maybe<Array<__CheckoutDraftValuesDiscount>>;
  isCartPriceValid?: Maybe<Scalars['Boolean']['output']>;
  isCheckoutAllowed?: Maybe<Scalars['Boolean']['output']>;
  isDoneProducts?: Maybe<Scalars['Boolean']['output']>;
  orderTotalMin?: Maybe<Scalars['Int']['output']>;
  priceProducts: __Price2;
  priceProductsOld?: Maybe<__Price2>;
  priceProductsTaxless: __Price2;
  priceSavings?: Maybe<__Price2>;
  sellerId: Scalars['ObjectId']['output'];
};

export type __BuyerCheckoutResponse = __MutationResponeMsg & {
  cartSelectSeller?: Maybe<Scalars['Boolean']['output']>;
  checkout?: Maybe<__CheckoutDraft>;
  orders?: Maybe<Array<__SellerOrderDoc>>;
  paymentInvoice?: Maybe<__PaymentInvoiceDoc>;
  paymentProvider?: Maybe<__PaymentProviderDoc>;
  responseInfo: __ResponseInfo;
  sellers?: Maybe<Array<__CheckoutConfirmationSeller>>;
};

export type __BuyerCompanyAddress = {
  apartment?: Maybe<Scalars['String']['output']>;
  city: Scalars['String']['output'];
  country: __BuyerAddressCountry;
  postCode: Scalars['String']['output'];
  state?: Maybe<Scalars['String']['output']>;
  street: Scalars['String']['output'];
  tel?: Maybe<Scalars['String']['output']>;
  type?: Maybe<__EnumAddressType>;
};

export type __BuyerEverypayCard = {
  _id: Scalars['ObjectId']['output'];
  _ui?: Maybe<__BuyerEverypayCardUi>;
  bankIso2?: Maybe<Scalars['String']['output']>;
  bankLogoUrl?: Maybe<Scalars['String']['output']>;
  bankName?: Maybe<Scalars['String']['output']>;
  brand?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['MongoDate']['output']>;
  expMonth?: Maybe<Scalars['Int']['output']>;
  expYear?: Maybe<Scalars['Int']['output']>;
  holderName?: Maybe<Scalars['String']['output']>;
  img?: Maybe<Scalars['String']['output']>;
  isActive?: Maybe<Scalars['Boolean']['output']>;
  issuer?: Maybe<Scalars['String']['output']>;
  issuerCountryIso2?: Maybe<Scalars['String']['output']>;
  lastFourDigits?: Maybe<Scalars['String']['output']>;
  product?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['MongoDate']['output']>;
  userId?: Maybe<Scalars['ObjectId']['output']>;
};

export type __BuyerEverypayCardUi = {
  debtorIban?: Maybe<Scalars['String']['output']>;
  expired: Scalars['Boolean']['output'];
  isMastercard: Scalars['Boolean']['output'];
  isOb: Scalars['Boolean']['output'];
  isVisa: Scalars['Boolean']['output'];
};

export type __BuyerEverypayCards = __PaginatedResults & {
  info?: Maybe<__PaginationInfo>;
  items?: Maybe<Array<__BuyerEverypayCard>>;
};

export type __BuyerInteractions = {
  comment: Scalars['Boolean']['output'];
  id: Scalars['String']['output'];
  likes: Scalars['Boolean']['output'];
  question: Scalars['Boolean']['output'];
  review: Scalars['Boolean']['output'];
};

export type __BuyerInvoice = {
  _id?: Maybe<Scalars['ObjectId']['output']>;
  company?: Maybe<__BuyerInvoiceCompany>;
  none?: Maybe<Scalars['Boolean']['output']>;
  personal?: Maybe<__BuyerInvoicePersonal>;
};

export type __BuyerInvoiceCompany = {
  address?: Maybe<__BuyerCompanyAddress>;
  companyCode: Scalars['String']['output'];
  companyName: Scalars['String']['output'];
  goodsForEuCommercialUse?: Maybe<Scalars['Boolean']['output']>;
  vatCode?: Maybe<Scalars['String']['output']>;
};

export type __BuyerInvoicePersonal = {
  country?: Maybe<__BuyerAddressCountry>;
  goodsForEuCommercialUse?: Maybe<Scalars['Boolean']['output']>;
  lastname: Scalars['String']['output'];
  message?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  vatCode?: Maybe<Scalars['String']['output']>;
};

export const __BuyerLikeType = {
  Article: 'Article',
  Review: 'Review'
} as const;

export type __BuyerLikeType = typeof __BuyerLikeType[keyof typeof __BuyerLikeType];
export type __BuyerLikes = {
  id: Scalars['ObjectId']['output'];
  liked: Scalars['Boolean']['output'];
};

export type __BuyerNotification = {
  _id: Scalars['ObjectId']['output'];
  orderPrettyId?: Maybe<Scalars['String']['output']>;
  type: __EnumBuyerNotification;
};

export type __BuyerNotifications = {
  _products?: Maybe<Array<__ProductListingBox>>;
  cursorNext?: Maybe<Scalars['String']['output']>;
  items: Array<__BuyerNotifyDoc>;
};

export type __BuyerNotifyDoc = {
  id: Scalars['String']['output'];
  isActive: Scalars['Boolean']['output'];
  onPriceDrop?: Maybe<Scalars['Float']['output']>;
  productId?: Maybe<Scalars['ObjectId']['output']>;
  type: __EnumBuyerNotifyDoc;
};

export type __BuyerOrderPayment = {
  invoice: __PaymentInvoiceDoc;
  order: Array<__BuyerOrderPaymentOrder>;
};

export type __BuyerOrderPaymentList = __PaginatedResults & {
  info?: Maybe<__PaginationInfo>;
  items?: Maybe<Array<__BuyerOrderPayment>>;
};

export type __BuyerOrderPaymentListYears = {
  years: Array<__BuyerOrderPaymentListYearsItem>;
};

export type __BuyerOrderPaymentListYearsItem = {
  count: Scalars['Int']['output'];
  year: Scalars['String']['output'];
};

export type __BuyerOrderPaymentOrder = {
  _id: Scalars['ObjectId']['output'];
  paymentId: Scalars['ObjectId']['output'];
  prettyId: Scalars['String']['output'];
  pricesFinal: __Price2Total;
  productCount: Scalars['Int']['output'];
  products: Array<__SellerOrderDocProduct>;
  productsManual: Array<__SellerOrderDocProduct>;
  statusUi: __SellerOrderStatusUi;
};

export type __BuyerOrderProduct = {
  _id: Scalars['ObjectId']['output'];
  groupId?: Maybe<Scalars['ObjectId']['output']>;
  lastOrder?: Maybe<Scalars['MongoDate']['output']>;
  lastPrice?: Maybe<Scalars['Float']['output']>;
  orderIds?: Maybe<Array<Scalars['ObjectId']['output']>>;
  orders?: Maybe<Scalars['Int']['output']>;
  price?: Maybe<Scalars['Float']['output']>;
  productId: Scalars['ObjectId']['output'];
  qty?: Maybe<Scalars['Float']['output']>;
};

export type __BuyerOrderProducts = {
  cursorNext?: Maybe<Scalars['String']['output']>;
  items?: Maybe<Array<__BuyerOrderProduct>>;
};

export const __BuyerOrderProductsFind = {
  All: 'All',
  ToReview: 'ToReview'
} as const;

export type __BuyerOrderProductsFind = typeof __BuyerOrderProductsFind[keyof typeof __BuyerOrderProductsFind];
export const __BuyerOrderProductsSort = {
  LastOrder: 'LastOrder',
  Orders: 'Orders',
  Qty: 'Qty'
} as const;

export type __BuyerOrderProductsSort = typeof __BuyerOrderProductsSort[keyof typeof __BuyerOrderProductsSort];
export type __BuyerPostExists = {
  exists?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['String']['output'];
};

export type __BuyerPostRef = {
  existsOnView?: Maybe<Array<__BuyerPostExists>>;
  review?: Maybe<__BuyerPostReviewedProduct>;
};

export type __BuyerPostReviewMultiget = {
  items: Array<__BuyerPostReviewedProduct>;
};

export type __BuyerPostReviewedProduct = {
  id: Scalars['String']['output'];
  order?: Maybe<__PostReviewOrder>;
  rating?: Maybe<__PostReviewRating>;
};

export type __BuyerProductBoard = {
  _allProductIds?: Maybe<__ProductIds>;
  _id: Scalars['ObjectId']['output'];
  _listings?: Maybe<__Listings>;
  addedAt?: Maybe<Scalars['MongoDate']['output']>;
  images?: Maybe<Array<__Image>>;
  isDefault: Scalars['Boolean']['output'];
  isPublic: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  productCount?: Maybe<Scalars['Int']['output']>;
  updatedAt?: Maybe<Scalars['MongoDate']['output']>;
};


export type __BuyerProductBoard_ListingsArgs = {
  input: __CursorInput;
};

export type __BuyerProductHistory = {
  cursorNext?: Maybe<Scalars['String']['output']>;
  items?: Maybe<Array<__BuyerProductHistoryItem>>;
};

export type __BuyerProductHistoryItem = {
  active?: Maybe<Scalars['Boolean']['output']>;
  addedAt: Scalars['MongoDate']['output'];
  id: Scalars['String']['output'];
};

export type __BuyerProductHistoryStats = {
  _boardBox?: Maybe<__BuyerProductBoard>;
  id: Scalars['String']['output'];
};

export type __BuyerReturnOrder = {
  order: __SellerOrderDoc;
};

export type __BuyerReturnOrders = __PaginatedResults & {
  info?: Maybe<__PaginationInfo>;
  items: Array<__BuyerReturnOrder>;
};

export type __BuyerReturnTrackingNumberDetail = {
  courier?: Maybe<Scalars['String']['output']>;
  trackingNumber: Scalars['String']['output'];
};

export type __BuyerReviewsProduct = {
  countries?: Maybe<__MarketCountriesRef>;
  products?: Maybe<Array<__BuyerReviewsProductProduct>>;
  review?: Maybe<__Post>;
};

export type __BuyerReviewsProductProduct = {
  createdAt?: Maybe<Scalars['MongoDate']['output']>;
  orderId: Scalars['ObjectId']['output'];
  ref: __SellerOrderDocProduct;
};

export type __BuyerSellerOrderResponse = __MutationResponeMsg & {
  me?: Maybe<__Me>;
  order?: Maybe<Array<__SellerOrderDoc>>;
  payStart?: Maybe<__BuyerSellerOrderResponsePayStart>;
  paymentInvoice?: Maybe<__PaymentInvoiceDoc>;
  paymentProvider?: Maybe<__PaymentProviderDoc>;
  responseInfo: __ResponseInfo;
  shipment?: Maybe<__SellerShipment>;
};

export type __BuyerSellerOrderResponsePayStart = {
  allowToPay?: Maybe<Scalars['Boolean']['output']>;
  paymentFailed?: Maybe<__BuyerSellerOrderResponsePayStartFaild>;
  stockValid?: Maybe<Scalars['Boolean']['output']>;
};

export type __BuyerSellerOrderResponsePayStartFaild = {
  at: Scalars['MongoDate']['output'];
  type: __PaymentType;
};

export type __BuyerSubscriptions = {
  items: Array<__BuyerSubscriptionsItem>;
};

export type __BuyerSubscriptionsItem = {
  id: Scalars['String']['output'];
  newsletter: Scalars['Boolean']['output'];
  reviewRemindersEnabled: Scalars['Boolean']['output'];
};

export type __BuyerTaxInfo = {
  goodsForEuCommercialUse: Scalars['Boolean']['output'];
  isTaxed: Scalars['Boolean']['output'];
  iso2: Scalars['String']['output'];
  vatSize: Scalars['Float']['output'];
};

export const __CartAvailability = {
  Available: 'Available',
  OutOfStock: 'OutOfStock',
  QuantityOutOfStock: 'QuantityOutOfStock',
  Upcoming: 'Upcoming'
} as const;

export type __CartAvailability = typeof __CartAvailability[keyof typeof __CartAvailability];
export const __CartProductActionType = {
  Added: 'Added',
  Decreased: 'Decreased',
  Increased: 'Increased'
} as const;

export type __CartProductActionType = typeof __CartProductActionType[keyof typeof __CartProductActionType];
export type __CatalogFiltersInput = {
  key: Scalars['String']['input'];
  max?: InputMaybe<Scalars['Int']['input']>;
  min?: InputMaybe<Scalars['Int']['input']>;
  multi?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type __CatalogFiltersInputType = {
  key: Scalars['String']['output'];
  max?: Maybe<Scalars['Int']['output']>;
  min?: Maybe<Scalars['Int']['output']>;
  multi?: Maybe<Array<Scalars['String']['output']>>;
};

export type __CatalogInputType = {
  catalogSlug?: Maybe<Scalars['String']['output']>;
  cursor?: Maybe<__CursorInputType>;
  department?: Maybe<Scalars['String']['output']>;
  filters?: Maybe<Array<__CatalogFiltersInputType>>;
  isB2b: Scalars['Boolean']['output'];
  limitTo?: Maybe<Array<__CatalogSearchLimitTo>>;
  query?: Maybe<Scalars['String']['output']>;
  seller: __SellerId;
  sellerCollection?: Maybe<Scalars['String']['output']>;
  sku?: Maybe<Array<Scalars['String']['output']>>;
  sort?: Maybe<__EnumCatalogSort>;
};

export const __CatalogSearchLimitTo = {
  InStock: 'InStock',
  Limited: 'Limited',
  New: 'New',
  Sale: 'Sale',
  Upcoming: 'Upcoming'
} as const;

export type __CatalogSearchLimitTo = typeof __CatalogSearchLimitTo[keyof typeof __CatalogSearchLimitTo];
export type __CheckoutConfirmationSeller = {
  order: __SellerOrderDoc;
  seller?: Maybe<__SellerDoc>;
};

export type __CheckoutDeliveryOptions = {
  errors?: Maybe<Array<__CheckoutDeliveryOptionsError>>;
  id: Scalars['String']['output'];
  locationOptions?: Maybe<Array<__CheckoutDraftDeliveryItem>>;
  lockerOptionIds: Array<Scalars['String']['output']>;
  lockerOptions?: Maybe<Array<__CheckoutDraftDeliveryItem>>;
  shippingOptions?: Maybe<Array<__CheckoutDraftDeliveryItem>>;
};

export type __CheckoutDeliveryOptionsError = {
  msg: Scalars['String']['output'];
  provider: Scalars['String']['output'];
};

export const __CheckoutDeliveryStatus = {
  Canceled: 'Canceled',
  CollectionReady: 'CollectionReady',
  Created: 'Created',
  Delivered: 'Delivered',
  Returned: 'Returned',
  Shipped: 'Shipped',
  ShippedPartially: 'ShippedPartially'
} as const;

export type __CheckoutDeliveryStatus = typeof __CheckoutDeliveryStatus[keyof typeof __CheckoutDeliveryStatus];
export type __CheckoutDraft = {
  _id: Scalars['ObjectId']['output'];
  addressOptions?: Maybe<__CheckoutDraftAddress>;
  deliveryOptions?: Maybe<__CheckoutDraftDelivery>;
  doc: __CheckoutDraftDoc;
  values?: Maybe<__CheckoutDraftValues>;
};


export type __CheckoutDraftDeliveryOptionsArgs = {
  keys: Array<Scalars['String']['input']>;
};

export type __CheckoutDraftAddress = {
  id?: Maybe<Scalars['String']['output']>;
  items?: Maybe<Array<__BuyerAddress>>;
};

export type __CheckoutDraftDelivery = {
  options: Array<__CheckoutDeliveryOptions>;
  values?: Maybe<__CheckoutDraftValues>;
};

export type __CheckoutDraftDeliveryItem = {
  _lockerId?: Maybe<Scalars['String']['output']>;
  address?: Maybe<__Text>;
  deliveryDocId: Scalars['ObjectId']['output'];
  deliveryDuraitonDays?: Maybe<Scalars['Int']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  disabled?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['String']['output'];
  isFreeShipping?: Maybe<Scalars['Boolean']['output']>;
  lockerProvider?: Maybe<__EnumLockerProvider>;
  openingHours?: Maybe<__Text>;
  orderWithin: Scalars['String']['output'];
  price?: Maybe<__Price2>;
  receiveBy: Scalars['String']['output'];
  title?: Maybe<Scalars['String']['output']>;
  type: __SellerDeliveryType;
};

export type __CheckoutDraftDoc = {
  _id: Scalars['ObjectId']['output'];
  userId: Scalars['ObjectId']['output'];
};

export type __CheckoutDraftInput = {
  addDiscountCode?: InputMaybe<__CheckoutDraftInputCode>;
  addressUpdate?: InputMaybe<__InputBuyerAddressUpdate>;
  checkoutId?: InputMaybe<Scalars['ObjectId']['input']>;
  create?: InputMaybe<__CheckoutDraftInputCreateOrder>;
  createManual?: InputMaybe<__InputCheckoutDraftCreateManual>;
  invoiceRemove?: InputMaybe<__InputBool>;
  invoiceSet?: InputMaybe<__InputId>;
  removeDiscountCode?: InputMaybe<__CheckoutDraftInputCodeRemove>;
  repeat?: InputMaybe<__OrderInput>;
  replaceProduct?: InputMaybe<__CheckoutQuoteReplaceProduct>;
  sellerRemove?: InputMaybe<__InputId>;
  setDelivery?: InputMaybe<__CheckoutDraftInputSeller>;
  setMainAddress?: InputMaybe<__CheckoutDraftInputMainAddress>;
  setProduct?: InputMaybe<__CheckoutDraftInputSetProduct>;
  start?: InputMaybe<__OrderDraftUpdateInputStart>;
};

export type __CheckoutDraftInputBillinAddress = {
  addressEdit?: InputMaybe<__InputBuyerAddressValues>;
  type: __EnumCheckoutDraftInputBillinAddress;
};

export type __CheckoutDraftInputCode = {
  code: Scalars['String']['input'];
};

export type __CheckoutDraftInputCodeRemove = {
  discountId: Scalars['String']['input'];
};

export type __CheckoutDraftInputCreateOrder = {
  pay: __InputBuyerPay;
  resetCart?: InputMaybe<Scalars['Boolean']['input']>;
};

export type __CheckoutDraftInputMainAddress = {
  address?: InputMaybe<__InputBuyerAddressValues>;
  addressId?: InputMaybe<Scalars['ObjectId']['input']>;
};

export type __CheckoutDraftInputPaypalCanceled = {
  paymentId: Scalars['String']['input'];
  paypalOrderId: Scalars['String']['input'];
};

export type __CheckoutDraftInputSeller = {
  deliveryOptionId: Scalars['String']['input'];
  lockerId?: InputMaybe<Scalars['String']['input']>;
  sellerId: Scalars['ObjectId']['input'];
};

export type __CheckoutDraftInputSetProduct = {
  productId: Scalars['String']['input'];
  quantity: Scalars['Float']['input'];
};

export type __CheckoutDraftLockers = {
  countries?: Maybe<__MarketCountriesRef>;
  items: Array<__LockersItem>;
};

export type __CheckoutDraftLockersCities = {
  items?: Maybe<Array<Scalars['String']['output']>>;
};

export type __CheckoutDraftSeller = {
  activeDelivery?: Maybe<__CheckoutDraftDeliveryItem>;
  deliveryDiscounts?: Maybe<__CheckoutDraftSellerDeliveryDiscounts>;
  deliveryOptionsKey?: Maybe<Scalars['String']['output']>;
  discountIds?: Maybe<Array<Scalars['String']['output']>>;
  isDoneDelivery: Scalars['Boolean']['output'];
  isDoneProducts: Scalars['Boolean']['output'];
  isFreeShipping?: Maybe<Scalars['Boolean']['output']>;
  prices?: Maybe<__PaymentPrices>;
  products: Array<__SelleCheckoutDraftProduct>;
  sellerId: Scalars['ObjectId']['output'];
  sellerName: Scalars['String']['output'];
};

export type __CheckoutDraftSellerDeliveryDiscounts = {
  freeDeliveryAll?: Maybe<Scalars['Boolean']['output']>;
  freeDeliveryIds?: Maybe<Array<Scalars['ObjectId']['output']>>;
};

export type __CheckoutDraftValues = {
  addressMain?: Maybe<__BuyerAddress>;
  discounts: Array<__CheckoutDraftValuesDiscount>;
  email?: Maybe<Scalars['String']['output']>;
  fullname?: Maybe<Scalars['String']['output']>;
  id: Scalars['ObjectId']['output'];
  invoice?: Maybe<__BuyerInvoice>;
  isAllowedToPay: Scalars['Boolean']['output'];
  isAuth: Scalars['Boolean']['output'];
  isCartPriceValid: Scalars['Boolean']['output'];
  isDoneDelivery: Scalars['Boolean']['output'];
  isDoneProducts: Scalars['Boolean']['output'];
  isEmpty: Scalars['Boolean']['output'];
  isPayedWithGiftCards: Scalars['Boolean']['output'];
  paymentId?: Maybe<Scalars['ObjectId']['output']>;
  prices?: Maybe<__PaymentPrices>;
  sellers: Array<__CheckoutDraftSeller>;
};

export type __CheckoutDraftValuesDiscount = {
  code?: Maybe<Scalars['String']['output']>;
  discountId: Scalars['String']['output'];
  isB2b?: Maybe<Scalars['Boolean']['output']>;
  isDiscount?: Maybe<Scalars['Boolean']['output']>;
  isGiftcard?: Maybe<Scalars['Boolean']['output']>;
  isNext?: Maybe<Scalars['Boolean']['output']>;
  isUsed?: Maybe<Scalars['Boolean']['output']>;
  sellerId?: Maybe<Scalars['String']['output']>;
  ui: Array<__DiscountUi>;
};

export type __CheckoutOrderHistoryItem = {
  at: Scalars['MongoDate']['output'];
  status: __SellerOrderStatus;
};

export type __CheckoutOrders = {
  _id: Scalars['ObjectId']['output'];
  orders: Array<__SellerOrderDoc>;
  paymentInvoice?: Maybe<__PaymentInvoiceDoc>;
  paymentProvider?: Maybe<__PaymentProviderDoc>;
  sellers?: Maybe<Array<__CheckoutConfirmationSeller>>;
};

export type __CheckoutPaymentHistoryItem = {
  at: Scalars['MongoDate']['output'];
  status: __CheckoutPaymentStatus;
};

export const __CheckoutPaymentStatus = {
  Canceled: 'Canceled',
  Chargeback: 'Chargeback',
  Created: 'Created',
  OpenAccount: 'OpenAccount',
  PaymentConfirmed: 'PaymentConfirmed',
  PaymentFailed: 'PaymentFailed',
  PaymentFailedRepeatWarning: 'PaymentFailedRepeatWarning',
  PaymentProcessing: 'PaymentProcessing',
  PaymentReceived: 'PaymentReceived',
  PaymentTransferWaiting: 'PaymentTransferWaiting',
  PaymentTransferWaitingLate: 'PaymentTransferWaitingLate',
  PaymentTransferWaitingWarning: 'PaymentTransferWaitingWarning',
  RefundedFully: 'RefundedFully',
  RefundedPartially: 'RefundedPartially',
  Voided: 'Voided'
} as const;

export type __CheckoutPaymentStatus = typeof __CheckoutPaymentStatus[keyof typeof __CheckoutPaymentStatus];
export type __CheckoutQuote = {
  _admin?: Maybe<__SellerQuoteAdmin>;
  _adminOriginal?: Maybe<__SellerQuoteAdminOriginal>;
  _checkout?: Maybe<__CheckoutQuoteCheckout>;
  _id: Scalars['ObjectId']['output'];
  _uiBox?: Maybe<__CheckoutQuoteCheckoutUiBox>;
  createdAt?: Maybe<Scalars['MongoDate']['output']>;
  delivery?: Maybe<__SellerQuoteDelivery>;
  prettyId?: Maybe<Scalars['String']['output']>;
  sellerId: Scalars['ObjectId']['output'];
  status: __CheckoutQuoteStatus;
  updatedAt?: Maybe<Scalars['MongoDate']['output']>;
};

export type __CheckoutQuoteAction = {
  _id: Scalars['ObjectId']['output'];
  action?: Maybe<Scalars['String']['output']>;
  author?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['MongoDate']['output']>;
  isCustomer?: Maybe<Scalars['Boolean']['output']>;
  isSeller?: Maybe<Scalars['Boolean']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  seenBySeller?: Maybe<Scalars['Boolean']['output']>;
};

export type __CheckoutQuoteActions = {
  cursorNext?: Maybe<Scalars['String']['output']>;
  items?: Maybe<Array<__CheckoutQuoteAction>>;
};

export type __CheckoutQuoteCalcRetailProductDiscount = {
  products: Array<__SellerQuoteUpdateProductsCalcRetailDiscountProduct>;
};

export type __CheckoutQuoteCheckout = {
  discountPercent?: Maybe<Scalars['Int']['output']>;
  discounts: Array<__CheckoutDraftValuesDiscount>;
  isAllowedToPay: Scalars['Boolean']['output'];
  isCartPriceValid: Scalars['Boolean']['output'];
  isCheckoutFinished: Scalars['Boolean']['output'];
  isDeliveryValid: Scalars['Boolean']['output'];
  isEmpty: Scalars['Boolean']['output'];
  isProductsValid: Scalars['Boolean']['output'];
  orderTotalMin?: Maybe<Scalars['Int']['output']>;
  paymentDelayDays?: Maybe<Scalars['Int']['output']>;
  prices?: Maybe<__PaymentPrices>;
  products: Array<__SelleCheckoutDraftProduct>;
  productsManual: Array<__SellerOrderDocProduct>;
};

export type __CheckoutQuoteCheckoutUiBox = {
  company?: Maybe<Scalars['String']['output']>;
  delivery?: Maybe<__EnumCheckoutQuoteDelivery>;
  deliveryOrder?: Maybe<__SellerOrderDelivery>;
  expiration?: Maybe<Scalars['MongoDate']['output']>;
  fullname?: Maybe<Scalars['String']['output']>;
  history?: Maybe<Array<__CheckoutQuoteHistory>>;
  invoice?: Maybe<__BuyerInvoice>;
  lastAdminUpdate?: Maybe<Scalars['MongoDate']['output']>;
  lastMessageAt?: Maybe<Scalars['MongoDate']['output']>;
  lastMessageId?: Maybe<Scalars['ObjectId']['output']>;
  messageCount?: Maybe<Scalars['Int']['output']>;
  orderId?: Maybe<Scalars['String']['output']>;
  prices?: Maybe<__PaymentPrices>;
  productCount?: Maybe<Scalars['Int']['output']>;
  products?: Maybe<Array<__SellerCheckoutProduct>>;
  shippingAddress?: Maybe<__BuyerAddress>;
  weightGrams?: Maybe<__UiWeight>;
};

export type __CheckoutQuoteHistory = {
  at: Scalars['MongoDate']['output'];
  status?: Maybe<__CheckoutQuoteStatus>;
};

export type __CheckoutQuoteReplaceProduct = {
  productId: Scalars['String']['input'];
  replacementProductId: Scalars['String']['input'];
};

export const __CheckoutQuoteStatus = {
  Canceled: 'Canceled',
  Created: 'Created',
  InReview: 'InReview',
  OrderPlaced: 'OrderPlaced',
  SellerSubmited: 'SellerSubmited'
} as const;

export type __CheckoutQuoteStatus = typeof __CheckoutQuoteStatus[keyof typeof __CheckoutQuoteStatus];
export type __CheckoutQuotes = __PaginatedResults & {
  info?: Maybe<__PaginationInfo>;
  items?: Maybe<Array<__CheckoutQuote>>;
};

export type __CheckoutUpcomingDeliveryOptions = {
  deliveryDiscounts?: Maybe<__CheckoutDraftSellerDeliveryDiscounts>;
  locationOptions?: Maybe<Array<__CheckoutDraftDeliveryItem>>;
  lockerOptionIds: Array<Scalars['String']['output']>;
  lockerOptions?: Maybe<Array<__CheckoutDraftDeliveryItem>>;
  shippingOptions?: Maybe<Array<__CheckoutDraftDeliveryItem>>;
};

export type __CursorInput = {
  number: Scalars['Int']['input'];
  size: Scalars['Int']['input'];
};

export type __CursorInputType = {
  number: Scalars['Int']['output'];
  size: Scalars['Int']['output'];
};

export const __DiscountType2 = {
  NewPrice: 'NewPrice',
  Percentage: 'Percentage',
  PercentageRoundUp: 'PercentageRoundUp',
  ReducePriceBy: 'ReducePriceBy'
} as const;

export type __DiscountType2 = typeof __DiscountType2[keyof typeof __DiscountType2];
export type __DiscountUi = {
  amount: Scalars['String']['output'];
  msg: Scalars['String']['output'];
};

export type __DocumentBlock = {
  blockType?: Maybe<__EnumDocumentBlockType>;
  img?: Maybe<__Image>;
  link?: Maybe<__SellerLink>;
  padding?: Maybe<Array<Scalars['Int']['output']>>;
  productId?: Maybe<Scalars['String']['output']>;
  productUi?: Maybe<__EnumDocumentBlockProductUi>;
  radius?: Maybe<Scalars['Int']['output']>;
  ratio?: Maybe<__ImageTaggedRatio>;
  spanCol?: Maybe<Scalars['Int']['output']>;
  spanRow?: Maybe<Scalars['Int']['output']>;
  table?: Maybe<__DocumentBlockTable>;
  tags?: Maybe<Array<__DocumentBlockTag>>;
  txt?: Maybe<Array<__DocumentBlockTxt>>;
};

export type __DocumentBlockHeader = {
  align?: Maybe<__EnumDocumentBlockTxtAlign>;
  link?: Maybe<__SellerLink>;
  linkUi?: Maybe<__EnumDocumentLinkUi>;
  padding?: Maybe<Array<Scalars['Int']['output']>>;
  text?: Maybe<__LexicalTranslated>;
};

export type __DocumentBlockTable = {
  entries: Array<__DocumentBlockTableEntry>;
  flowCol?: Maybe<Scalars['Boolean']['output']>;
  headers: Array<__DocumentBlockTableHead>;
  layout: __EnumDocumentBlockFixed;
  view: __EnumDocumentBlockTable;
};

export type __DocumentBlockTableEntry = {
  bg?: Maybe<__DocumentColor>;
  color?: Maybe<__DocumentColor>;
  index: Scalars['Int']['output'];
  key: Scalars['String']['output'];
  padding?: Maybe<Array<Scalars['Int']['output']>>;
  text?: Maybe<__LexicalTranslated>;
};

export type __DocumentBlockTableHead = {
  align?: Maybe<__EnumDocumentBlockTxtAlign>;
  bg?: Maybe<__DocumentColor>;
  color?: Maybe<__DocumentColor>;
  key: Scalars['String']['output'];
  padding?: Maybe<Array<Scalars['Int']['output']>>;
  text?: Maybe<__LexicalTranslated>;
};

export type __DocumentBlockTag = {
  groupId?: Maybe<Scalars['String']['output']>;
  productId?: Maybe<Scalars['String']['output']>;
  profileId?: Maybe<Scalars['String']['output']>;
  x?: Maybe<Scalars['Float']['output']>;
  xAlign?: Maybe<__EnumDocumentTxtFloatAlign>;
  y?: Maybe<Scalars['Float']['output']>;
  yAlign?: Maybe<__EnumDocumentTxtFloatAlign>;
};

export type __DocumentBlockTxt = {
  align?: Maybe<__EnumDocumentBlockTxtAlign>;
  bg?: Maybe<__DocumentColor>;
  color?: Maybe<__DocumentColor>;
  floating?: Maybe<Array<__EnumBlockTextFloating>>;
  link?: Maybe<__SellerLink>;
  linkUi?: Maybe<__EnumDocumentLinkUi>;
  padding?: Maybe<Array<Scalars['Int']['output']>>;
  radius?: Maybe<Scalars['Int']['output']>;
  text?: Maybe<__LexicalTranslated>;
  type?: Maybe<__EnumDocumentBlockTxtType>;
  width?: Maybe<__DocumentWidth>;
  x?: Maybe<Scalars['Float']['output']>;
  xAlign?: Maybe<__EnumDocumentTxtFloatAlign>;
  y?: Maybe<Scalars['Float']['output']>;
  yAlign?: Maybe<__EnumDocumentTxtFloatAlign>;
};

export type __DocumentColor = {
  _id?: Maybe<Scalars['ObjectId']['output']>;
  color?: Maybe<__DocumentColorHsla>;
  gradient?: Maybe<Array<__DocumentColorGradient>>;
};

export type __DocumentColorGradient = {
  colors?: Maybe<Array<__DocumentColorGradientCol>>;
  linearDeg?: Maybe<Scalars['Float']['output']>;
  radialX?: Maybe<Scalars['Float']['output']>;
  radialY?: Maybe<Scalars['Float']['output']>;
  repeat?: Maybe<Scalars['Boolean']['output']>;
  type?: Maybe<__EnumDocumentColorGradientRadialSize>;
};

export type __DocumentColorGradientCol = {
  color: __DocumentColorHsla;
  percent: Scalars['Float']['output'];
};

export type __DocumentColorHsla = {
  a?: Maybe<Scalars['Float']['output']>;
  h: Scalars['Float']['output'];
  l: Scalars['Float']['output'];
  s: Scalars['Float']['output'];
};

export type __DocumentColorSearch = __PaginatedResults & {
  info?: Maybe<__PaginationInfo>;
  items?: Maybe<Array<__DocumentColor>>;
};

export type __DocumentSection = {
  bg?: Maybe<__DocumentColor>;
  blockWidth?: Maybe<__DocumentWidth>;
  blocks?: Maybe<Array<__DocumentBlock>>;
  color?: Maybe<__DocumentColor>;
  cols?: Maybe<Scalars['Int']['output']>;
  gapCol?: Maybe<Scalars['Int']['output']>;
  gapRow?: Maybe<Scalars['Int']['output']>;
  head?: Maybe<__DocumentBlockHeader>;
  hidden?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['ObjectId']['output'];
  padding?: Maybe<Array<Scalars['Int']['output']>>;
  rows?: Maybe<Scalars['Int']['output']>;
  type?: Maybe<__SellerDocumentBlocksType>;
  width?: Maybe<__DocumentWidth>;
};

export type __DocumentWidth = {
  unit: __EnumDocumentWidthUnit;
  value: Scalars['Float']['output'];
};

export type __Duration = {
  unit: __EnumDuration;
  value: Scalars['Int']['output'];
};

export type __EmailBlacklistinResponse = __MutationResponeMsg & {
  responseInfo: __ResponseInfo;
};

export type __EmailingUpdating = {
  add?: InputMaybe<Array<Scalars['String']['input']>>;
  remove?: InputMaybe<Array<Scalars['String']['input']>>;
};

export const __EnumAddressType = {
  Autocomplete: 'Autocomplete',
  Manual: 'Manual'
} as const;

export type __EnumAddressType = typeof __EnumAddressType[keyof typeof __EnumAddressType];
export const __EnumAdminSubsType = {
  B2BRequest: 'B2BRequest',
  Quote: 'Quote'
} as const;

export type __EnumAdminSubsType = typeof __EnumAdminSubsType[keyof typeof __EnumAdminSubsType];
export const __EnumBlockTextFloating = {
  Hidden: 'Hidden'
} as const;

export type __EnumBlockTextFloating = typeof __EnumBlockTextFloating[keyof typeof __EnumBlockTextFloating];
export const __EnumBuyerGender = {
  Famale: 'Famale',
  Male: 'Male',
  Na: 'Na'
} as const;

export type __EnumBuyerGender = typeof __EnumBuyerGender[keyof typeof __EnumBuyerGender];
export const __EnumBuyerNotification = {
  OrderCollectionReady: 'OrderCollectionReady',
  OrderShipped: 'OrderShipped'
} as const;

export type __EnumBuyerNotification = typeof __EnumBuyerNotification[keyof typeof __EnumBuyerNotification];
export const __EnumBuyerNotifyDoc = {
  Price: 'Price',
  Stock: 'Stock'
} as const;

export type __EnumBuyerNotifyDoc = typeof __EnumBuyerNotifyDoc[keyof typeof __EnumBuyerNotifyDoc];
export const __EnumBuyerType = {
  OneTime: 'OneTime',
  Regular: 'Regular',
  Wholesale: 'Wholesale',
  WholesaleOneTime: 'WholesaleOneTime'
} as const;

export type __EnumBuyerType = typeof __EnumBuyerType[keyof typeof __EnumBuyerType];
export const __EnumCatalogSort = {
  Available: 'Available',
  BestMatch: 'BestMatch',
  EndsAt: 'EndsAt',
  New: 'New',
  PriceAsc: 'PriceAsc',
  PriceDsc: 'PriceDsc'
} as const;

export type __EnumCatalogSort = typeof __EnumCatalogSort[keyof typeof __EnumCatalogSort];
export const __EnumCheckoutDraftInputBillinAddress = {
  Company: 'Company',
  Edit: 'Edit',
  Shipping: 'Shipping'
} as const;

export type __EnumCheckoutDraftInputBillinAddress = typeof __EnumCheckoutDraftInputBillinAddress[keyof typeof __EnumCheckoutDraftInputBillinAddress];
export const __EnumCheckoutQuoteDelivery = {
  Delivery: 'Delivery',
  SelfPickup: 'SelfPickup'
} as const;

export type __EnumCheckoutQuoteDelivery = typeof __EnumCheckoutQuoteDelivery[keyof typeof __EnumCheckoutQuoteDelivery];
export const __EnumCountryContinent = {
  Af: 'Af',
  An: 'An',
  As: 'As',
  Eu: 'Eu',
  Na: 'Na',
  Oc: 'Oc',
  Sa: 'Sa'
} as const;

export type __EnumCountryContinent = typeof __EnumCountryContinent[keyof typeof __EnumCountryContinent];
export const __EnumDeliveryTrackingProvider = {
  Dpd: 'DPD',
  Fedex: 'Fedex',
  LpExpress: 'LpExpress',
  None: 'None',
  Venipak: 'Venipak'
} as const;

export type __EnumDeliveryTrackingProvider = typeof __EnumDeliveryTrackingProvider[keyof typeof __EnumDeliveryTrackingProvider];
export const __EnumDocumentBlockFixed = {
  Auto: 'Auto',
  Fixed: 'Fixed'
} as const;

export type __EnumDocumentBlockFixed = typeof __EnumDocumentBlockFixed[keyof typeof __EnumDocumentBlockFixed];
export const __EnumDocumentBlockProductUi = {
  Card: 'Card',
  Product: 'Product'
} as const;

export type __EnumDocumentBlockProductUi = typeof __EnumDocumentBlockProductUi[keyof typeof __EnumDocumentBlockProductUi];
export const __EnumDocumentBlockTable = {
  Cards: 'Cards',
  Table: 'Table'
} as const;

export type __EnumDocumentBlockTable = typeof __EnumDocumentBlockTable[keyof typeof __EnumDocumentBlockTable];
export const __EnumDocumentBlockTxtAlign = {
  Center: 'Center',
  Left: 'Left',
  Right: 'Right'
} as const;

export type __EnumDocumentBlockTxtAlign = typeof __EnumDocumentBlockTxtAlign[keyof typeof __EnumDocumentBlockTxtAlign];
export const __EnumDocumentBlockTxtType = {
  Bottom: 'Bottom',
  Floating: 'Floating',
  Top: 'Top'
} as const;

export type __EnumDocumentBlockTxtType = typeof __EnumDocumentBlockTxtType[keyof typeof __EnumDocumentBlockTxtType];
export const __EnumDocumentBlockType = {
  Card: 'Card',
  Product: 'Product',
  Table: 'Table'
} as const;

export type __EnumDocumentBlockType = typeof __EnumDocumentBlockType[keyof typeof __EnumDocumentBlockType];
export const __EnumDocumentColorGradientRadialSize = {
  Linear: 'Linear',
  RadialCircle: 'RadialCircle',
  RadialClosestCorner: 'RadialClosestCorner',
  RadialClosestSide: 'RadialClosestSide',
  RadialEllipse: 'RadialEllipse',
  RadialFarthestCorner: 'RadialFarthestCorner',
  RadialFarthestSide: 'RadialFarthestSide'
} as const;

export type __EnumDocumentColorGradientRadialSize = typeof __EnumDocumentColorGradientRadialSize[keyof typeof __EnumDocumentColorGradientRadialSize];
export const __EnumDocumentLinkUi = {
  Arrow: 'Arrow',
  ArrowText: 'ArrowText',
  Plain: 'Plain'
} as const;

export type __EnumDocumentLinkUi = typeof __EnumDocumentLinkUi[keyof typeof __EnumDocumentLinkUi];
export const __EnumDocumentTxtFloatAlign = {
  Center: 'Center',
  End: 'End',
  Start: 'Start'
} as const;

export type __EnumDocumentTxtFloatAlign = typeof __EnumDocumentTxtFloatAlign[keyof typeof __EnumDocumentTxtFloatAlign];
export const __EnumDocumentWidthUnit = {
  Auto: 'Auto',
  Percent: 'Percent',
  Px: 'Px'
} as const;

export type __EnumDocumentWidthUnit = typeof __EnumDocumentWidthUnit[keyof typeof __EnumDocumentWidthUnit];
export const __EnumDuration = {
  Day: 'Day',
  Month: 'Month',
  Year: 'Year'
} as const;

export type __EnumDuration = typeof __EnumDuration[keyof typeof __EnumDuration];
export const __EnumIncoterms = {
  Cip: 'CIP',
  Cpt: 'CPT',
  Dap: 'DAP',
  Ddp: 'DDP',
  Dpu: 'DPU',
  Exw: 'EXW',
  Fca: 'FCA'
} as const;

export type __EnumIncoterms = typeof __EnumIncoterms[keyof typeof __EnumIncoterms];
export const __EnumInputSellerTextHelp = {
  Rewrite: 'Rewrite',
  ToEn: 'ToEn',
  ToLt: 'ToLt'
} as const;

export type __EnumInputSellerTextHelp = typeof __EnumInputSellerTextHelp[keyof typeof __EnumInputSellerTextHelp];
export const __EnumLockerProvider = {
  Dpd: 'Dpd',
  LpExpress: 'LpExpress',
  Omniva: 'Omniva',
  Venipak: 'Venipak'
} as const;

export type __EnumLockerProvider = typeof __EnumLockerProvider[keyof typeof __EnumLockerProvider];
export const __EnumOrdersPaginationOptions = {
  All: 'All',
  New: 'New',
  Packing: 'Packing'
} as const;

export type __EnumOrdersPaginationOptions = typeof __EnumOrdersPaginationOptions[keyof typeof __EnumOrdersPaginationOptions];
export const __EnumPaginationGet = {
  Autocomplete: 'Autocomplete',
  FilterValues: 'FilterValues',
  Filters: 'Filters',
  Items: 'Items',
  Sorting: 'Sorting'
} as const;

export type __EnumPaginationGet = typeof __EnumPaginationGet[keyof typeof __EnumPaginationGet];
export const __EnumPaymentPaymentModification = {
  Done: 'Done',
  New: 'New'
} as const;

export type __EnumPaymentPaymentModification = typeof __EnumPaymentPaymentModification[keyof typeof __EnumPaymentPaymentModification];
export const __EnumPaymentsView = {
  All: 'All',
  OpenAccount: 'OpenAccount',
  Transfers: 'Transfers'
} as const;

export type __EnumPaymentsView = typeof __EnumPaymentsView[keyof typeof __EnumPaymentsView];
export const __EnumPayoutStatus = {
  Canceled: 'Canceled',
  Completed: 'Completed',
  Pending: 'Pending'
} as const;

export type __EnumPayoutStatus = typeof __EnumPayoutStatus[keyof typeof __EnumPayoutStatus];
export const __EnumPostStatus = {
  Disabled: 'Disabled',
  Pending: 'Pending',
  Published: 'Published'
} as const;

export type __EnumPostStatus = typeof __EnumPostStatus[keyof typeof __EnumPostStatus];
export const __EnumPriceEntry = {
  B2b: 'B2b',
  Bundle: 'Bundle',
  Discount: 'Discount'
} as const;

export type __EnumPriceEntry = typeof __EnumPriceEntry[keyof typeof __EnumPriceEntry];
export const __EnumProductQtyUnit = {
  Meter: 'Meter',
  Unit: 'Unit'
} as const;

export type __EnumProductQtyUnit = typeof __EnumProductQtyUnit[keyof typeof __EnumProductQtyUnit];
export const __EnumProductVolumeCategory = {
  Dense: 'Dense',
  Lofty: 'Lofty',
  Pillow: 'Pillow',
  Standard: 'Standard',
  UltraLoft: 'UltraLoft'
} as const;

export type __EnumProductVolumeCategory = typeof __EnumProductVolumeCategory[keyof typeof __EnumProductVolumeCategory];
export const __EnumSearchCatalogSellerBreadcrums = {
  Article: 'Article',
  CatalogUi: 'CatalogUi',
  Department: 'Department'
} as const;

export type __EnumSearchCatalogSellerBreadcrums = typeof __EnumSearchCatalogSellerBreadcrums[keyof typeof __EnumSearchCatalogSellerBreadcrums];
export const __EnumSellerBusinessStatus = {
  Active: 'Active',
  Created: 'Created',
  Disabled: 'Disabled',
  Invited: 'Invited'
} as const;

export type __EnumSellerBusinessStatus = typeof __EnumSellerBusinessStatus[keyof typeof __EnumSellerBusinessStatus];
export const __EnumSellerCheckoutType = {
  Checkout: 'Checkout',
  Quote: 'Quote'
} as const;

export type __EnumSellerCheckoutType = typeof __EnumSellerCheckoutType[keyof typeof __EnumSellerCheckoutType];
export const __EnumSellerDeliveryPricing = {
  Fedex: 'Fedex',
  Free: 'Free',
  Quote: 'Quote',
  Table: 'Table'
} as const;

export type __EnumSellerDeliveryPricing = typeof __EnumSellerDeliveryPricing[keyof typeof __EnumSellerDeliveryPricing];
export const __EnumSellerDiscountStatus = {
  Active: 'Active',
  Deleted: 'Deleted',
  Disabled: 'Disabled',
  Pending: 'Pending'
} as const;

export type __EnumSellerDiscountStatus = typeof __EnumSellerDiscountStatus[keyof typeof __EnumSellerDiscountStatus];
export const __EnumSellerFind = {
  Admin: 'Admin',
  Images: 'Images'
} as const;

export type __EnumSellerFind = typeof __EnumSellerFind[keyof typeof __EnumSellerFind];
export const __EnumSellerProfileType = {
  Assistant: 'Assistant',
  Author: 'Author',
  Model: 'Model',
  User: 'User'
} as const;

export type __EnumSellerProfileType = typeof __EnumSellerProfileType[keyof typeof __EnumSellerProfileType];
export const __EnumSellerReturnType = {
  Accepted: 'Accepted',
  Canceled: 'Canceled',
  CanceledByBuyer: 'CanceledByBuyer',
  Created: 'Created',
  Received: 'Received',
  ShippedByBuyer: 'ShippedByBuyer'
} as const;

export type __EnumSellerReturnType = typeof __EnumSellerReturnType[keyof typeof __EnumSellerReturnType];
export const __EnumSellerShipmentTrackStatus = {
  BadTrackingNumber: 'BadTrackingNumber',
  Delivered: 'Delivered',
  Exception: 'Exception',
  Expired: 'Expired',
  FailedAttempt: 'FailedAttempt',
  InTransit: 'InTransit',
  OutForDelivery: 'OutForDelivery',
  Pending: 'Pending'
} as const;

export type __EnumSellerShipmentTrackStatus = typeof __EnumSellerShipmentTrackStatus[keyof typeof __EnumSellerShipmentTrackStatus];
export const __EnumSellerTaxStrategy = {
  FixedTaxfull: 'FixedTaxfull',
  FixedTaxless: 'FixedTaxless'
} as const;

export type __EnumSellerTaxStrategy = typeof __EnumSellerTaxStrategy[keyof typeof __EnumSellerTaxStrategy];
export const __EnumSeoProblemTarget = {
  CatalogUi: 'CatalogUi',
  Department: 'Department',
  Product: 'Product'
} as const;

export type __EnumSeoProblemTarget = typeof __EnumSeoProblemTarget[keyof typeof __EnumSeoProblemTarget];
export const __EnumTrackingType = {
  Manual: 'Manual',
  Number: 'Number',
  Off: 'Off'
} as const;

export type __EnumTrackingType = typeof __EnumTrackingType[keyof typeof __EnumTrackingType];
export const __EnumUserType = {
  Admin: 'Admin',
  Buyer: 'Buyer'
} as const;

export type __EnumUserType = typeof __EnumUserType[keyof typeof __EnumUserType];
export type __FileUploadUrl = {
  file: __SellerFile;
  fileUrl: Scalars['String']['output'];
  message: Scalars['String']['output'];
  private: Scalars['Boolean']['output'];
  success: Scalars['Boolean']['output'];
  uploadHeadersJson: Scalars['String']['output'];
  uploadUrl: Scalars['String']['output'];
};

export const __FilterType = {
  Boolean: 'Boolean',
  ChoiceOne: 'ChoiceOne',
  Choices: 'Choices',
  Number: 'Number',
  Query: 'Query'
} as const;

export type __FilterType = typeof __FilterType[keyof typeof __FilterType];
export type __GetFiltersAsyncInput = {
  key?: InputMaybe<Scalars['String']['input']>;
};

export type __Giftcard = {
  _id: Scalars['ObjectId']['output'];
  _paymentInvoice?: Maybe<__PaymentInvoiceDoc>;
  _uiReceiver?: Maybe<__GiftcardUiReceiver>;
  _uiSender?: Maybe<__GiftcardUiSender>;
  amount: Scalars['Int']['output'];
  buyerFullname: Scalars['String']['output'];
  code: Scalars['String']['output'];
  createdAt: Scalars['MongoDate']['output'];
  emailSendAt?: Maybe<Scalars['MongoDate']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  paymentId: Scalars['ObjectId']['output'];
  receiverEmail: Scalars['String']['output'];
  receiverFullname: Scalars['String']['output'];
  sellerId?: Maybe<Scalars['ObjectId']['output']>;
  userId: Scalars['ObjectId']['output'];
};

export type __GiftcardPublicHistory = {
  amount: __Price2;
  at: Scalars['MongoDate']['output'];
};

export type __GiftcardUiReceiver = {
  _id: Scalars['ObjectId']['output'];
  amount: Scalars['Int']['output'];
  amountAvailable: Scalars['Float']['output'];
  buyerFullname: Scalars['String']['output'];
  code: Scalars['String']['output'];
  expiry: Scalars['MongoDate']['output'];
  history: Array<__GiftcardPublicHistory>;
  isActive: Scalars['Boolean']['output'];
  message?: Maybe<Scalars['String']['output']>;
  payment: __PaymentSimple;
  receiverFullname?: Maybe<Scalars['String']['output']>;
};

export type __GiftcardUiSender = {
  _id: Scalars['ObjectId']['output'];
  amount: Scalars['Int']['output'];
  amountAvailable: Scalars['Float']['output'];
  buyerFullname: Scalars['String']['output'];
  code: Scalars['String']['output'];
  emailSendAt?: Maybe<Scalars['MongoDate']['output']>;
  emailWasSendAt?: Maybe<Scalars['MongoDate']['output']>;
  expiry: Scalars['MongoDate']['output'];
  history: Array<__GiftcardPublicHistory>;
  isActive: Scalars['Boolean']['output'];
  message?: Maybe<Scalars['String']['output']>;
  payment: __PaymentSimple;
  receiverEmail: Scalars['String']['output'];
  receiverFullname: Scalars['String']['output'];
};

export type __Giftcards = __PaginatedResults & {
  info?: Maybe<__PaginationInfo>;
  items?: Maybe<Array<__Giftcard>>;
};

export type __GodActionsResponse = __MutationResponeMsg & {
  actionDone?: Maybe<Scalars['String']['output']>;
  actions?: Maybe<Array<Scalars['String']['output']>>;
  isListingsUpdated?: Maybe<Scalars['Boolean']['output']>;
  loadSystem?: Maybe<__SystemUploadProducts>;
  receivers?: Maybe<__GodNewsletterSetReceivers>;
  responseInfo: __ResponseInfo;
  user?: Maybe<__User>;
  userDeleted?: Maybe<Scalars['Boolean']['output']>;
};

export type __GodCreateAdminInput = {
  buyerId?: InputMaybe<__InputId>;
  createAdmin?: InputMaybe<__InputEmail>;
  password: Scalars['String']['input'];
};

export type __GodNewsletterSetReceivers = {
  emails?: Maybe<Array<Scalars['String']['output']>>;
};

export type __GoogleProductCategory = {
  id: Scalars['String']['output'];
  path: Array<Scalars['String']['output']>;
  txt: Scalars['String']['output'];
};

export type __GoogleProductCategoryList = {
  items?: Maybe<Array<__GoogleProductCategory>>;
};

export type __Image = {
  _id: Scalars['ObjectId']['output'];
  alt?: Maybe<__Text>;
  aspect?: Maybe<__ImageListingAspect>;
  contentType?: Maybe<Scalars['String']['output']>;
  filename?: Maybe<Scalars['String']['output']>;
  format?: Maybe<Scalars['String']['output']>;
  height?: Maybe<Scalars['Int']['output']>;
  hsla?: Maybe<__DocumentColorHsla>;
  image2?: Maybe<__ImageNodeItem>;
  isVideo?: Maybe<Scalars['Boolean']['output']>;
  original: Scalars['String']['output'];
  processingStatus?: Maybe<Scalars['String']['output']>;
  sellerId?: Maybe<Scalars['ObjectId']['output']>;
  tags?: Maybe<Array<Scalars['String']['output']>>;
  urlBase?: Maybe<Scalars['String']['output']>;
  videoHls?: Maybe<Scalars['String']['output']>;
  videoMeta?: Maybe<__MediaMeta>;
  videoThumbnail?: Maybe<Scalars['String']['output']>;
  width?: Maybe<Scalars['Int']['output']>;
};

export type __ImageInput = {
  _id: Scalars['ObjectId']['input'];
};

export type __ImageInternalKeyed = {
  image: __Image;
  key: Scalars['String']['output'];
};

export type __ImageListingAspect = {
  x: Scalars['Int']['output'];
  y: Scalars['Int']['output'];
};

export type __ImageNodeItem = {
  _id?: Maybe<Scalars['ObjectId']['output']>;
  alt?: Maybe<Scalars['String']['output']>;
  aspect?: Maybe<__ImageListingAspect>;
  audio?: Maybe<Scalars['Boolean']['output']>;
  error: Scalars['Boolean']['output'];
  fallbackUrl?: Maybe<Scalars['String']['output']>;
  height?: Maybe<Scalars['Int']['output']>;
  hsla?: Maybe<__DocumentColorHsla>;
  img?: Maybe<Scalars['String']['output']>;
  isVideo?: Maybe<Scalars['Boolean']['output']>;
  noProxy?: Maybe<Scalars['Boolean']['output']>;
  processing: Scalars['Boolean']['output'];
  /** @deprecated Field no longer supported */
  render?: Maybe<__ImageRender>;
  type?: Maybe<Scalars['String']['output']>;
  uploadDate?: Maybe<Scalars['MongoDate']['output']>;
  url?: Maybe<Scalars['String']['output']>;
  video?: Maybe<Scalars['String']['output']>;
  videoHls?: Maybe<Scalars['String']['output']>;
  videoThumbnail?: Maybe<Scalars['String']['output']>;
  width?: Maybe<Scalars['Int']['output']>;
};

export const __ImageProductType = {
  Main: 'Main',
  Outfit: 'Outfit',
  Product: 'Product'
} as const;

export type __ImageProductType = typeof __ImageProductType[keyof typeof __ImageProductType];
export type __ImageRender = {
  aspect?: Maybe<__ImageListingAspect>;
  fallbackUrl?: Maybe<Scalars['String']['output']>;
  height?: Maybe<Scalars['Int']['output']>;
  hsla?: Maybe<__DocumentColorHsla>;
  url?: Maybe<Scalars['String']['output']>;
  width?: Maybe<Scalars['Int']['output']>;
};

export type __ImageTagged = {
  img: __Image;
  ratio?: Maybe<__ImageTaggedRatio>;
  tags?: Maybe<Array<__DocumentBlockTag>>;
  type?: Maybe<__ImageProductType>;
};

export const __ImageTaggedRatio = {
  Cover: 'Cover',
  None: 'None',
  R2x3: 'R2x3',
  R4x5: 'R4x5',
  R5x2: 'R5x2',
  R16x9: 'R16x9',
  Square: 'Square'
} as const;

export type __ImageTaggedRatio = typeof __ImageTaggedRatio[keyof typeof __ImageTaggedRatio];
export type __ImageUploadFileResponse = __MutationResponeMsg & {
  data?: Maybe<__FileUploadUrl>;
  deleted?: Maybe<Scalars['Boolean']['output']>;
  downloadUrl?: Maybe<Scalars['String']['output']>;
  files?: Maybe<Array<__SellerFile>>;
  responseInfo: __ResponseInfo;
};

export type __ImageUploadUrl = {
  fileUrl: Scalars['String']['output'];
  image: __Image;
  message: Scalars['String']['output'];
  success: Scalars['Boolean']['output'];
  uploadHeadersJson: Scalars['String']['output'];
  uploadUrl: Scalars['String']['output'];
};

export type __ImageUploadUrlInput = {
  filename: Scalars['String']['input'];
  type: Scalars['String']['input'];
};

export type __ImageUploadUrlResponse = __MutationResponeMsg & {
  data?: Maybe<__ImageUploadUrl>;
  deleted?: Maybe<Scalars['Boolean']['output']>;
  images?: Maybe<Array<__Image>>;
  responseInfo: __ResponseInfo;
};

export type __InpuAddressValues = {
  apartment?: InputMaybe<Scalars['String']['input']>;
  city: Scalars['String']['input'];
  postCode: Scalars['String']['input'];
  state?: InputMaybe<Scalars['String']['input']>;
  street: Scalars['String']['input'];
  type: __EnumAddressType;
};

export type __InputAddressAutocomplete = {
  address: Scalars['String']['input'];
  iso2: Scalars['String']['input'];
  sessionToken: Scalars['String']['input'];
};

export type __InputAddressAutocompleteDetails = {
  placeId: Scalars['String']['input'];
  sessionToken: Scalars['String']['input'];
};

export type __InputAdminAuth = {
  login?: InputMaybe<__SignInInput>;
  logout?: InputMaybe<__InputBool>;
  register?: InputMaybe<__InputAdminAuthRegister>;
  registerCodeGet?: InputMaybe<__InputBuyerAuthRegisterCodeGet>;
  registerTokenCheck?: InputMaybe<__InputString>;
};

export type __InputAdminAuthRegister = {
  register: __InputBuyerAuthRegister;
  token: Scalars['String']['input'];
};

export type __InputAdminBuyerMutation = {
  block?: InputMaybe<__InputBool>;
  buyerType?: InputMaybe<__EnumBuyerType>;
  sellerId: Scalars['ObjectId']['input'];
  userId?: InputMaybe<Scalars['ObjectId']['input']>;
};

export type __InputAdminSubs = {
  sellerId: Scalars['ObjectId']['input'];
  set: Array<__InputAdminSubsActivate>;
};

export type __InputAdminSubsActivate = {
  isActive: Scalars['Boolean']['input'];
  type: __EnumAdminSubsType;
};

export type __InputArticlesFilter = {
  cursorNext?: InputMaybe<Scalars['ObjectId']['input']>;
  sellerId?: InputMaybe<Scalars['ObjectId']['input']>;
  size?: InputMaybe<Scalars['Int']['input']>;
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type __InputAuthCodeRef = {
  _id: Scalars['ObjectId']['input'];
  codeRefNumber: Scalars['Int']['input'];
};

export type __InputBool = {
  value: Scalars['Boolean']['input'];
};

export type __InputBundleEntries = {
  entries: Array<__InputPriceVariantBundle>;
  percentValue: Scalars['Int']['input'];
};

export type __InputBuyerAddress = {
  create?: InputMaybe<__InputBuyerAddressCreate>;
  delete?: InputMaybe<__InputId>;
  invoiceCreate?: InputMaybe<__InputBuyerInvoice>;
  invoiceRemove?: InputMaybe<__InputId>;
  invoiceUpdate?: InputMaybe<__InputBuyerInvoice>;
  lockerAdd?: InputMaybe<__InputIdString>;
  lockerRemove?: InputMaybe<__InputIdString>;
  setDefaultAddress?: InputMaybe<__InputId>;
  update?: InputMaybe<__InputBuyerAddressUpdate>;
};

export type __InputBuyerAddressCountry = {
  iso2: Scalars['String']['input'];
};

export type __InputBuyerAddressCreate = {
  address: __InputBuyerAddressValues;
  setAsDefaultAddress: Scalars['Boolean']['input'];
};

export type __InputBuyerAddressUpdate = {
  _id: Scalars['ObjectId']['input'];
  address: __InputBuyerAddressValues;
};

export type __InputBuyerAddressValues = {
  address: __InpuAddressValues;
  country: __InputBuyerAddressCountry;
  deliveryInstruction?: InputMaybe<Scalars['String']['input']>;
  lastname: Scalars['String']['input'];
  name: Scalars['String']['input'];
  tel: Scalars['String']['input'];
};

export type __InputBuyerAuth = {
  _checkout?: InputMaybe<__InputBuyerAuthCheckout>;
  authCodeResend?: InputMaybe<__InputAuthCodeRef>;
  authEmailValid?: InputMaybe<__InputEmail>;
  emailStatus?: InputMaybe<__InputEmail>;
  forgotPasswordGetCode?: InputMaybe<__InputCodeEmail>;
  forgotPasswordUseCode?: InputMaybe<__InputBuyerAuthForgotUseCode>;
  login?: InputMaybe<__SignInInput>;
  loginCodeGet?: InputMaybe<__InputCodeEmail>;
  loginCodeUse?: InputMaybe<__InputLoginWithCode2>;
  loginFacebook?: InputMaybe<__InputBuyerAuthFacebook>;
  loginGoogle?: InputMaybe<__InputBuyerAuthGoogle>;
  logout?: InputMaybe<__InputBool>;
  oauthGoogle?: InputMaybe<__InputBuyerOauthGoogle>;
  register?: InputMaybe<__InputBuyerAuthRegister>;
  registerCodeGet?: InputMaybe<__InputBuyerAuthRegisterCodeGet>;
  verifyUrlCode?: InputMaybe<__InputBuyerAuthVerifyUrlCode>;
  widget: Scalars['String']['input'];
};

export type __InputBuyerAuthCheckout = {
  transferCheckout: Scalars['ObjectId']['input'];
};

export type __InputBuyerAuthFacebook = {
  accessToken: Scalars['String']['input'];
};

export type __InputBuyerAuthForgotUseCode = {
  codeFromEmail: Scalars['String']['input'];
  email: Scalars['String']['input'];
  passwordNew: Scalars['String']['input'];
};

export type __InputBuyerAuthGoogle = {
  jwt: Scalars['String']['input'];
};

export type __InputBuyerAuthRegister = {
  codeFromEmail: Scalars['String']['input'];
  email: Scalars['String']['input'];
};

export type __InputBuyerAuthRegisterCodeGet = {
  fullurl?: InputMaybe<Scalars['String']['input']>;
  values: __InputBuyerAuthRegisterValues;
};

export type __InputBuyerAuthRegisterValues = {
  email: Scalars['String']['input'];
  lastname: Scalars['String']['input'];
  name: Scalars['String']['input'];
  password: Scalars['String']['input'];
};

export type __InputBuyerAuthVerifyUrlCode = {
  urlCode: Scalars['String']['input'];
};

export type __InputBuyerBoard = {
  boardCreate?: InputMaybe<__UserProductBoardInputCreate>;
  boardDelete?: InputMaybe<__InputId>;
  boardUpdate?: InputMaybe<__UserProductBoardInputUpdate>;
  productAdd?: InputMaybe<__UserProductBoardInputProduct>;
  productRemove?: InputMaybe<__UserProductBoardInputProduct>;
};

export type __InputBuyerBoardCursor = {
  cursorNext?: InputMaybe<Scalars['String']['input']>;
  size: Scalars['Int']['input'];
};

export type __InputBuyerBundleProducts = {
  bundleId: Scalars['ObjectId']['input'];
};

export type __InputBuyerBundleProductsOne = {
  input: __InputBuyerBundleProducts;
  variantId: Scalars['ObjectId']['input'];
};

export type __InputBuyerBundles = {
  cursorNext?: InputMaybe<Scalars['String']['input']>;
  groupId?: InputMaybe<Scalars['ObjectId']['input']>;
  size?: InputMaybe<Scalars['Int']['input']>;
};

export type __InputBuyerBusiness = {
  businessUpdate?: InputMaybe<__InputBuyerBusinessUpdate>;
  requestB2b?: InputMaybe<__InputBuyerBusinessRequest>;
  requestB2bRemove?: InputMaybe<__InputBool>;
  sellerId: Scalars['ObjectId']['input'];
};

export type __InputBuyerBusinessRequest = {
  invoiceId: Scalars['ObjectId']['input'];
  message: Scalars['String']['input'];
  website?: InputMaybe<Scalars['String']['input']>;
};

export type __InputBuyerBusinessUpdate = {
  website?: InputMaybe<Scalars['String']['input']>;
};

export type __InputBuyerCart = {
  add?: InputMaybe<Array<__InputBuyerCartAdd>>;
  set?: InputMaybe<Array<__InputBuyerCartAdd>>;
};

export type __InputBuyerCartAdd = {
  productId: Scalars['ObjectId']['input'];
  qty: Scalars['Float']['input'];
};

export type __InputBuyerEverypayCard = {
  createEnd?: InputMaybe<__InputBuyerEverypayCardCreateEnd>;
  createStart?: InputMaybe<__InputBuyerEverypayCardCreateStart>;
  remove?: InputMaybe<__InputId>;
};

export type __InputBuyerEverypayCardCreateEnd = {
  referenceId: Scalars['String']['input'];
};

export type __InputBuyerEverypayCardCreateStart = {
  start: Scalars['Boolean']['input'];
};

export type __InputBuyerEverypayCards = {
  checkout?: InputMaybe<Scalars['Boolean']['input']>;
  input?: InputMaybe<__InputPagination>;
};

export type __InputBuyerGiftcard = {
  create?: InputMaybe<__InputBuyerGiftcardCreate>;
};

export type __InputBuyerGiftcardCreate = {
  amount: Scalars['Int']['input'];
  buyerFullname: Scalars['String']['input'];
  emailSendAt?: InputMaybe<__InputDate>;
  isActive: Scalars['Boolean']['input'];
  message?: InputMaybe<Scalars['String']['input']>;
  paymentType: __PaymentType;
  receiverEmail: Scalars['String']['input'];
  receiverFullname: Scalars['String']['input'];
  sellerId?: InputMaybe<Scalars['ObjectId']['input']>;
};

export type __InputBuyerImage = {
  upload?: InputMaybe<__ImageUploadUrlInput>;
  uploadDone?: InputMaybe<__InputObjectIds>;
};

export type __InputBuyerInformation = {
  defaultCountrySet?: InputMaybe<__InputBuyerAddressCountry>;
  deleteAccount?: InputMaybe<__InputCode>;
  deleteAccountGetCode?: InputMaybe<__InputCodeEmail>;
  emailChange1NewEmailSendCode?: InputMaybe<__InputCodeEmail>;
  emailChange2NewEmailConfirm?: InputMaybe<__InputBuyerInformationEmailConfirm>;
  emailChange3SendCode?: InputMaybe<__InputCodeEmail>;
  emailChange4Confirm?: InputMaybe<__InputBuyerInformationEmailConfirm>;
  hasPassword?: InputMaybe<__InputBool>;
  informationSet?: InputMaybe<__InputBuyerInformationInfo>;
  langSet?: InputMaybe<__UserLanguageUpdateInput>;
  passwordCreate1GetCode?: InputMaybe<__InputBool>;
  passwordCreate2Confirm?: InputMaybe<__InputPasswordCreate>;
  passwordSet?: InputMaybe<__InputBuyerInformationPassword>;
  profileContactsSet?: InputMaybe<__InputSellerProfilesContacts>;
  profileCreate?: InputMaybe<__InputBuyerProfileCreate>;
  profileDelete?: InputMaybe<__InputBool>;
  profileUpdate?: InputMaybe<__InputBuyerProfileUpdate>;
};

export type __InputBuyerInformationEmailConfirm = {
  code: Scalars['String']['input'];
  email: Scalars['String']['input'];
};

export type __InputBuyerInformationInfo = {
  birthdate?: InputMaybe<__InputDate>;
  gender?: InputMaybe<__EnumBuyerGender>;
  lastname: Scalars['String']['input'];
  name: Scalars['String']['input'];
};

export type __InputBuyerInformationPassword = {
  new: __InputPassword;
  old: __InputPassword;
};

export type __InputBuyerInvoice = {
  _id?: InputMaybe<Scalars['ObjectId']['input']>;
  company?: InputMaybe<__InputBuyerInvoiceCompany>;
  none: Scalars['Boolean']['input'];
  personal?: InputMaybe<__InputBuyerInvoicePersonal>;
};

export type __InputBuyerInvoiceCompany = {
  address: __InpuAddressValues;
  companyCode: Scalars['String']['input'];
  companyName: Scalars['String']['input'];
  country: __InputBuyerAddressCountry;
  goodsForEuCommercialUse: Scalars['Boolean']['input'];
  tel?: InputMaybe<Scalars['String']['input']>;
  vatCode?: InputMaybe<Scalars['String']['input']>;
};

export type __InputBuyerInvoicePersonal = {
  country: __InputBuyerAddressCountry;
  goodsForEuCommercialUse: Scalars['Boolean']['input'];
  lastname: Scalars['String']['input'];
  message?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  vatCode?: InputMaybe<Scalars['String']['input']>;
};

export type __InputBuyerInvoiceUpdate = {
  _id: Scalars['ObjectId']['input'];
  address: __InputBuyerAddressValues;
};

export type __InputBuyerLikes = {
  toggleLike?: InputMaybe<__InputBuyerLikesToggle>;
};

export type __InputBuyerLikesToggle = {
  docId: Scalars['ObjectId']['input'];
  type: __BuyerLikeType;
};

export type __InputBuyerNotificationCursor = {
  cursorNext?: InputMaybe<Scalars['String']['input']>;
  productIds?: InputMaybe<Array<Scalars['ObjectId']['input']>>;
  size?: InputMaybe<Scalars['Int']['input']>;
};

export type __InputBuyerNotify = {
  removeProductId?: InputMaybe<__InputId>;
  set?: InputMaybe<__InputBuyerNotifyProductPriceDrop>;
};

export type __InputBuyerNotifyProductPriceDrop = {
  onInStock: Scalars['Boolean']['input'];
  onPriceDrop?: InputMaybe<Scalars['Float']['input']>;
  productId: Scalars['ObjectId']['input'];
  type: __EnumBuyerNotifyDoc;
};

export type __InputBuyerOauthGoogle = {
  code: Scalars['String']['input'];
};

export type __InputBuyerOrderProductsCursor = {
  cursorNext?: InputMaybe<Scalars['String']['input']>;
  find?: InputMaybe<__BuyerOrderProductsFind>;
  size?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<__BuyerOrderProductsSort>;
};

export type __InputBuyerPay = {
  billingAddress?: InputMaybe<__CheckoutDraftInputBillinAddress>;
  everypay?: InputMaybe<__InputBuyerPaymentPayInvoiceEverypay>;
  log?: InputMaybe<Scalars['String']['input']>;
  paypal?: InputMaybe<__InputBuyerPaymentPayInvoicePaypal>;
  type: __PaymentType;
};

export type __InputBuyerPayment = {
  invoiceCancel?: InputMaybe<__InputId>;
  order?: InputMaybe<__InputBuyerPaymentOrder>;
  payInvoice?: InputMaybe<__InputBuyerPaymentPayInvoice>;
  payStart?: InputMaybe<__InputId>;
  paymentAfter?: InputMaybe<__InputBuyerPaymentAfter>;
  paymentCancel?: InputMaybe<__InputId>;
  paymentTransferMade?: InputMaybe<__InputId>;
  requestModification?: InputMaybe<__InputBuyerPaymentModification>;
};

export type __InputBuyerPaymentAfter = {
  checkEverypay?: InputMaybe<__InputBool>;
  payId?: InputMaybe<Scalars['ObjectId']['input']>;
  paypal?: InputMaybe<__InputBuyerPaymentAfterPaypal>;
  paysera?: InputMaybe<__InputBuyerPaymentAfterPaysera>;
  resetCart?: InputMaybe<Scalars['Boolean']['input']>;
};

export type __InputBuyerPaymentAfterPaypal = {
  payWithPayPal: Scalars['Boolean']['input'];
  paypalOrderId: Scalars['String']['input'];
};

export type __InputBuyerPaymentAfterPaysera = {
  data: Scalars['String']['input'];
  ss1: Scalars['String']['input'];
  ss2: Scalars['String']['input'];
};

export type __InputBuyerPaymentEmailChange = {
  newEmail: Scalars['String']['input'];
};

export type __InputBuyerPaymentModification = {
  paymentId: Scalars['ObjectId']['input'];
  text: Scalars['String']['input'];
};

export type __InputBuyerPaymentOrder = {
  shippingCheck?: InputMaybe<__InputId>;
};

export type __InputBuyerPaymentPayInvoice = {
  pay: __InputBuyerPay;
  paymentId: Scalars['ObjectId']['input'];
};

export type __InputBuyerPaymentPayInvoiceEverypay = {
  mobilePayments: Scalars['Boolean']['input'];
  payWithCardId?: InputMaybe<Scalars['ObjectId']['input']>;
  saveCard: Scalars['Boolean']['input'];
};

export type __InputBuyerPaymentPayInvoicePaypal = {
  authorize: Scalars['Boolean']['input'];
};

export type __InputBuyerPost = {
  commentCreate?: InputMaybe<__InputBuyerPostCommentCreate>;
  commentUpdate?: InputMaybe<__InputBuyerPostUpdate>;
  deletePost?: InputMaybe<__InputId>;
  postSubscribe?: InputMaybe<__InputBuyerPostSubscribe>;
  questionCreate?: InputMaybe<__InputBuyerPostQuestionCreate>;
  questionUpdate?: InputMaybe<__InputBuyerPostUpdate>;
  replyCreate?: InputMaybe<__InputBuyerPostReplyCreate>;
  replyUpdate?: InputMaybe<__InputBuyerPostUpdate>;
  report?: InputMaybe<__InputBuyerPostReport>;
  reviewCreate?: InputMaybe<__InputBuyerPostReviewCreate>;
  reviewCreateQuick?: InputMaybe<__InputBuyerPostReviewCreateQuick>;
  reviewUpdate?: InputMaybe<__InputBuyerPostReviewUpdate>;
};

export type __InputBuyerPostBase = {
  comment: Scalars['String']['input'];
  emailNotificationsEnabled: Scalars['Boolean']['input'];
  handle: __InputBuyerPostHandle;
  images: Array<__ImageInput>;
};

export type __InputBuyerPostBase2 = {
  comment: Scalars['String']['input'];
  handle: __InputBuyerPostHandle;
  images: Array<__ImageInput>;
};

export type __InputBuyerPostCommentCreate = {
  articleId: Scalars['ObjectId']['input'];
  base2: __InputBuyerPostBase2;
};

export type __InputBuyerPostHandle = {
  publicName?: InputMaybe<Scalars['String']['input']>;
};

export type __InputBuyerPostQuestionCreate = {
  base: __InputBuyerPostBase;
  productId: Scalars['ObjectId']['input'];
};

export type __InputBuyerPostReplyCreate = {
  base2: __InputBuyerPostBase2;
  toPostId: Scalars['ObjectId']['input'];
};

export type __InputBuyerPostReport = {
  postId: Scalars['String']['input'];
  reason: Scalars['String']['input'];
};

export type __InputBuyerPostReviewCreate = {
  base: __InputBuyerPostBase;
  productId: Scalars['ObjectId']['input'];
  ratings: __InputBuyerPostReviewRating;
};

export type __InputBuyerPostReviewCreateQuick = {
  productId: Scalars['ObjectId']['input'];
  rating: Scalars['Int']['input'];
};

export type __InputBuyerPostReviewRating = {
  rating: Scalars['Int']['input'];
  ratingDelivery: Scalars['Int']['input'];
  ratingFit: Scalars['Int']['input'];
  ratingMatch: Scalars['Int']['input'];
  ratingQuality: Scalars['Int']['input'];
  ratingRecomend: Scalars['Int']['input'];
  ratingSeller: Scalars['Int']['input'];
};

export type __InputBuyerPostReviewUpdate = {
  base: __InputBuyerPostBase;
  ratings: __InputBuyerPostReviewRating;
  reviewId: Scalars['ObjectId']['input'];
};

export type __InputBuyerPostSubscribe = {
  emailNotificationsEnabled: Scalars['Boolean']['input'];
  postId: Scalars['ObjectId']['input'];
};

export type __InputBuyerPostUpdate = {
  base: __InputBuyerPostBase;
  postId: Scalars['ObjectId']['input'];
};

export type __InputBuyerPosts = {
  pag?: InputMaybe<__InputPagination>;
  type: __SellerPostViewType;
};

export type __InputBuyerProductHistory = {
  add?: InputMaybe<__InputId>;
  remove?: InputMaybe<__InputId>;
};

export type __InputBuyerProductHistoryCursor = {
  cursorNext?: InputMaybe<Scalars['ObjectId']['input']>;
  size?: InputMaybe<Scalars['Int']['input']>;
};

export type __InputBuyerProfileCreate = {
  handle: Scalars['String']['input'];
  values: __InputSellerProfilesValues;
};

export type __InputBuyerProfileUpdate = {
  profileId: Scalars['ObjectId']['input'];
  values: __InputSellerProfilesValues;
};

export type __InputBuyerReturn = {
  cancel?: InputMaybe<__InputId>;
  create?: InputMaybe<__InputBuyerReturnCreate>;
  paymentReturn?: InputMaybe<__InputBuyerReturnPaymentUpdate>;
  shipped?: InputMaybe<__InputBuyerReturnTracking>;
  updateTracking?: InputMaybe<__InputBuyerReturnTracking>;
};

export type __InputBuyerReturnCreate = {
  orderId: Scalars['ObjectId']['input'];
  paymentReturn: __InputSellerPayoutBank;
  products: Array<__InputBuyerReturnProduct>;
};

export type __InputBuyerReturnPaymentUpdate = {
  returnId: Scalars['ObjectId']['input'];
  value: __InputSellerPayoutBank;
};

export type __InputBuyerReturnProduct = {
  comment?: InputMaybe<Scalars['String']['input']>;
  productId: Scalars['ObjectId']['input'];
  qty: Scalars['Float']['input'];
  reason: __InputSellerReturnReason;
};

export type __InputBuyerReturnTracking = {
  returnId: Scalars['ObjectId']['input'];
  trackingNumbers?: InputMaybe<Array<__InputBuyerReturnTrackingNumberDetail>>;
};

export type __InputBuyerReturnTrackingNumberDetail = {
  courier?: InputMaybe<Scalars['String']['input']>;
  trackingNumber: Scalars['String']['input'];
};

export type __InputBuyerSubscription = {
  set?: InputMaybe<__InputSubscriptionsEmailingSettings>;
};

export type __InputCatalog = {
  catalogSlug?: InputMaybe<Scalars['String']['input']>;
  cursor?: InputMaybe<__CursorInput>;
  department?: InputMaybe<Scalars['String']['input']>;
  filters?: InputMaybe<Array<__CatalogFiltersInput>>;
  isB2b: Scalars['Boolean']['input'];
  limitTo?: InputMaybe<Array<__CatalogSearchLimitTo>>;
  query?: InputMaybe<Scalars['String']['input']>;
  seller: __InputSellerId;
  sellerCollection?: InputMaybe<Scalars['String']['input']>;
  sku?: InputMaybe<Array<Scalars['String']['input']>>;
  sort?: InputMaybe<__EnumCatalogSort>;
};

export type __InputCatalogVisibilityFind = {
  visibilityIds?: InputMaybe<Array<Scalars['ObjectId']['input']>>;
};

export type __InputCheckoutCreateQuote = {
  products: Array<__InputCheckoutDraftCreateManualItem>;
  sellerId: Scalars['ObjectId']['input'];
};

export type __InputCheckoutDraftCreateManual = {
  products: Array<__InputCheckoutDraftCreateManualItem>;
};

export type __InputCheckoutDraftCreateManualItem = {
  productId: Scalars['String']['input'];
  qty: Scalars['Float']['input'];
};

export type __InputCheckoutQuote = {
  createQuote?: InputMaybe<__InputCheckoutCreateQuote>;
  update?: InputMaybe<__InputCheckoutQuoteUpdate>;
};

export type __InputCheckoutQuoteActions = {
  cursorNext?: InputMaybe<Scalars['String']['input']>;
  limit: Scalars['Int']['input'];
  quoteId: Scalars['ObjectId']['input'];
};

export type __InputCheckoutQuoteDeliveryType = {
  type: __EnumCheckoutQuoteDelivery;
};

export type __InputCheckoutQuoteUpdate = {
  _id: Scalars['ObjectId']['input'];
  addressUpdate?: InputMaybe<__InputBuyerAddressUpdate>;
  askChanges?: InputMaybe<__InputString>;
  askChangesCancel?: InputMaybe<__InputId>;
  cancel?: InputMaybe<__InputBool>;
  delivery?: InputMaybe<__InputCheckoutQuoteDeliveryType>;
  placeOrder?: InputMaybe<__InputCheckoutQuoteUpdatePlaceOrder>;
  product?: InputMaybe<__CheckoutDraftInputSetProduct>;
  quoteViewed?: InputMaybe<__InputBool>;
  replaceProduct?: InputMaybe<__CheckoutQuoteReplaceProduct>;
  setMainAddress?: InputMaybe<__CheckoutDraftInputMainAddress>;
  submitQuote?: InputMaybe<__InputBool>;
};

export type __InputCheckoutQuoteUpdatePlaceOrder = {
  openAccount: Scalars['Boolean']['input'];
};

export type __InputCheckoutUpcomingDeliveryOptions = {
  addressId: Scalars['ObjectId']['input'];
  sellerId: Scalars['ObjectId']['input'];
};

export type __InputCode = {
  code: Scalars['String']['input'];
};

export type __InputCodeEmail = {
  email: Scalars['String']['input'];
  fullurl?: InputMaybe<Scalars['String']['input']>;
};

export type __InputDate = {
  dateIso: Scalars['String']['input'];
};

export type __InputDocumentBlock = {
  blockType?: InputMaybe<__EnumDocumentBlockType>;
  img?: InputMaybe<__ImageInput>;
  link?: InputMaybe<__InputSellerLink>;
  padding?: InputMaybe<Array<Scalars['Int']['input']>>;
  productId?: InputMaybe<Scalars['String']['input']>;
  productUi?: InputMaybe<__EnumDocumentBlockProductUi>;
  radius?: InputMaybe<Scalars['Int']['input']>;
  ratio?: InputMaybe<__ImageTaggedRatio>;
  spanCol?: InputMaybe<Scalars['Int']['input']>;
  spanRow?: InputMaybe<Scalars['Int']['input']>;
  table?: InputMaybe<__InputDocumentBlockTable>;
  tags?: InputMaybe<Array<__InputDocumentBlockTag>>;
  txt?: InputMaybe<Array<__InputDocumentBlockTxt>>;
};

export type __InputDocumentBlockHeader = {
  align?: InputMaybe<__EnumDocumentBlockTxtAlign>;
  link?: InputMaybe<__InputSellerLink>;
  linkUi?: InputMaybe<__EnumDocumentLinkUi>;
  padding?: InputMaybe<Array<Scalars['Int']['input']>>;
  text?: InputMaybe<__InputLexicalTranslated>;
};

export type __InputDocumentBlockTable = {
  entries: Array<__InputDocumentBlockTableEntry>;
  flowCol?: InputMaybe<Scalars['Boolean']['input']>;
  headers: Array<__InputDocumentBlockTableHead>;
  layout: __EnumDocumentBlockFixed;
  view: __EnumDocumentBlockTable;
};

export type __InputDocumentBlockTableEntry = {
  bg?: InputMaybe<__InputDocumentColor>;
  color?: InputMaybe<__InputDocumentColor>;
  index: Scalars['Int']['input'];
  key: Scalars['String']['input'];
  padding?: InputMaybe<Array<Scalars['Int']['input']>>;
  text?: InputMaybe<__InputLexicalTranslated>;
};

export type __InputDocumentBlockTableHead = {
  align?: InputMaybe<__EnumDocumentBlockTxtAlign>;
  bg?: InputMaybe<__InputDocumentColor>;
  color?: InputMaybe<__InputDocumentColor>;
  key: Scalars['String']['input'];
  padding?: InputMaybe<Array<Scalars['Int']['input']>>;
  text?: InputMaybe<__InputLexicalTranslated>;
};

export type __InputDocumentBlockTag = {
  groupId?: InputMaybe<Scalars['String']['input']>;
  productId?: InputMaybe<Scalars['String']['input']>;
  profileId?: InputMaybe<Scalars['String']['input']>;
  x?: InputMaybe<Scalars['Float']['input']>;
  xAlign?: InputMaybe<__EnumDocumentTxtFloatAlign>;
  y?: InputMaybe<Scalars['Float']['input']>;
  yAlign?: InputMaybe<__EnumDocumentTxtFloatAlign>;
};

export type __InputDocumentBlockTxt = {
  align?: InputMaybe<__EnumDocumentBlockTxtAlign>;
  bg?: InputMaybe<__InputDocumentColor>;
  color?: InputMaybe<__InputDocumentColor>;
  floating?: InputMaybe<Array<__EnumBlockTextFloating>>;
  link?: InputMaybe<__InputSellerLink>;
  linkUi?: InputMaybe<__EnumDocumentLinkUi>;
  padding?: InputMaybe<Array<Scalars['Int']['input']>>;
  radius?: InputMaybe<Scalars['Int']['input']>;
  text?: InputMaybe<__InputLexicalTranslated>;
  type: __EnumDocumentBlockTxtType;
  width?: InputMaybe<__InputDocumentWidth>;
  x?: InputMaybe<Scalars['Float']['input']>;
  xAlign?: InputMaybe<__EnumDocumentTxtFloatAlign>;
  y?: InputMaybe<Scalars['Float']['input']>;
  yAlign?: InputMaybe<__EnumDocumentTxtFloatAlign>;
};

export type __InputDocumentColor = {
  color?: InputMaybe<__InputDocumentColorHsla>;
  gradient?: InputMaybe<Array<__InputDocumentColorGradient>>;
};

export type __InputDocumentColorGradient = {
  colors: Array<__InputDocumentColorGradientCol>;
  linearDeg?: InputMaybe<Scalars['Float']['input']>;
  radialX?: InputMaybe<Scalars['Float']['input']>;
  radialY?: InputMaybe<Scalars['Float']['input']>;
  repeat: Scalars['Boolean']['input'];
  type: __EnumDocumentColorGradientRadialSize;
};

export type __InputDocumentColorGradientCol = {
  color: __InputDocumentColorHsla;
  percent: Scalars['Float']['input'];
};

export type __InputDocumentColorHsla = {
  a?: InputMaybe<Scalars['Float']['input']>;
  h: Scalars['Float']['input'];
  l: Scalars['Float']['input'];
  s: Scalars['Float']['input'];
};

export type __InputDocumentColorMutate = {
  create?: InputMaybe<__InputDocumentColor>;
  remove?: InputMaybe<__InputId>;
  sellerId: Scalars['ObjectId']['input'];
};

export type __InputDocumentColorSearch = {
  gradient: Scalars['Boolean']['input'];
  input: __InputPagination;
};

export type __InputDocumentId = {
  documentId?: InputMaybe<Scalars['ObjectId']['input']>;
};

export type __InputDocumentIdMust = {
  documentId: Scalars['ObjectId']['input'];
};

export type __InputDocumentOrText = {
  doc?: InputMaybe<__InputDocumentId>;
  text?: InputMaybe<__InputText>;
};

export type __InputDocumentSection = {
  bg?: InputMaybe<__InputDocumentColor>;
  blockWidth?: InputMaybe<__InputDocumentWidth>;
  blocks: Array<__InputDocumentBlock>;
  color?: InputMaybe<__InputDocumentColor>;
  cols: Scalars['Int']['input'];
  gapCol?: InputMaybe<Scalars['Int']['input']>;
  gapRow?: InputMaybe<Scalars['Int']['input']>;
  head?: InputMaybe<__InputDocumentBlockHeader>;
  hidden: Scalars['Boolean']['input'];
  id: Scalars['ObjectId']['input'];
  padding?: InputMaybe<Array<Scalars['Int']['input']>>;
  rows: Scalars['Int']['input'];
  type: __SellerDocumentBlocksType;
  width?: InputMaybe<__InputDocumentWidth>;
};

export type __InputDocumentView = {
  id: Scalars['ObjectId']['input'];
  mobile: Scalars['Boolean']['input'];
};

export type __InputDocumentWidth = {
  unit: __EnumDocumentWidthUnit;
  value: Scalars['Float']['input'];
};

export type __InputDuration = {
  unit: __EnumDuration;
  value: Scalars['Int']['input'];
};

export type __InputEmail = {
  email: Scalars['String']['input'];
};

export type __InputGroupId = {
  groupId: Scalars['ObjectId']['input'];
};

export type __InputHandle = {
  handle: Scalars['String']['input'];
};

export type __InputId = {
  _id: Scalars['ObjectId']['input'];
};

export type __InputIdOptional = {
  _id?: InputMaybe<Scalars['ObjectId']['input']>;
};

export type __InputIdString = {
  id: Scalars['String']['input'];
};

export type __InputIds = {
  ids: Array<Scalars['String']['input']>;
};

export type __InputImageTagged = {
  img: __ImageInput;
  ratio: __ImageTaggedRatio;
  tags: Array<__InputDocumentBlockTag>;
  type: __ImageProductType;
};

export type __InputLexicalTranslated = {
  translations: Array<__InputLexicalTranslatedValue>;
};

export type __InputLexicalTranslatedValue = {
  json: Scalars['String']['input'];
  lang: Scalars['String']['input'];
};

export type __InputListingsPagination = {
  department?: InputMaybe<Scalars['String']['input']>;
  pagination: __InputPagination;
};

export type __InputLockersCities = {
  all?: InputMaybe<Scalars['Boolean']['input']>;
  iso2: Scalars['String']['input'];
  lockerProviders?: InputMaybe<Array<__EnumLockerProvider>>;
};

export type __InputLoggingPagination = {
  orderEntry?: InputMaybe<__OrderInput>;
  pagination: __InputPagination;
};

export type __InputLoginWithCode2 = {
  codeFromEmail: Scalars['String']['input'];
  email: Scalars['String']['input'];
};

export type __InputMarketCountry = {
  countryCreate?: InputMaybe<__InputMarketCountryItem>;
  countryDelete?: InputMaybe<__InputMarketCountryItem>;
  countryUpdate?: InputMaybe<__InputMarketCountryItem>;
  sellerId: Scalars['ObjectId']['input'];
};

export type __InputMarketCountryItem = {
  altname: Array<Scalars['String']['input']>;
  continent: __EnumCountryContinent;
  img?: InputMaybe<__ImageInput>;
  isEu: Scalars['Boolean']['input'];
  iso2: Scalars['String']['input'];
  priority?: InputMaybe<Scalars['Boolean']['input']>;
  telCode: Scalars['String']['input'];
  title: __InputText;
  vat: Scalars['Float']['input'];
};

export type __InputMarketCountryRegion = {
  code: Scalars['String']['input'];
  iso2: Scalars['String']['input'];
  title: __InputText;
  vat?: InputMaybe<Scalars['Float']['input']>;
};

export type __InputMediaProduct = {
  images: Array<__InputImageTagged>;
};

export type __InputMediaProductSet = {
  media: __InputMediaProduct;
  productId: Scalars['ObjectId']['input'];
};

export type __InputMessage = {
  read?: InputMaybe<__InputMessageIds>;
  readAll?: InputMaybe<__InputMessageThrough>;
  seen?: InputMaybe<__InputMessageThrough>;
};

export type __InputMessageIds = {
  ids: Array<Scalars['ObjectId']['input']>;
};

export type __InputMessageThrough = {
  throughCursor: Scalars['String']['input'];
};

export type __InputMessagesPag = {
  cursorNext?: InputMaybe<Scalars['String']['input']>;
  sellerId?: InputMaybe<Scalars['ObjectId']['input']>;
  size?: InputMaybe<Scalars['Int']['input']>;
  unreadOnly?: InputMaybe<Scalars['Boolean']['input']>;
};

export type __InputObjectIds = {
  ids: Array<Scalars['ObjectId']['input']>;
};

export type __InputOpeningHours = {
  fri?: InputMaybe<__InputOpeningHoursDay>;
  mon?: InputMaybe<__InputOpeningHoursDay>;
  sat?: InputMaybe<__InputOpeningHoursDay>;
  sun?: InputMaybe<__InputOpeningHoursDay>;
  thu?: InputMaybe<__InputOpeningHoursDay>;
  timezone?: InputMaybe<Scalars['String']['input']>;
  tue?: InputMaybe<__InputOpeningHoursDay>;
  wed?: InputMaybe<__InputOpeningHoursDay>;
};

export type __InputOpeningHoursDay = {
  close?: InputMaybe<Scalars['Boolean']['input']>;
  hours?: InputMaybe<Array<__InputOpeningHoursDayHours>>;
  open24?: InputMaybe<Scalars['Boolean']['input']>;
};

export type __InputOpeningHoursDayHours = {
  close: __InputOpeningHoursHour;
  open: __InputOpeningHoursHour;
};

export type __InputOpeningHoursHour = {
  hour: Scalars['Int']['input'];
  min: Scalars['Int']['input'];
};

export type __InputPageGridBlock = {
  id: Scalars['String']['input'];
  image?: InputMaybe<__InputPageImageSection>;
  position: __InputPageGridPosition;
  richText?: InputMaybe<__InputPageRichTextEditor>;
  type: __PageGridBlockType;
};

export type __InputPageGridEditor = {
  blocks: Array<__InputPageGridBlock>;
  columns: Scalars['Int']['input'];
  gap?: InputMaybe<__PageSpacing>;
  rows: Scalars['Int']['input'];
};

export type __InputPageGridPosition = {
  column: Scalars['Int']['input'];
  columnSpan: Scalars['Int']['input'];
  row: Scalars['Int']['input'];
  rowSpan: Scalars['Int']['input'];
};

export type __InputPageHeroAction = {
  href: Scalars['String']['input'];
  id: Scalars['String']['input'];
  label: Scalars['String']['input'];
  variant: __PageHeroActionVariant;
};

export type __InputPageHeroEditor = {
  actions?: InputMaybe<Array<__InputPageHeroAction>>;
  description?: InputMaybe<__InputLexicalTranslated>;
  focalPoint?: InputMaybe<__InputPageHeroFocalPoint>;
  headingLevel?: InputMaybe<__PageHeroHeadingLevel>;
  height?: InputMaybe<__PageHeroHeight>;
  horizontalAlign?: InputMaybe<__PageHeroHorizontalAlign>;
  image: __ImageInput;
  mobileFocalPoint?: InputMaybe<__InputPageHeroFocalPoint>;
  mobileImage?: InputMaybe<__ImageInput>;
  overlay?: InputMaybe<__PageHeroOverlay>;
  title: Scalars['String']['input'];
  verticalAlign?: InputMaybe<__PageHeroVerticalAlign>;
};

export type __InputPageHeroFocalPoint = {
  x: Scalars['Float']['input'];
  y: Scalars['Float']['input'];
};

export type __InputPageImageSection = {
  media: __ImageInput;
  presentation?: InputMaybe<__PageImagePresentation>;
};

export type __InputPageProductGridSection = {
  columns?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  source: __InputPageProductGridSource;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type __InputPageProductGridSource = {
  categoryId?: InputMaybe<Scalars['String']['input']>;
  listingIds?: InputMaybe<Array<Scalars['String']['input']>>;
  type: __PageProductGridSourceType;
};

export type __InputPageRichTextEditor = {
  align?: InputMaybe<__PageTextAlign>;
  text: __InputLexicalTranslated;
  textWidth?: InputMaybe<__PageTextWidth>;
};

export type __InputPageSectionSettings = {
  background?: InputMaybe<__PageBackground>;
  contentWidth?: InputMaybe<__PageContentWidth>;
  spacing?: InputMaybe<__PageSpacing>;
};

export type __InputPageSliderSection = {
  aspectRatio?: InputMaybe<__PageSliderAspectRatio>;
  label?: InputMaybe<Scalars['String']['input']>;
  showArrows?: InputMaybe<Scalars['Boolean']['input']>;
  slides: Array<__InputPageSliderSlide>;
};

export type __InputPageSliderSlide = {
  caption?: InputMaybe<Scalars['String']['input']>;
  href?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['String']['input'];
  image: __ImageInput;
};

export type __InputPageTextImageEditor = {
  image: __ImageInput;
  imagePosition: __PageImagePosition;
  ratio?: InputMaybe<Scalars['String']['input']>;
  text: __InputLexicalTranslated;
  verticalAlign?: InputMaybe<__PageTextImageVerticalAlign>;
};

export type __InputPagination = {
  cursor?: InputMaybe<__CursorInput>;
  filterValue?: InputMaybe<__GetFiltersAsyncInput>;
  filters?: InputMaybe<Array<__PaginationInputFilters>>;
  get: __EnumPaginationGet;
  init?: InputMaybe<Scalars['Boolean']['input']>;
  multiget?: InputMaybe<Array<Scalars['String']['input']>>;
  query?: InputMaybe<Scalars['String']['input']>;
  queryRegex?: InputMaybe<Scalars['Boolean']['input']>;
  sorting?: InputMaybe<__PaginationSortingInput>;
};

export type __InputPassword = {
  password: Scalars['String']['input'];
};

export type __InputPasswordCreate = {
  code: Scalars['String']['input'];
  password: Scalars['String']['input'];
};

export type __InputPayCancel = {
  payId?: InputMaybe<Scalars['ObjectId']['input']>;
  paymentId: Scalars['ObjectId']['input'];
};

export type __InputPayRecheck = {
  payId: Scalars['ObjectId']['input'];
};

export type __InputPaymentInvoicesPagination = {
  filters?: InputMaybe<__InputPaymentInvoicesPaginationFilters>;
  input: __InputPagination;
  year?: InputMaybe<Scalars['String']['input']>;
};

export type __InputPaymentInvoicesPaginationFilters = {
  waiting?: InputMaybe<Scalars['Boolean']['input']>;
};

export type __InputPaymentProvidersPagination = {
  input: __InputPagination;
  paymentId: Scalars['ObjectId']['input'];
};

export type __InputPayments = {
  input: __InputPagination;
  view?: InputMaybe<__EnumPaymentsView>;
};

export type __InputPostReviewsPhotos = {
  cursorNext?: InputMaybe<Scalars['String']['input']>;
  find: __InputPostsFind;
  limit: Scalars['Int']['input'];
};

export type __InputPostsFind = {
  articleId?: InputMaybe<Scalars['ObjectId']['input']>;
  groupId?: InputMaybe<Scalars['ObjectId']['input']>;
  replyParentId?: InputMaybe<Scalars['ObjectId']['input']>;
  sellerId?: InputMaybe<Scalars['ObjectId']['input']>;
  type: __PostGetInputType;
};

export type __InputPriceGroupsFind = {
  priceGroups?: InputMaybe<Array<Scalars['ObjectId']['input']>>;
};

export type __InputPriceVariantBulk = {
  price: Scalars['Float']['input'];
  qty: Scalars['Float']['input'];
};

export type __InputPriceVariantBundle = {
  entries: Array<__InputPriceVariantBundleEntry>;
  entryId: Scalars['String']['input'];
  minQty: Scalars['Float']['input'];
};

export type __InputPriceVariantBundleEntry = {
  groupId: Scalars['ObjectId']['input'];
  variantIds?: InputMaybe<Array<Scalars['ObjectId']['input']>>;
};

export type __InputProductAvailibility = {
  availabilityType: __ProductAvailabilityType;
  limited?: InputMaybe<__InputProductVariantLimited>;
  upcoming?: InputMaybe<__InputProductVariantUpcoming>;
};

export type __InputProductCertificate = {
  description: __InputText;
  image: __ImageInput;
  title: __InputText;
};

export type __InputProductDetails = {
  description: __InputText;
};

export type __InputProductExtra = {
  careId?: InputMaybe<Scalars['ObjectId']['input']>;
  certificateIds?: InputMaybe<Array<Scalars['ObjectId']['input']>>;
  detailsId?: InputMaybe<Scalars['ObjectId']['input']>;
  fabricId?: InputMaybe<Scalars['ObjectId']['input']>;
  factoryId?: InputMaybe<Scalars['ObjectId']['input']>;
  returnId?: InputMaybe<Scalars['ObjectId']['input']>;
  stockLocationId?: InputMaybe<Scalars['ObjectId']['input']>;
  warrantyId?: InputMaybe<Scalars['ObjectId']['input']>;
};

export type __InputProductExtraCare = {
  careIconsIds: Array<Scalars['ObjectId']['input']>;
  careMessage: __InputText;
};

export type __InputProductExtraCareIcon = {
  image: __ImageInput;
  title: __InputText;
};

export type __InputProductExtraFabric = {
  care?: InputMaybe<__InputProductExtraCare>;
  careId?: InputMaybe<Scalars['ObjectId']['input']>;
  description: __InputText;
  image: __ImageInput;
  title: __InputText;
};

export type __InputProductExtraFactory = {
  document?: InputMaybe<__InputDocumentId>;
  image?: InputMaybe<__ImageInput>;
  location: __InputText;
  title: __InputText;
};

export type __InputProductExtraShop = {
  address: __InputText;
  city: __InputText;
  contacts?: InputMaybe<__InputProductExtraShopContactsSet>;
  country: __InputBuyerAddressCountry;
  document?: InputMaybe<__InputDocumentId>;
  image?: InputMaybe<__ImageInput>;
  title: __InputText;
};

export type __InputProductExtraShopContactsSet = {
  contacts?: InputMaybe<__InputSellerContacts>;
  update: Scalars['Boolean']['input'];
};

export type __InputProductExtraShops = {
  findOne?: InputMaybe<__InputSlug>;
  seller: __InputId;
};

export type __InputProductExtraStockLocation = {
  country: __InputBuyerAddressCountry;
  locationShort: __InputText;
  stockLocation: __InputText;
};

export type __InputProductExtraType = {
  careId?: Maybe<Scalars['ObjectId']['output']>;
  certificateIds?: Maybe<Array<Scalars['ObjectId']['output']>>;
  detailsId?: Maybe<Scalars['ObjectId']['output']>;
  fabricId?: Maybe<Scalars['ObjectId']['output']>;
  factoryId?: Maybe<Scalars['ObjectId']['output']>;
  returnId?: Maybe<Scalars['ObjectId']['output']>;
  stockLocationId?: Maybe<Scalars['ObjectId']['output']>;
  warrantyId?: Maybe<Scalars['ObjectId']['output']>;
};

export type __InputProductGet = {
  slug: Scalars['String']['input'];
};

export type __InputProductId = {
  productId: Scalars['ObjectId']['input'];
};

export type __InputProductIds = {
  productIds: Array<Scalars['ObjectId']['input']>;
};

export type __InputProductPrice = {
  priceGroups: Array<__InputProductPriceGroup>;
  priceMain: Scalars['Float']['input'];
  pricePrime?: InputMaybe<Scalars['Float']['input']>;
  variantId: Scalars['ObjectId']['input'];
};

export type __InputProductPriceEntries = {
  priceEntries?: InputMaybe<Array<__InputProductPriceEntriesItem>>;
  variantId: Scalars['ObjectId']['input'];
};

export type __InputProductPriceEntriesItem = {
  entryId: Scalars['ObjectId']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
};

export type __InputProductPriceGroup = {
  bulk?: InputMaybe<Array<__InputPriceVariantBulk>>;
  priceGroupId: Scalars['ObjectId']['input'];
  reduce?: InputMaybe<__InputSellerDiscountReduce>;
};

export type __InputProductPropertyVal4 = {
  fieldId: Scalars['ObjectId']['input'];
  number?: InputMaybe<Scalars['Float']['input']>;
  text?: InputMaybe<__InputText>;
  val4Id?: InputMaybe<Scalars['String']['input']>;
};

export type __InputProductPropertyVal4FieldUi = {
  disabled: Scalars['Boolean']['input'];
  expandInCatalog: Scalars['Boolean']['input'];
  fieldId: Scalars['ObjectId']['input'];
  guideBodyId?: InputMaybe<Scalars['String']['input']>;
  guideProductId?: InputMaybe<Scalars['String']['input']>;
  order: Scalars['Int']['input'];
  reTitle?: InputMaybe<__InputText>;
};

export type __InputProductRecomended = {
  cursorNext?: InputMaybe<Scalars['String']['input']>;
  groupId: Scalars['String']['input'];
  productId: Scalars['String']['input'];
  sellerId?: InputMaybe<Scalars['String']['input']>;
  size?: InputMaybe<Scalars['Int']['input']>;
};

export type __InputProductSettingsQty = {
  max?: InputMaybe<Scalars['Float']['input']>;
  min?: InputMaybe<Scalars['Float']['input']>;
  step?: InputMaybe<Scalars['Float']['input']>;
  stockMsg?: InputMaybe<__StockMsg>;
  unit?: InputMaybe<__EnumProductQtyUnit>;
};

export type __InputProductVariantAvailibiltySet = {
  productId: Scalars['ObjectId']['input'];
  value: __InputProductAvailibility;
};

export type __InputProductVariantFeedAttr = {
  audience?: InputMaybe<Scalars['String']['input']>;
  gender?: InputMaybe<Scalars['String']['input']>;
  groupId: Scalars['ObjectId']['input'];
  gtin?: InputMaybe<Scalars['String']['input']>;
  gtin8?: InputMaybe<Scalars['String']['input']>;
  gtin12?: InputMaybe<Scalars['String']['input']>;
  gtin13?: InputMaybe<Scalars['String']['input']>;
  height?: InputMaybe<Scalars['Int']['input']>;
  isbn?: InputMaybe<Scalars['String']['input']>;
  length?: InputMaybe<Scalars['Int']['input']>;
  material?: InputMaybe<Scalars['String']['input']>;
  mpn?: InputMaybe<Scalars['String']['input']>;
  pattern?: InputMaybe<Scalars['String']['input']>;
  width?: InputMaybe<Scalars['Int']['input']>;
};

export type __InputProductVariantGoogleProductCategory = {
  auto: Scalars['Boolean']['input'];
  groupId: Scalars['ObjectId']['input'];
  override?: InputMaybe<Scalars['String']['input']>;
};

export type __InputProductVariantLimited = {
  quantityLimit: Scalars['Int']['input'];
};

export type __InputProductVariantSet = {
  descriptionShort: __InputText;
  descriptionTechnical: __InputText;
  sku: Scalars['String']['input'];
  stock: Scalars['Float']['input'];
  title: __InputText;
  volumeCategory: __EnumProductVolumeCategory;
  weightGrams: Scalars['Float']['input'];
};

export type __InputProductVariantSetOptionsSet = {
  options2: Array<__InputProductPropertyVal4>;
  productId: Scalars['ObjectId']['input'];
};

export type __InputProductVariantUpcoming = {
  availableAt: __InputDate;
  quantityLimit: Scalars['Int']['input'];
};

export type __InputProductVisibility = {
  all: Scalars['Boolean']['input'];
  ids?: InputMaybe<Array<Scalars['ObjectId']['input']>>;
};

export type __InputProductWarranty = {
  document?: InputMaybe<__InputDocumentId>;
  duration: __InputDuration;
  title: __InputText;
};

export type __InputProductsMultiget = {
  ids?: InputMaybe<Array<Scalars['ObjectId']['input']>>;
  sku?: InputMaybe<Array<Scalars['String']['input']>>;
  slugs?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type __InputProductsMultigetFieldValue = {
  fieldId: Scalars['ObjectId']['input'];
  val4Id: Scalars['String']['input'];
};

export type __InputPublicBoard = {
  cursorNext?: InputMaybe<Scalars['String']['input']>;
  handle: Scalars['String']['input'];
};

export type __InputPublicDeliveryProduct = {
  iso2: Scalars['String']['input'];
  priceSaleTotal: Scalars['Float']['input'];
  sellerId: Scalars['ObjectId']['input'];
  stockLocationId?: InputMaybe<Scalars['ObjectId']['input']>;
  volumeCategory: __EnumProductVolumeCategory;
  weightGramsTotal?: InputMaybe<Scalars['Float']['input']>;
};

export type __InputPublicDeliverySeller = {
  country: __InputBuyerAddressCountry;
  sellerId: Scalars['ObjectId']['input'];
};

export type __InputPublicListingsGroup = {
  groupId: Scalars['String']['input'];
  mainOnly?: InputMaybe<Scalars['Boolean']['input']>;
  private?: InputMaybe<Scalars['Boolean']['input']>;
};

export type __InputPublicLockers = {
  all?: InputMaybe<Scalars['Boolean']['input']>;
  city: Scalars['String']['input'];
  iso2: Scalars['String']['input'];
  lockerProviders?: InputMaybe<Array<__EnumLockerProvider>>;
};

export type __InputReadyForCollection = {
  sendDocuments: __InputSellerOrderSendDocuments;
  value: Scalars['Boolean']['input'];
};

export type __InputSearchCatalogFiltersInit = {
  items: Array<__InputSearchCatalogFiltersInitItem>;
};

export type __InputSearchCatalogFiltersInitItem = {
  filterId: Scalars['String']['input'];
  multiIds?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type __InputSearchCatalogFiltersSeller = {
  catalogSlug?: InputMaybe<Scalars['String']['input']>;
  department?: InputMaybe<Scalars['String']['input']>;
  filterKey?: InputMaybe<Scalars['String']['input']>;
  filters?: InputMaybe<Array<__CatalogFiltersInput>>;
  isB2b: Scalars['Boolean']['input'];
  limitTo?: InputMaybe<Array<__CatalogSearchLimitTo>>;
  query?: InputMaybe<Scalars['String']['input']>;
  seller: __InputSellerId;
  sellerCollection?: InputMaybe<Scalars['String']['input']>;
};

export type __InputSearchCatalogFiltersSellerType = {
  catalogSlug?: Maybe<Scalars['String']['output']>;
  department?: Maybe<Scalars['String']['output']>;
  filterKey?: Maybe<Scalars['String']['output']>;
  filters?: Maybe<Array<__CatalogFiltersInputType>>;
  isB2b: Scalars['Boolean']['output'];
  limitTo?: Maybe<Array<__CatalogSearchLimitTo>>;
  query?: Maybe<Scalars['String']['output']>;
  seller: __SellerId;
  sellerCollection?: Maybe<Scalars['String']['output']>;
};

export type __InputSellerActivity = {
  cursorNext?: InputMaybe<Scalars['String']['input']>;
  groupId?: InputMaybe<Scalars['String']['input']>;
  orderId?: InputMaybe<Scalars['String']['input']>;
  pageId?: InputMaybe<Scalars['String']['input']>;
  paymentId?: InputMaybe<Scalars['String']['input']>;
  productId?: InputMaybe<Scalars['String']['input']>;
  quoteId?: InputMaybe<Scalars['String']['input']>;
  size?: InputMaybe<Scalars['Int']['input']>;
};

export type __InputSellerAddImageSharing = {
  password: Scalars['String']['input'];
  sellerId: __InputId;
};

export type __InputSellerAdminInvitation = {
  remove?: InputMaybe<__InputId>;
  sellerId: Scalars['ObjectId']['input'];
};

export type __InputSellerAi = {
  chat?: InputMaybe<__InputSellerTextHelp>;
  context?: InputMaybe<__InputSeoProblemsRececk>;
  sellerId: Scalars['ObjectId']['input'];
};

export type __InputSellerArticle = {
  collectionProducts?: InputMaybe<__InputSellerArticleProducts>;
  create?: InputMaybe<__InputSellerArticleCreate>;
  delete?: InputMaybe<__InputId>;
  sellerId: Scalars['ObjectId']['input'];
  update?: InputMaybe<__InputSellerArticleUpdate>;
};

export type __InputSellerArticleCreate = {
  authorId?: InputMaybe<Scalars['ObjectId']['input']>;
  document: __InputDocumentId;
  image?: InputMaybe<__ImageInput>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  tags: Array<Scalars['String']['input']>;
  title: __InputText;
  type: __SellerArticleType;
};

export type __InputSellerArticleProducts = {
  groupIds: Array<Scalars['ObjectId']['input']>;
  postId: Scalars['ObjectId']['input'];
};

export type __InputSellerArticleUpdate = {
  authorId?: InputMaybe<Scalars['ObjectId']['input']>;
  document: __InputDocumentId;
  image?: InputMaybe<__ImageInput>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  postId: Scalars['ObjectId']['input'];
  tags: Array<Scalars['String']['input']>;
  title: __InputText;
};

export type __InputSellerBundle = {
  create?: InputMaybe<__InputSellerBundleCreate>;
  delete?: InputMaybe<__InputId>;
  sellerId: Scalars['ObjectId']['input'];
  updateEntries?: InputMaybe<__InputSellerBundleUpdateDiscount>;
  updateTitle?: InputMaybe<__InputSellerBundleUpdateTitle>;
};

export type __InputSellerBundleCreate = {
  description?: InputMaybe<__InputText>;
  entries: __InputBundleEntries;
  imageTagged: __InputImageTagged;
  isActive: Scalars['Boolean']['input'];
  title: __InputText;
};

export type __InputSellerBundleUpdateDiscount = {
  _id: Scalars['ObjectId']['input'];
  entries: __InputBundleEntries;
  imageTagged: __InputImageTagged;
};

export type __InputSellerBundleUpdateImage = {
  _id: Scalars['ObjectId']['input'];
};

export type __InputSellerBundleUpdateTitle = {
  _id: Scalars['ObjectId']['input'];
  description?: InputMaybe<__InputText>;
  isActive: Scalars['Boolean']['input'];
  title: __InputText;
};

export type __InputSellerBusiness = {
  _b2bInit_?: InputMaybe<__InputSellerBusinessInit>;
  businessCreate?: InputMaybe<__InputSellerBusinessCreate>;
  businessMutate?: InputMaybe<__InputSellerBusinessMutate>;
  requestRemove?: InputMaybe<__InputSellerBusinessRemove>;
  sellerId: Scalars['ObjectId']['input'];
};

export type __InputSellerBusinessCreate = {
  billingDetails: __SellerOrderDocEditsInvoice;
  buyerEmail?: InputMaybe<Scalars['String']['input']>;
  buyerId?: InputMaybe<Scalars['ObjectId']['input']>;
  requestId?: InputMaybe<Scalars['ObjectId']['input']>;
  values: __InputSellerBusinessUpdate;
};

export type __InputSellerBusinessInit = {
  likuciai: __InputId;
  pakuotes: __InputId;
  prekesKnygosIrasai: __InputId;
  skuFile: __InputId;
};

export type __InputSellerBusinessMutate = {
  billingDetails?: InputMaybe<__SellerOrderDocEditsInvoice>;
  businessDisable?: InputMaybe<__InputBool>;
  businessDisableActivate?: InputMaybe<__InputBool>;
  businessId: Scalars['ObjectId']['input'];
  businessSendEmail?: InputMaybe<__InputBool>;
  businessUpdate?: InputMaybe<__InputSellerBusinessUpdate>;
};

export type __InputSellerBusinessRemove = {
  _id: Scalars['ObjectId']['input'];
  reason?: InputMaybe<Scalars['String']['input']>;
};

export type __InputSellerBusinessUpdate = {
  discountPercent?: InputMaybe<Scalars['Int']['input']>;
  orderTotalMin: Scalars['Int']['input'];
  paymentDelayDays?: InputMaybe<Scalars['Int']['input']>;
  priceGroups: Array<Scalars['ObjectId']['input']>;
  profileId: Scalars['ObjectId']['input'];
};

export type __InputSellerBusinessesFind = {
  disabled?: InputMaybe<Scalars['Boolean']['input']>;
  invites?: InputMaybe<Scalars['Boolean']['input']>;
  priceGroupId?: InputMaybe<Scalars['ObjectId']['input']>;
};

export type __InputSellerCatalogUi = {
  sellerId: Scalars['ObjectId']['input'];
  set?: InputMaybe<__InputSellerCatalogUiSet>;
  updateDescription?: InputMaybe<__InputSellerCatalogUiUpdateDescription>;
};

export type __InputSellerCatalogUiSet = {
  _id: Scalars['ObjectId']['input'];
  description?: InputMaybe<__InputText>;
  documentId?: InputMaybe<__InputDocumentId>;
  isActive: Scalars['Boolean']['input'];
  slugEn?: InputMaybe<Scalars['String']['input']>;
  slugLt?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<__InputText>;
};

export type __InputSellerCatalogUiUpdateDescription = {
  _id: Scalars['ObjectId']['input'];
  description?: InputMaybe<__InputText>;
  title?: InputMaybe<__InputText>;
};

export type __InputSellerCatalogUis = {
  created?: InputMaybe<Scalars['Boolean']['input']>;
  pagination: __InputPagination;
  storefrontFilters?: InputMaybe<__InputCatalog>;
};

export type __InputSellerCatalogVisibility = {
  create?: InputMaybe<__InputSellerCatalogVisibilityCreate>;
  delete?: InputMaybe<__InputId>;
  sellerId: Scalars['ObjectId']['input'];
  update?: InputMaybe<__InputSellerCatalogVisibilityUpdate>;
};

export type __InputSellerCatalogVisibilityCreate = {
  adminNote: Scalars['String']['input'];
  isActive: Scalars['Boolean']['input'];
  name: Scalars['String']['input'];
};

export type __InputSellerCatalogVisibilityUpdate = {
  adminNote: Scalars['String']['input'];
  id: Scalars['ObjectId']['input'];
  isActive: Scalars['Boolean']['input'];
  name: Scalars['String']['input'];
};

export type __InputSellerContacts = {
  emails?: InputMaybe<Array<Scalars['String']['input']>>;
  links?: InputMaybe<Array<__InputSellerSocialItem>>;
  openingHours?: InputMaybe<__InputOpeningHours>;
  tels?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type __InputSellerCreate = {
  handle: Scalars['String']['input'];
  sellerName: Scalars['String']['input'];
};

export type __InputSellerDeliveryCreate = {
  deliveryDuraitonDays: Scalars['Int']['input'];
  description: __InputText;
  dispatchHour: Scalars['Int']['input'];
  isActive: Scalars['Boolean']['input'];
  location?: InputMaybe<__InputSellerDeliveryLocation>;
  locker?: InputMaybe<__InputSellerDeliveryLocker>;
  pricing: __InputSellerDeliveryUpdatePricingValues;
  shipping?: InputMaybe<__InputSellerDeliveryShipping>;
  trackingProvider: __EnumDeliveryTrackingProvider;
};

export type __InputSellerDeliveryLocation = {
  locationShopId: Scalars['ObjectId']['input'];
  title: __InputText;
};

export type __InputSellerDeliveryLocker = {
  lockerProvider: __EnumLockerProvider;
};

export type __InputSellerDeliveryShipping = {
  title: __InputText;
};

export type __InputSellerDeliveryShippingCountry = {
  all: Scalars['Boolean']['input'];
  iso2: Scalars['String']['input'];
  mainland: Scalars['Boolean']['input'];
  postCodeZones?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type __InputSellerDeliveryTable = {
  types: Array<__InputSellerDeliveryTablePage>;
  values: Array<__InputSellerDeliveryTableValue>;
  weights: Array<__InputSellerDeliveryTableWeight>;
  zones: Array<__InputSellerDeliveryTableZone>;
};

export type __InputSellerDeliveryTablePage = {
  deliveryDuraitonDays?: InputMaybe<Scalars['Int']['input']>;
  disabled?: InputMaybe<Scalars['Boolean']['input']>;
  title?: InputMaybe<__InputText>;
  type: Scalars['String']['input'];
};

export type __InputSellerDeliveryTableValue = {
  price: Scalars['Float']['input'];
  type: Scalars['String']['input'];
  weightGrams: Scalars['Int']['input'];
  zone: Scalars['String']['input'];
};

export type __InputSellerDeliveryTableWeight = {
  weightGrams: Scalars['Int']['input'];
};

export type __InputSellerDeliveryTableZone = {
  countries: Array<__InputSellerDeliveryShippingCountry>;
  disabled: Scalars['Boolean']['input'];
  zone: Scalars['String']['input'];
};

export type __InputSellerDeliveryTracking = {
  _id: Scalars['ObjectId']['input'];
  deliveryDuraitonDays: Scalars['Int']['input'];
  dispatchHour: Scalars['Int']['input'];
  emailTemplate?: InputMaybe<__SellerDeliveryInputEmailTemplate>;
};

export type __InputSellerDeliveryUpdate = {
  _id: Scalars['ObjectId']['input'];
  description: __InputText;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  location?: InputMaybe<__InputSellerDeliveryLocation>;
  locker?: InputMaybe<__InputSellerDeliveryLocker>;
  shipping?: InputMaybe<__InputSellerDeliveryShipping>;
  trackingProvider: __EnumDeliveryTrackingProvider;
};

export type __InputSellerDeliveryUpdatePricing = {
  _id: Scalars['ObjectId']['input'];
  values: __InputSellerDeliveryUpdatePricingValues;
};

export type __InputSellerDeliveryUpdatePricingValues = {
  disabledCountries: Array<__InputSellerDeliveryShippingCountry>;
  pricingFreeCountries: Array<__InputSellerDeliveryShippingCountry>;
  pricingTable?: InputMaybe<__InputSellerDeliveryTable>;
  pricingType: __EnumSellerDeliveryPricing;
};

export type __InputSellerDeliveryZoneCreate = {
  code: Scalars['String']['input'];
  isActive: Scalars['Boolean']['input'];
  iso2: Scalars['String']['input'];
  rules: __InputSellerDeliveryZoneRule;
  title: __InputText;
};

export type __InputSellerDeliveryZoneRange = {
  max: Scalars['Int']['input'];
  min: Scalars['Int']['input'];
};

export type __InputSellerDeliveryZoneRule = {
  exact?: InputMaybe<Array<Scalars['String']['input']>>;
  prefixes?: InputMaybe<Array<Scalars['String']['input']>>;
  ranges?: InputMaybe<Array<__InputSellerDeliveryZoneRange>>;
};

export type __InputSellerDeliveryZoneUpdate = {
  isActive: Scalars['Boolean']['input'];
  title: __InputText;
  zoneId: Scalars['ObjectId']['input'];
};

export type __InputSellerDeliveryZoneUpdateRules = {
  rules: __InputSellerDeliveryZoneRule;
  zoneId: Scalars['ObjectId']['input'];
};

export type __InputSellerDeliveryZones = {
  create?: InputMaybe<__InputSellerDeliveryZoneCreate>;
  delete?: InputMaybe<__InputId>;
  rulesUpdate?: InputMaybe<__InputSellerDeliveryZoneUpdateRules>;
  sellerId: Scalars['ObjectId']['input'];
  update?: InputMaybe<__InputSellerDeliveryZoneUpdate>;
};

export type __InputSellerDepartmentItem = {
  description?: InputMaybe<__InputText>;
  img?: InputMaybe<__ImageInput>;
  isActive: Scalars['Boolean']['input'];
  parentId?: InputMaybe<Scalars['ObjectId']['input']>;
  stats?: InputMaybe<Scalars['Boolean']['input']>;
  title: __InputText;
};

export type __InputSellerDepartmentItemSeo = {
  _id: Scalars['ObjectId']['input'];
  description?: InputMaybe<__InputText>;
  title?: InputMaybe<__InputText>;
};

export type __InputSellerDepartmentItemUpdate = {
  _id: Scalars['ObjectId']['input'];
  item: __InputSellerDepartmentItem;
};

export type __InputSellerDepartments = {
  create?: InputMaybe<__InputSellerDepartmentItem>;
  delete?: InputMaybe<__InputId>;
  sellerId: Scalars['ObjectId']['input'];
  update?: InputMaybe<__InputSellerDepartmentItemUpdate>;
  updateSeo?: InputMaybe<__InputSellerDepartmentItemSeo>;
};

export type __InputSellerDiscount = {
  create?: InputMaybe<__InputSellerDiscountCreate>;
  delete?: InputMaybe<__InputId>;
  delivery?: InputMaybe<__InputSellerDiscountDeliveryUpdate>;
  priceGroups?: InputMaybe<__InputSellerDiscountPriceGroups>;
  sellerId: Scalars['ObjectId']['input'];
  update?: InputMaybe<__InputSellerDiscountUpdate>;
  updateCodeOne?: InputMaybe<__InputSellerDiscountCodeUpdateOne>;
  updateCodes?: InputMaybe<__InputSellerDiscountCodeUpdate>;
  updateOrder?: InputMaybe<__InputSellerDiscountUpdateCart>;
  updateOrderMin?: InputMaybe<__InputSellerDiscountUpdateOrderMin>;
};

export type __InputSellerDiscountCode = {
  code: Scalars['String']['input'];
  codeCaseInsensitive: Scalars['Boolean']['input'];
};

export type __InputSellerDiscountCodeUpdate = {
  codeCaseInsensitive: Scalars['Boolean']['input'];
  codes: Array<__InputSellerDiscountCreateCodeItem>;
  discountId: Scalars['ObjectId']['input'];
};

export type __InputSellerDiscountCodeUpdateOne = {
  code: __InputSellerDiscountCreateCodeItem;
  discountId: Scalars['ObjectId']['input'];
};

export type __InputSellerDiscountCreate = {
  auto?: InputMaybe<__InputSellerDiscountValues>;
  code?: InputMaybe<__InputSellerDiscountCreateCode>;
  endAt?: InputMaybe<__InputDate>;
  isActive: Scalars['Boolean']['input'];
  name: Scalars['String']['input'];
  sale?: InputMaybe<__InputSellerDiscountCreateSale>;
  startAt?: InputMaybe<__InputDate>;
  title: __InputText;
};

export type __InputSellerDiscountCreateCode = {
  codeCaseInsensitive: Scalars['Boolean']['input'];
  codes: Array<__InputSellerDiscountCreateCodeItem>;
  discount: __InputSellerDiscountValues;
};

export type __InputSellerDiscountCreateCodeItem = {
  active: Scalars['Boolean']['input'];
  code: Scalars['String']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
  note?: InputMaybe<Scalars['String']['input']>;
};

export type __InputSellerDiscountCreateSale = {
  code?: InputMaybe<__InputSellerDiscountCode>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  priceGroupIds: Array<Scalars['ObjectId']['input']>;
};

export type __InputSellerDiscountDeliveryUpdate = {
  discountId: Scalars['ObjectId']['input'];
  value: __InputSellerDiscountGivesDelivery;
};

export type __InputSellerDiscountGivesCart = {
  codePublic?: InputMaybe<Scalars['Boolean']['input']>;
  percentage: Scalars['Float']['input'];
  reduceCombined: Scalars['Boolean']['input'];
};

export type __InputSellerDiscountGivesDelivery = {
  all?: InputMaybe<Scalars['Boolean']['input']>;
  deliveryIds?: InputMaybe<Array<Scalars['ObjectId']['input']>>;
};

export type __InputSellerDiscountPriceGroups = {
  id: Scalars['ObjectId']['input'];
  priceGroupIds: Array<Scalars['ObjectId']['input']>;
};

export type __InputSellerDiscountReduce = {
  type: __DiscountType2;
  value: Scalars['Float']['input'];
};

export type __InputSellerDiscountUpdate = {
  endAt?: InputMaybe<__InputDate>;
  id: Scalars['ObjectId']['input'];
  isActive: Scalars['Boolean']['input'];
  startAt?: InputMaybe<__InputDate>;
  title: __InputText;
};

export type __InputSellerDiscountUpdateCart = {
  id: Scalars['ObjectId']['input'];
  value: __InputSellerDiscountGivesCart;
};

export type __InputSellerDiscountUpdateOrderMin = {
  id: Scalars['ObjectId']['input'];
  requirementsOrderTotal: Scalars['Float']['input'];
};

export type __InputSellerDiscountValues = {
  givesFreeShipping?: InputMaybe<__InputSellerDiscountGivesDelivery>;
  givesOrderDiscount?: InputMaybe<__InputSellerDiscountGivesCart>;
  givesType: __SellerDiscountGivesType;
  priceGroupIds?: InputMaybe<Array<Scalars['ObjectId']['input']>>;
  requirementsOrderTotal?: InputMaybe<Scalars['Float']['input']>;
};

export type __InputSellerDiscountsFind = {
  activeOnly?: InputMaybe<Scalars['Boolean']['input']>;
  archiveOnly?: InputMaybe<Scalars['Boolean']['input']>;
  priceGroupId?: InputMaybe<Scalars['ObjectId']['input']>;
};

export type __InputSellerDocOff = {
  isOff?: InputMaybe<Scalars['Boolean']['input']>;
  msg?: InputMaybe<__InputText>;
};

export type __InputSellerDocumentComponentDelete = {
  documentId: Scalars['ObjectId']['input'];
  mobile: Scalars['Boolean']['input'];
  sectionId: Scalars['ObjectId']['input'];
};

export type __InputSellerDocumentComponentHide = {
  documentId: Scalars['ObjectId']['input'];
  hidden: Scalars['Boolean']['input'];
  mobile: Scalars['Boolean']['input'];
  sectionId: Scalars['ObjectId']['input'];
};

export type __InputSellerDocumentCreate = {
  name: Scalars['String']['input'];
  tags: Array<Scalars['String']['input']>;
};

export type __InputSellerDocumentSf = {
  draft?: InputMaybe<Scalars['Boolean']['input']>;
  id: Scalars['ObjectId']['input'];
  mobile: Scalars['Boolean']['input'];
};

export type __InputSellerDocumentTemplate = {
  sellerId: Scalars['ObjectId']['input'];
  templateDelete?: InputMaybe<__InputId>;
  templateSave?: InputMaybe<__InputSellerDocumentTemplateSection>;
};

export type __InputSellerDocumentTemplateSection = {
  documentId: Scalars['ObjectId']['input'];
  mobile: Scalars['Boolean']['input'];
  name: Scalars['String']['input'];
  sectionId: Scalars['ObjectId']['input'];
};

export type __InputSellerFaq = {
  questionCreate?: InputMaybe<__InputSellerFaqQuestionCreate>;
  questionDelete?: InputMaybe<__InputId>;
  questionReoeder?: InputMaybe<__InputSellerFaqQuestionReorder>;
  questionUpdate?: InputMaybe<__InputSellerFaqQuestionUpdate>;
  sectionCreate?: InputMaybe<__InputSellerFaqSectionCreate>;
  sectionDelete?: InputMaybe<__InputId>;
  sectionReorder?: InputMaybe<__InputIds>;
  sectionUpdate?: InputMaybe<__InputSellerFaqSectionUpdate>;
  sellerId: Scalars['ObjectId']['input'];
};

export type __InputSellerFaqQuestionCreate = {
  content: __InputDocumentOrText;
  isActive: Scalars['Boolean']['input'];
  question: __InputText;
  sectionId: Scalars['ObjectId']['input'];
};

export type __InputSellerFaqQuestionReorder = {
  ids: Array<Scalars['ObjectId']['input']>;
  sectionId: Scalars['ObjectId']['input'];
};

export type __InputSellerFaqQuestionUpdate = {
  content: __InputDocumentOrText;
  isActive: Scalars['Boolean']['input'];
  question: __InputText;
  questionId: Scalars['ObjectId']['input'];
};

export type __InputSellerFaqSectionCreate = {
  isActive: Scalars['Boolean']['input'];
  title: __InputText;
};

export type __InputSellerFaqSectionUpdate = {
  isActive: Scalars['Boolean']['input'];
  sectionId: Scalars['ObjectId']['input'];
  title: __InputText;
};

export type __InputSellerFile = {
  _id: Scalars['ObjectId']['input'];
};

export type __InputSellerFileMutate = {
  getDownloadUrl?: InputMaybe<__InputId>;
  remove?: InputMaybe<__InputObjectIds>;
  sellerId: Scalars['ObjectId']['input'];
  tags?: InputMaybe<__InputSellerImageTags>;
  upload?: InputMaybe<__InputSellerFileUpload>;
  uploadDone?: InputMaybe<__InputObjectIds>;
};

export type __InputSellerFileUpload = {
  dir: Scalars['String']['input'];
  filename: Scalars['String']['input'];
  private: Scalars['Boolean']['input'];
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
  type: Scalars['String']['input'];
};

export type __InputSellerGuideArea = {
  description?: InputMaybe<__InputText>;
  key: Scalars['String']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<__InputText>;
};

export type __InputSellerGuideSize = {
  key: Scalars['String']['input'];
  title?: InputMaybe<__InputText>;
};

export type __InputSellerGuideUnit = {
  key: Scalars['String']['input'];
  unit: Scalars['String']['input'];
};

export type __InputSellerGuideValue = {
  areaKey: Scalars['String']['input'];
  sizeKey: Scalars['String']['input'];
  unitKey: Scalars['String']['input'];
  value: Scalars['String']['input'];
};

export type __InputSellerId = {
  sellerId?: InputMaybe<Scalars['ObjectId']['input']>;
};

export type __InputSellerImage = {
  remove?: InputMaybe<__InputObjectIds>;
  sellerId: Scalars['ObjectId']['input'];
  tags?: InputMaybe<__InputSellerImageTags>;
  upload?: InputMaybe<__InputSellerImageUpload>;
  uploadDone?: InputMaybe<__InputObjectIds>;
};

export type __InputSellerImageTags = {
  tags: Array<__InputSellerImageTagsOne>;
};

export type __InputSellerImageTagsOne = {
  id: Scalars['ObjectId']['input'];
  tags: Array<Scalars['String']['input']>;
};

export type __InputSellerImageUpload = {
  filename: Scalars['String']['input'];
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
  type: Scalars['String']['input'];
};

export type __InputSellerInboxHandled = {
  latestCustomerPostId: Scalars['ObjectId']['input'];
  rootId: Scalars['ObjectId']['input'];
};

export type __InputSellerInfoAddress = {
  apartment?: InputMaybe<__InputText>;
  city: __InputText;
  country: __InputBuyerAddressCountry;
  deliveryInstruction?: InputMaybe<__InputText>;
  fullname: __InputText;
  postCode: __InputText;
  state?: InputMaybe<__InputText>;
  street: __InputText;
  tel?: InputMaybe<__InputText>;
};

export type __InputSellerInvoiceDetails = {
  SWIFT: Scalars['String']['input'];
  comanyAddress: __InputText;
  companyCode: Scalars['String']['input'];
  companyName: __InputText;
  companyVAT: Scalars['String']['input'];
  invoiceBank: __InputText;
  invoiceBankAccount: Scalars['String']['input'];
  invoiceBankCode: Scalars['String']['input'];
};

export type __InputSellerLink = {
  alt: Scalars['String']['input'];
  sellerId: Scalars['String']['input'];
  slug: Scalars['String']['input'];
  type: __SellerLinkType;
};

export type __InputSellerLinks = {
  create?: InputMaybe<__InputSellerLinksOutside>;
  remove?: InputMaybe<__InputId>;
  sellerId: Scalars['ObjectId']['input'];
  update?: InputMaybe<__InputSellerLinksUpdate>;
};

export type __InputSellerLinksOutside = {
  text: __InputText;
  url: Scalars['String']['input'];
};

export type __InputSellerLinksUpdate = {
  id: __InputId;
  update: __InputSellerLinksOutside;
};

export type __InputSellerLockerItems = {
  input: __InputPagination;
  lockerProvider?: InputMaybe<__EnumLockerProvider>;
};

export type __InputSellerMain = {
  handle: Scalars['String']['input'];
  logo: __ImageInput;
  logoFull: __ImageInput;
  name: Scalars['String']['input'];
  productDetailsId?: InputMaybe<Scalars['ObjectId']['input']>;
  productFactoryId?: InputMaybe<Scalars['ObjectId']['input']>;
  productReturnId?: InputMaybe<Scalars['ObjectId']['input']>;
  productStockLocationId?: InputMaybe<Scalars['ObjectId']['input']>;
  productWarrantyId?: InputMaybe<Scalars['ObjectId']['input']>;
  returnAddressId?: InputMaybe<Scalars['ObjectId']['input']>;
};

export type __InputSellerOrder = {
  checkDeliveryTracking?: InputMaybe<__InputSellerOrderTrackingCheck>;
  editBillingAddress?: InputMaybe<__SellerOrderDocEditsAddress>;
  editBillingAddressDelete?: InputMaybe<__SellerOrderDocEditsInputDelete>;
  editDeliveryAddressDelete?: InputMaybe<__SellerOrderDocEditsInputDelete>;
  editDeliveryAddressSet?: InputMaybe<__SellerOrderDocEditsAddress>;
  editInvoiceDelete?: InputMaybe<__SellerOrderDocEditsInputDelete>;
  editInvoiceSet?: InputMaybe<__SellerOrderDocEditsInvoice>;
  order?: InputMaybe<__OrderInput>;
  sellerId: Scalars['ObjectId']['input'];
  sendDocuments?: InputMaybe<__InputSellerOrderSendDocuments>;
  sendEmailWithOrder?: InputMaybe<__InputSellerOrderSendEmailWithOrder>;
  setCanceled?: InputMaybe<__SellerOrderInputCancel>;
  setDeliveryTracking?: InputMaybe<__InputSellerOrderTracking>;
  setInvoicePdf?: InputMaybe<__InputSellerOrderInvoicePdf>;
  setNote?: InputMaybe<__SellerOrderInputNote>;
  setPacking?: InputMaybe<__InputBool>;
  setPackingMany?: InputMaybe<__InputIds>;
  setReturned?: InputMaybe<__InputBool>;
  setShipped?: InputMaybe<__InputSellerOrderShipped>;
};

export type __InputSellerOrderCreateProducts = {
  discountPercentage?: InputMaybe<Scalars['Float']['input']>;
  priceUnitBase: Scalars['Float']['input'];
  productId: Scalars['ObjectId']['input'];
  qty: Scalars['Float']['input'];
};

export type __InputSellerOrderCreateProductsManual = {
  description?: InputMaybe<Scalars['String']['input']>;
  discountPercentage?: InputMaybe<Scalars['Float']['input']>;
  image?: InputMaybe<__ImageInput>;
  priceUnitBase: Scalars['Float']['input'];
  qty: Scalars['Float']['input'];
  title: Scalars['String']['input'];
};

export type __InputSellerOrderDocPdf = {
  documents: __InputSellerOrderSendDocuments;
  order: __OrderInput;
};

export type __InputSellerOrderInvoicePdf = {
  files?: InputMaybe<Array<__InputSellerFile>>;
  invoicedDefaultPdf: Scalars['Boolean']['input'];
  pdfLang?: InputMaybe<Scalars['String']['input']>;
};

export type __InputSellerOrderSendDocuments = {
  ids: Array<Scalars['String']['input']>;
};

export type __InputSellerOrderSendEmailWithOrder = {
  lang: Scalars['String']['input'];
  orderId: Scalars['ObjectId']['input'];
};

export type __InputSellerOrderShipped = {
  sendDocuments: __InputSellerOrderSendDocuments;
  shipmentIds?: InputMaybe<Array<Scalars['ObjectId']['input']>>;
  value: Scalars['Boolean']['input'];
};

export type __InputSellerOrderTracking = {
  items: Array<__InputSellerOrderTrackingOne>;
};

export type __InputSellerOrderTrackingCheck = {
  shippingId: Array<Scalars['ObjectId']['input']>;
};

export type __InputSellerOrderTrackingNumber = {
  number: Scalars['String']['input'];
};

export type __InputSellerOrderTrackingNumberChange = {
  deliveryId: Scalars['ObjectId']['input'];
  lockerId?: InputMaybe<Scalars['String']['input']>;
};

export type __InputSellerOrderTrackingOne = {
  changeDelivery?: InputMaybe<__InputSellerOrderTrackingNumberChange>;
  estimatedDeliveryDate?: InputMaybe<__InputDate>;
  manualTracking?: InputMaybe<__InputSellerOrderTrackingUpdate>;
  products: Array<__InputSellerOrderTrackingOneProduct>;
  shippingId?: InputMaybe<Scalars['ObjectId']['input']>;
  tracking?: InputMaybe<__InputSellerOrderTrackingNumber>;
};

export type __InputSellerOrderTrackingOneProduct = {
  productId: Scalars['ObjectId']['input'];
  qty: Scalars['Float']['input'];
};

export type __InputSellerOrderTrackingUpdate = {
  courierName?: InputMaybe<Scalars['String']['input']>;
  number?: InputMaybe<Scalars['String']['input']>;
  trackingPageUrl?: InputMaybe<Scalars['String']['input']>;
  trackingProvider: __EnumDeliveryTrackingProvider;
  url?: InputMaybe<Scalars['String']['input']>;
};

export type __InputSellerPage = {
  archiveSet?: InputMaybe<__InputSellerPageArchiveSet>;
  draftCommit?: InputMaybe<__InputSellerPageDraft>;
  draftRevert?: InputMaybe<__InputSellerPageDraft>;
  expectedRevision?: InputMaybe<Scalars['String']['input']>;
  pageCreate?: InputMaybe<__InputSellerPageCreate>;
  pageSet?: InputMaybe<__InputSellerPageSet>;
  pinSet?: InputMaybe<__InputSellerPagePinSet>;
  sectionAdd?: InputMaybe<__InputSellerPageSectionAdd>;
  sectionReplace?: InputMaybe<__InputSellerPageSectionReplace>;
  sectionVisibilitySet?: InputMaybe<__InputSellerPageSectionVisibilitySet>;
  sectionsSet?: InputMaybe<__InputSellerPageSectionsSet>;
  sellerId: Scalars['ObjectId']['input'];
};

export type __InputSellerPageArchiveSet = {
  archived: Scalars['Boolean']['input'];
  pageId: Scalars['ObjectId']['input'];
};

export type __InputSellerPageCreate = {
  name: Scalars['String']['input'];
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type __InputSellerPageDraft = {
  pageId: Scalars['ObjectId']['input'];
};

export type __InputSellerPagePinSet = {
  pageId: Scalars['ObjectId']['input'];
  pinned: Scalars['Boolean']['input'];
};

export type __InputSellerPageSection = {
  sectionCreate?: InputMaybe<__InputSellerPageSectionCreate>;
  sectionRename?: InputMaybe<__InputSellerPageSectionRename>;
  sectionSet?: InputMaybe<__InputSellerPageSectionSet>;
  sellerId: Scalars['ObjectId']['input'];
};

export type __InputSellerPageSectionAdd = {
  pageId: Scalars['ObjectId']['input'];
  sectionId: Scalars['ObjectId']['input'];
  type: __PageSectionType;
};

export type __InputSellerPageSectionCreate = {
  value: __InputSellerPageSectionValue;
};

export type __InputSellerPageSectionRename = {
  name: Scalars['String']['input'];
  sectionId: Scalars['ObjectId']['input'];
};

export type __InputSellerPageSectionReplace = {
  pageId: Scalars['ObjectId']['input'];
  replacementId: Scalars['ObjectId']['input'];
  sectionId: Scalars['ObjectId']['input'];
};

export type __InputSellerPageSectionSet = {
  sectionId: Scalars['ObjectId']['input'];
  value: __InputSellerPageSectionValue;
};

export type __InputSellerPageSectionValue = {
  grid?: InputMaybe<__InputPageGridEditor>;
  hero?: InputMaybe<__InputPageHeroEditor>;
  image?: InputMaybe<__InputPageImageSection>;
  name: Scalars['String']['input'];
  productGrid?: InputMaybe<__InputPageProductGridSection>;
  richText?: InputMaybe<__InputPageRichTextEditor>;
  settings?: InputMaybe<__InputPageSectionSettings>;
  slider?: InputMaybe<__InputPageSliderSection>;
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
  textImage?: InputMaybe<__InputPageTextImageEditor>;
  type: __PageSectionType;
};

export type __InputSellerPageSectionVisibilitySet = {
  hidden: Scalars['Boolean']['input'];
  pageId: Scalars['ObjectId']['input'];
  sectionId: Scalars['ObjectId']['input'];
};

export type __InputSellerPageSectionsSet = {
  pageId: Scalars['ObjectId']['input'];
  sections: Array<Scalars['ObjectId']['input']>;
};

export type __InputSellerPageSet = {
  name: Scalars['String']['input'];
  notes?: InputMaybe<Scalars['String']['input']>;
  pageId: Scalars['ObjectId']['input'];
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type __InputSellerPageSf = {
  id: Scalars['ObjectId']['input'];
  mobile: Scalars['Boolean']['input'];
};

export type __InputSellerPayout = {
  bank?: InputMaybe<__InputSellerPayoutBankUpdate>;
  cancel?: InputMaybe<__InputId>;
  completed?: InputMaybe<__InputIds>;
  sellerId: Scalars['ObjectId']['input'];
};

export type __InputSellerPayoutBank = {
  bankAcconutHolderName: Scalars['String']['input'];
  bankAccountNumber: Scalars['String']['input'];
  bankSwift: Scalars['String']['input'];
  bankTitle: Scalars['String']['input'];
};

export type __InputSellerPayoutBankUpdate = {
  bank: __InputSellerPayoutBank;
  id: Scalars['ObjectId']['input'];
};

export type __InputSellerPayoutFind = {
  active?: InputMaybe<__InputBool>;
  order?: InputMaybe<__OrderInput>;
  payment?: InputMaybe<__InputId>;
};

export type __InputSellerPost = {
  approveAll?: InputMaybe<__InputIds>;
  disabledPost?: InputMaybe<__InputSellerPostDisabled>;
  replyAdd?: InputMaybe<__InputSellerPostReply>;
  replyPin?: InputMaybe<__InputSellerPostBool>;
  replyUpdate?: InputMaybe<__InputSellerPostUpdate>;
  sellerId: Scalars['ObjectId']['input'];
  sellerInboxHandled?: InputMaybe<__InputSellerInboxHandled>;
  sellerLike?: InputMaybe<__InputSellerPostBool>;
};

export type __InputSellerPostBool = {
  active: Scalars['Boolean']['input'];
  postId: Scalars['ObjectId']['input'];
};

export type __InputSellerPostDisabled = {
  postId: Scalars['ObjectId']['input'];
  reason: Scalars['String']['input'];
};

export type __InputSellerPostReply = {
  comment: Scalars['String']['input'];
  replyMessageId: Scalars['ObjectId']['input'];
};

export type __InputSellerPostUpdate = {
  comment: Scalars['String']['input'];
  postId: Scalars['ObjectId']['input'];
};

export type __InputSellerPriceGroup = {
  create?: InputMaybe<__SellerPriceGroupInputCreate>;
  delete?: InputMaybe<__InputId>;
  priceSet?: InputMaybe<__InputSellerPriceGroupPrices>;
  sellerId: Scalars['ObjectId']['input'];
  update?: InputMaybe<__SellerPriceGroupInputUpdate>;
};

export type __InputSellerPriceGroupPrices = {
  departmentSlug?: InputMaybe<Scalars['String']['input']>;
  filters?: InputMaybe<Array<__PaginationInputFilters>>;
  priceGroupId: Scalars['ObjectId']['input'];
  productsMapped: Array<__SellerDiscountProductPricingInputMapped>;
  query?: InputMaybe<Scalars['String']['input']>;
  queryRegex?: InputMaybe<Scalars['Boolean']['input']>;
  removePrev: Scalars['Boolean']['input'];
  valueAll?: InputMaybe<__InputSellerPricesValue>;
};

export type __InputSellerPricesValue = {
  bulk?: InputMaybe<Array<__InputPriceVariantBulk>>;
  reduce?: InputMaybe<__InputSellerDiscountReduce>;
  remove?: InputMaybe<Scalars['Boolean']['input']>;
};

export type __InputSellerProductAdd = {
  departments: Array<Scalars['String']['input']>;
  descriptionShort: __InputText;
  descriptionTechnical: __InputText;
  media?: InputMaybe<__InputMediaProduct>;
  options2: Array<__InputProductPropertyVal4>;
  price: Scalars['Float']['input'];
  pricePrime?: InputMaybe<Scalars['Float']['input']>;
  sku: Scalars['String']['input'];
  stock: Scalars['Float']['input'];
  title: __InputText;
  volumeCategory: __EnumProductVolumeCategory;
  weightGrams: Scalars['Float']['input'];
};

export type __InputSellerProductCreate = {
  availibility: __InputProductAvailibility;
  departments: Array<Scalars['String']['input']>;
  descriptionShort: __InputText;
  descriptionTechnical: __InputText;
  info?: InputMaybe<__InputProductExtra>;
  media?: InputMaybe<__InputMediaProduct>;
  options2: Array<__InputProductPropertyVal4>;
  price: Scalars['Float']['input'];
  pricePrime?: InputMaybe<Scalars['Float']['input']>;
  productTypeId: Scalars['ObjectId']['input'];
  settingsQty?: InputMaybe<__InputProductSettingsQty>;
  sku: Scalars['String']['input'];
  stock: Scalars['Float']['input'];
  title: __InputText;
  volumeCategory: __EnumProductVolumeCategory;
  weightGrams: Scalars['Float']['input'];
};

export type __InputSellerProductEditUniform = {
  departments?: InputMaybe<Array<Scalars['String']['input']>>;
  groupIds: Array<Scalars['ObjectId']['input']>;
};

export type __InputSellerProductField = {
  create?: InputMaybe<__InputSellerProductFieldCreate>;
  delete?: InputMaybe<__InputId>;
  sellerId: Scalars['ObjectId']['input'];
  update?: InputMaybe<__InputSellerProductFieldUpdate>;
  valuesSet?: InputMaybe<__InputSellerProductFieldValuesSet>;
};

export type __InputSellerProductFieldCreate = {
  isNumber: Scalars['Boolean']['input'];
  isText: Scalars['Boolean']['input'];
  title: __InputText;
};

export type __InputSellerProductFieldUpdate = {
  _id: Scalars['ObjectId']['input'];
  expandInCatalog?: InputMaybe<__InputBool>;
  forceDisplayUi?: InputMaybe<__InputBool>;
  guideBodySet?: InputMaybe<__InputIdOptional>;
  guideProductSet?: InputMaybe<__InputId>;
  isColor?: InputMaybe<__InputBool>;
  showInEmail?: InputMaybe<__InputBool>;
  titleSet?: InputMaybe<__InputText>;
};

export type __InputSellerProductFieldValuesSet = {
  items: Array<__InputSellerProductFieldValuesSetItem>;
};

export type __InputSellerProductFieldValuesSetItem = {
  hsla?: InputMaybe<__InputDocumentColorHsla>;
  image?: InputMaybe<__ImageInput>;
  order: Scalars['Int']['input'];
  val4: __InputProductPropertyVal4;
};

export type __InputSellerProductFieldValuesUis = {
  fieldId: Scalars['ObjectId']['input'];
  includeDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  pagination: __InputPagination;
};

export type __InputSellerProductFind = {
  collectionId?: InputMaybe<Scalars['ObjectId']['input']>;
  departmentSlug?: InputMaybe<Scalars['String']['input']>;
  fieldValue?: InputMaybe<__InputProductsMultigetFieldValue>;
  groupId?: InputMaybe<Array<Scalars['ObjectId']['input']>>;
  priceGroupIds?: InputMaybe<Array<Scalars['ObjectId']['input']>>;
  productStats?: InputMaybe<Scalars['Boolean']['input']>;
  published?: InputMaybe<Scalars['Boolean']['input']>;
  showGroups?: InputMaybe<Scalars['Boolean']['input']>;
  visibilityId?: InputMaybe<Scalars['ObjectId']['input']>;
};

export type __InputSellerProductGroupAddVariant = {
  groupId: Scalars['ObjectId']['input'];
  variant: __InputSellerProductAdd;
};

export type __InputSellerProductInfo = {
  create?: InputMaybe<__InputSellerProductInfoCreate>;
  delete?: InputMaybe<__InputId>;
  sellerId: Scalars['ObjectId']['input'];
  update?: InputMaybe<__InputSellerProductInfoUpdate>;
};

export type __InputSellerProductInfoCreate = {
  name: Scalars['String']['input'];
  values: __InputSellerProductInfoValues;
};

export type __InputSellerProductInfoReturn = {
  duration?: InputMaybe<__InputDuration>;
  returnMessage: __InputText;
  returnTitle: __InputText;
  returnsDocument?: InputMaybe<__InputDocumentId>;
  returnsNotAllowed: Scalars['Boolean']['input'];
};

export type __InputSellerProductInfoUpdate = {
  id: Scalars['ObjectId']['input'];
  name: Scalars['String']['input'];
  values?: InputMaybe<__InputSellerProductInfoValues>;
};

export type __InputSellerProductInfoValues = {
  address?: InputMaybe<__InputSellerInfoAddress>;
  care?: InputMaybe<__InputProductExtraCare>;
  careIcon?: InputMaybe<__InputProductExtraCareIcon>;
  certificate?: InputMaybe<__InputProductCertificate>;
  details?: InputMaybe<__InputProductDetails>;
  fabric?: InputMaybe<__InputProductExtraFabric>;
  factory?: InputMaybe<__InputProductExtraFactory>;
  return?: InputMaybe<__InputSellerProductInfoReturn>;
  shop?: InputMaybe<__InputProductExtraShop>;
  stockLocation?: InputMaybe<__InputProductExtraStockLocation>;
  warranty?: InputMaybe<__InputProductWarranty>;
};

export type __InputSellerProductTypeCreate = {
  name: Scalars['String']['input'];
};

export type __InputSellerProductTypeCsv = {
  _id: Scalars['ObjectId']['input'];
  csvFieldValue?: InputMaybe<Scalars['String']['input']>;
};

export type __InputSellerProductTypeFields = {
  _id: Scalars['ObjectId']['input'];
  productFieldIds?: InputMaybe<Array<Scalars['ObjectId']['input']>>;
};

export type __InputSellerProductTypeMutate = {
  create?: InputMaybe<__InputSellerProductTypeCreate>;
  csv?: InputMaybe<__InputSellerProductTypeCsv>;
  delete?: InputMaybe<__InputId>;
  fields?: InputMaybe<__InputSellerProductTypeFields>;
  info?: InputMaybe<__InputSellerProductTypeUpdateInfo>;
  sellerId: Scalars['ObjectId']['input'];
  settingsQty?: InputMaybe<__InputSellerProductTypeQty>;
  update?: InputMaybe<__InputSellerProductTypeUpdate>;
};

export type __InputSellerProductTypeQty = {
  _id: Scalars['ObjectId']['input'];
  settingsQty?: InputMaybe<__InputProductSettingsQty>;
};

export type __InputSellerProductTypeRef = {
  _id: Scalars['ObjectId']['input'];
  name: Scalars['String']['input'];
};

export type __InputSellerProductTypeUpdate = {
  _id: Scalars['ObjectId']['input'];
  name: Scalars['String']['input'];
};

export type __InputSellerProductTypeUpdateInfo = {
  _id: Scalars['ObjectId']['input'];
  info?: InputMaybe<__InputProductExtra>;
};

export type __InputSellerProductUpdate = {
  _system_skuFileCheck?: InputMaybe<__InputSellerFile>;
  availibilitySet?: InputMaybe<__InputProductVariantAvailibiltySet>;
  create?: InputMaybe<__InputSellerProductCreate>;
  delete?: InputMaybe<__InputGroupId>;
  groupAddVariant?: InputMaybe<__InputSellerProductGroupAddVariant>;
  groupFeedAttr?: InputMaybe<__InputProductVariantFeedAttr>;
  groupGoogleProductCategory?: InputMaybe<__InputProductVariantGoogleProductCategory>;
  groupSetCollection?: InputMaybe<__InputSellerProductUpdateCollection>;
  groupSetDepartment?: InputMaybe<__ModelUpdateInput>;
  groupSetDocument?: InputMaybe<__SellerProductUpdateInputDocument>;
  groupSetInformation?: InputMaybe<__SellerProductUpdateInputInformation>;
  groupSetOptionUi?: InputMaybe<__InputSellerProductUpdateOptionUi>;
  groupSetVariantsDelete?: InputMaybe<__AssignVariantToProductDelete>;
  groupSetVariantsJoin?: InputMaybe<__InputSellerProductUpdateJoin>;
  groupSetVariantsSeperate?: InputMaybe<__AssignVariantToProductSeperate>;
  groupSettingsQty?: InputMaybe<__InputSellerProductUpdateSettingsQty>;
  groupVisibility?: InputMaybe<__InputVariantVisibility>;
  mediaSet?: InputMaybe<__InputMediaProductSet>;
  optionsSet?: InputMaybe<__InputProductVariantSetOptionsSet>;
  productEditMultiPerProduct?: InputMaybe<__InputSellerProductUpdateMany>;
  productEditMultiUniform?: InputMaybe<__InputSellerProductEditUniform>;
  productSync?: InputMaybe<__InputId>;
  productType?: InputMaybe<__InputSellerProductUpdateType>;
  productUpdateFromCsv?: InputMaybe<__InputSellerProductUpdateFromCsv>;
  productUpdateMulti?: InputMaybe<__InputSellerProductUpdateMulti>;
  productUpdateOne?: InputMaybe<__InputSellerProductUpdateOne>;
  productsChangeProductsValue?: InputMaybe<__InputSellerProductUpdateMultiChangeFieldValue>;
  productsProductsValueRemove?: InputMaybe<__InputProductPropertyVal4>;
  publish?: InputMaybe<__InputSellerProductUpdatePublish>;
  sellerId: Scalars['ObjectId']['input'];
  setMainVariant?: InputMaybe<__ProductMinVariantIdInput>;
  setPriceEntries?: InputMaybe<__InputProductPriceEntries>;
  setPriceVariants?: InputMaybe<__InputProductPrice>;
};

export type __InputSellerProductUpdateCollection = {
  collectionId?: InputMaybe<Scalars['ObjectId']['input']>;
  groupId: Scalars['ObjectId']['input'];
};

export type __InputSellerProductUpdateFromCsv = {
  create?: InputMaybe<Array<__InputSellerProductUpdateFromCsvItemCreate>>;
  update?: InputMaybe<Array<__InputSellerProductUpdateFromCsvItemUpdate>>;
};

export type __InputSellerProductUpdateFromCsvItemCreate = {
  sku?: InputMaybe<Scalars['String']['input']>;
  values: __InputSellerProductUpdateFromCsvItemValues;
};

export type __InputSellerProductUpdateFromCsvItemUpdate = {
  values: __InputSellerProductUpdateFromCsvItemValues;
  variantId: Scalars['ObjectId']['input'];
};

export type __InputSellerProductUpdateFromCsvItemValues = {
  descriptionShort?: InputMaybe<__InputText>;
  options?: InputMaybe<Array<__InputProductPropertyVal4>>;
  priceTaxfull?: InputMaybe<Scalars['Float']['input']>;
  priceTaxless?: InputMaybe<Scalars['Float']['input']>;
  productType?: InputMaybe<__InputSellerProductTypeRef>;
  skuNew?: InputMaybe<Scalars['String']['input']>;
  stock?: InputMaybe<Scalars['Float']['input']>;
  title?: InputMaybe<__InputText>;
  weightGrams?: InputMaybe<Scalars['Float']['input']>;
};

export type __InputSellerProductUpdateJoin = {
  groupId1: Scalars['ObjectId']['input'];
  groupIdsJoin: Array<Scalars['ObjectId']['input']>;
};

export type __InputSellerProductUpdateMany = {
  items: Array<__InputSellerProductUpdateManyItem>;
};

export type __InputSellerProductUpdateManyItem = {
  descriptionShort?: InputMaybe<__InputText>;
  descriptionTechnical?: InputMaybe<__InputText>;
  price?: InputMaybe<Scalars['Float']['input']>;
  sku?: InputMaybe<Scalars['String']['input']>;
  stock?: InputMaybe<Scalars['Float']['input']>;
  title?: InputMaybe<__InputText>;
  variantId: Scalars['ObjectId']['input'];
  volumeCategory?: InputMaybe<__EnumProductVolumeCategory>;
  weightGrams?: InputMaybe<Scalars['Float']['input']>;
};

export type __InputSellerProductUpdateMulti = {
  groupId: Scalars['ObjectId']['input'];
  item: Array<__InputSellerProductUpdateMultiItem>;
};

export type __InputSellerProductUpdateMultiChangeFieldValue = {
  next: __InputProductPropertyVal4;
  prev: __InputProductPropertyVal4;
};

export type __InputSellerProductUpdateMultiItem = {
  descriptionShort: __InputText;
  descriptionTechnical: __InputText;
  media: __InputMediaProduct;
  options: Array<__InputProductPropertyVal4>;
  price: Scalars['Float']['input'];
  priceGroups: Array<__InputProductPriceGroup>;
  pricePrime?: InputMaybe<Scalars['Float']['input']>;
  sku: Scalars['String']['input'];
  stock: Scalars['Float']['input'];
  title: __InputText;
  variantId: Scalars['ObjectId']['input'];
  volumeCategory: __EnumProductVolumeCategory;
  weightGrams: Scalars['Float']['input'];
};

export type __InputSellerProductUpdateOne = {
  values: __InputProductVariantSet;
  variantId: Scalars['ObjectId']['input'];
};

export type __InputSellerProductUpdateOptionUi = {
  fields: Array<__InputProductPropertyVal4FieldUi>;
  groupId: Scalars['ObjectId']['input'];
  values: Array<__InputSellerProductUpdateOptionUiValues>;
};

export type __InputSellerProductUpdateOptionUiValues = {
  image?: InputMaybe<__ImageInput>;
  order: Scalars['Int']['input'];
  val4Id: Scalars['String']['input'];
};

export type __InputSellerProductUpdatePublish = {
  activeIds: Array<Scalars['ObjectId']['input']>;
  groupId: Scalars['ObjectId']['input'];
};

export type __InputSellerProductUpdateSettingsQty = {
  groupId: Scalars['ObjectId']['input'];
  setting: __InputProductSettingsQty;
};

export type __InputSellerProductUpdateType = {
  groupId: Scalars['ObjectId']['input'];
  productTypeId?: InputMaybe<Scalars['ObjectId']['input']>;
};

export type __InputSellerProfiles = {
  contactsSet?: InputMaybe<__InputSellerProfilesContacts>;
  profileCreate?: InputMaybe<__InputSellerProfilesCreate>;
  profileDelete?: InputMaybe<__InputId>;
  profileUpdate?: InputMaybe<__InputSellerProfilesUpdate>;
  profileUpdateUser?: InputMaybe<__InputSellerProfilesUpdateUser>;
  sellerId: Scalars['ObjectId']['input'];
};

export type __InputSellerProfilesContacts = {
  contacts: __InputSellerContacts;
  profileId: Scalars['ObjectId']['input'];
};

export type __InputSellerProfilesCreate = {
  userId?: InputMaybe<Scalars['ObjectId']['input']>;
  values: __InputSellerProfilesValues;
};

export type __InputSellerProfilesUpdate = {
  _id: Scalars['ObjectId']['input'];
  values: __InputSellerProfilesValues;
};

export type __InputSellerProfilesUpdateUser = {
  _id: Scalars['ObjectId']['input'];
  userId: Scalars['ObjectId']['input'];
};

export type __InputSellerProfilesValues = {
  email?: InputMaybe<Scalars['String']['input']>;
  image?: InputMaybe<__ImageInput>;
  modelBust?: InputMaybe<Scalars['Float']['input']>;
  modelHeight?: InputMaybe<Scalars['Float']['input']>;
  modelHip?: InputMaybe<Scalars['Float']['input']>;
  modelWaist?: InputMaybe<Scalars['Float']['input']>;
  publicName: Scalars['String']['input'];
  tel?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  type: __EnumSellerProfileType;
};

export type __InputSellerQuote = {
  createQuote?: InputMaybe<__InputSellerQuoteCreate>;
  productsCalcRetailDiscount?: InputMaybe<__InputSellerQuoteUpdateProductsCalcRetailDiscount>;
  sellerId: Scalars['ObjectId']['input'];
  update?: InputMaybe<__InputSellerQuoteUpdate>;
};

export type __InputSellerQuoteCreate = {
  base: __InputSellerQuoteCreateBase;
  deliveryId?: InputMaybe<Scalars['ObjectId']['input']>;
  deliveryLockerId?: InputMaybe<Scalars['String']['input']>;
  expiration?: InputMaybe<__InputDate>;
  priceShipping: Scalars['Float']['input'];
  products: Array<__InputSellerOrderCreateProducts>;
  productsManual: Array<__InputSellerOrderCreateProductsManual>;
  skipProductsReservedStock: Scalars['Boolean']['input'];
};

export type __InputSellerQuoteCreateBase = {
  buyerEmail?: InputMaybe<Scalars['String']['input']>;
  buyerId?: InputMaybe<Scalars['ObjectId']['input']>;
  country: __InputBuyerAddressCountry;
  invoice?: InputMaybe<__InputBuyerInvoice>;
  shipping?: InputMaybe<__InputBuyerAddressValues>;
};

export type __InputSellerQuoteDelivery = {
  deliveryAt?: InputMaybe<__InputDate>;
  deliveryId: Scalars['ObjectId']['input'];
  incotermsAndDuties: __EnumIncoterms;
  price: Scalars['Float']['input'];
  weightGrams: Scalars['Int']['input'];
};

export type __InputSellerQuoteUpdate = {
  _id: Scalars['ObjectId']['input'];
  buyer?: InputMaybe<__InputSellerQuoteUpdateBuyer>;
  buyerReset?: InputMaybe<__InputBool>;
  cancel?: InputMaybe<__InputSellerQuoteUpdateCancel>;
  convertToOrder?: InputMaybe<__InputCheckoutQuoteUpdatePlaceOrder>;
  delivery?: InputMaybe<__InputSellerQuoteDelivery>;
  invoice?: InputMaybe<__SellerOrderDocEditsInvoice>;
  invoiceReset?: InputMaybe<__InputBool>;
  productsReset?: InputMaybe<__InputBool>;
  productsUpdate?: InputMaybe<__InputSellerQuoteUpdateProducts>;
  sendToCustomer?: InputMaybe<__InputBool>;
  setNote?: InputMaybe<__SellerOrderInputNote>;
  shippingAddressEdit?: InputMaybe<__SellerOrderDocEditsAddress>;
  shippingAddressReset?: InputMaybe<__InputBool>;
};

export type __InputSellerQuoteUpdateBuyer = {
  email?: InputMaybe<Scalars['String']['input']>;
  userId?: InputMaybe<Scalars['ObjectId']['input']>;
};

export type __InputSellerQuoteUpdateCancel = {
  reasonAdmin?: InputMaybe<Scalars['String']['input']>;
  reasonCustomer?: InputMaybe<Scalars['String']['input']>;
};

export type __InputSellerQuoteUpdateProducts = {
  products: Array<__InputSellerOrderCreateProducts>;
  productsManual: Array<__InputSellerOrderCreateProductsManual>;
  skipProductsReservedStock: Scalars['Boolean']['input'];
};

export type __InputSellerQuoteUpdateProductsCalcRetailDiscount = {
  create?: InputMaybe<__InputSellerQuoteCreateBase>;
  products: Array<__InputSellerOrderCreateProducts>;
  quoteId?: InputMaybe<Scalars['ObjectId']['input']>;
};

export type __InputSellerQuotesPagination = {
  all?: InputMaybe<Scalars['Boolean']['input']>;
  new?: InputMaybe<Scalars['Boolean']['input']>;
  unpayed?: InputMaybe<Scalars['Boolean']['input']>;
};

export type __InputSellerReturn = {
  bank?: InputMaybe<__InputSellerPayoutBankUpdate>;
  cancel?: InputMaybe<__InputSellerReturnCancel>;
  products?: InputMaybe<__InputSellerReturnProductInput>;
  received?: InputMaybe<__InputId>;
  returnAccepted?: InputMaybe<__InputId>;
  sellerId: Scalars['ObjectId']['input'];
};

export type __InputSellerReturnCancel = {
  cancel?: InputMaybe<__InputSellerReturnReason>;
  returnId: Scalars['ObjectId']['input'];
};

export type __InputSellerReturnFiles = {
  en?: InputMaybe<__InputSellerFile>;
  lt?: InputMaybe<__InputSellerFile>;
};

export type __InputSellerReturnProduct = {
  cancelReason?: InputMaybe<__InputSellerReturnReason>;
  qtyAccepted: Scalars['Float']['input'];
  restock: Scalars['Float']['input'];
  variantId: Scalars['ObjectId']['input'];
};

export type __InputSellerReturnProductInput = {
  products: Array<__InputSellerReturnProduct>;
  returnId: __InputId;
};

export type __InputSellerReturnReason = {
  code: Scalars['String']['input'];
  txt: __InputText;
};

export type __InputSellerReturns = {
  active?: InputMaybe<__InputBool>;
  buyerId?: InputMaybe<Scalars['ObjectId']['input']>;
  order?: InputMaybe<__OrderInput>;
  productId?: InputMaybe<Scalars['ObjectId']['input']>;
};

export type __InputSellerShippingDelay = {
  end?: InputMaybe<__InputDate>;
  start?: InputMaybe<__InputDate>;
};

export type __InputSellerSocialItem = {
  fullUrl: Scalars['String']['input'];
  handle: Scalars['String']['input'];
  type: __SocialLinkType;
};

export type __InputSellerSubscription = {
  sellerId: Scalars['ObjectId']['input'];
  updateOne?: InputMaybe<__InputSellerSubscriptionUpdateOne>;
};

export type __InputSellerSubscriptionUpdateOne = {
  id: Scalars['ObjectId']['input'];
  synced: Scalars['Boolean']['input'];
};

export type __InputSellerTextHelp = {
  text: Scalars['String']['input'];
  type: __EnumInputSellerTextHelp;
};

export type __InputSellerTextLink = {
  link?: InputMaybe<__InputSellerLink>;
  text?: InputMaybe<__InputText>;
};

export type __InputSellerUpdate = {
  _id: Scalars['ObjectId']['input'];
  aboutUs?: InputMaybe<__InputDocumentId>;
  adminInvite?: InputMaybe<__GodCreateAdminInput>;
  adminRemove?: InputMaybe<__InputId>;
  care?: InputMaybe<__InputDocumentId>;
  certificate?: InputMaybe<__InputDocumentId>;
  checkoutCompleted?: InputMaybe<__InputDocumentOrText>;
  checkoutType?: InputMaybe<__EnumSellerCheckoutType>;
  contacts?: InputMaybe<__InputSellerContacts>;
  cookiePolicy?: InputMaybe<__InputDocumentId>;
  emailSubs?: InputMaybe<__InputSellerUpdateEmailSubs>;
  fabrics?: InputMaybe<__InputDocumentId>;
  footerTxt?: InputMaybe<__InputText>;
  homeDocument?: InputMaybe<__InputDocumentId>;
  invoiceDetails?: InputMaybe<__InputSellerInvoiceDetails>;
  main?: InputMaybe<__InputSellerMain>;
  message?: InputMaybe<__SellerMessageInput>;
  navigation?: InputMaybe<__SellerNavigationInput>;
  off?: InputMaybe<__InputSellerDocOff>;
  privacyPolicy?: InputMaybe<__InputDocumentId>;
  productPrivateVisibility?: InputMaybe<__InputBool>;
  returnDocs?: InputMaybe<__InputSellerReturnFiles>;
  returns?: InputMaybe<__InputDocumentId>;
  sellerRemove?: InputMaybe<__InputId>;
  shipping?: InputMaybe<__InputDocumentId>;
  shippingDelay?: InputMaybe<__InputSellerShippingDelay>;
  storeAdd?: InputMaybe<__InputSellerAddImageSharing>;
  taxStrategy?: InputMaybe<__EnumSellerTaxStrategy>;
  termsAndConditions?: InputMaybe<__InputDocumentId>;
  warranty?: InputMaybe<__InputDocumentId>;
};

export type __InputSellerUpdateEmailSubs = {
  emails: Array<Scalars['String']['input']>;
};

export type __InputSeoProblemSettings = {
  allowRepeating: Scalars['Boolean']['input'];
  disableDescriptionCheck: Scalars['Boolean']['input'];
  disableKeywordMatch: Scalars['Boolean']['input'];
  id: Scalars['ObjectId']['input'];
};

export type __InputSeoProblems = {
  analyzeSettings?: InputMaybe<__InputSeoProblemsSettings>;
  keywordCreate?: InputMaybe<__InputString>;
  keywordRemove?: InputMaybe<__InputId>;
  keywordUpdate?: InputMaybe<__InputSeoProblemsKeyword>;
  recehck?: InputMaybe<__InputBool>;
  recehckIds?: InputMaybe<__InputSeoProblemsRececk>;
  sellerId: Scalars['ObjectId']['input'];
  settings?: InputMaybe<__InputSeoProblemSettings>;
};

export type __InputSeoProblemsKeyword = {
  _id: Scalars['ObjectId']['input'];
  keyword: Scalars['String']['input'];
};

export type __InputSeoProblemsRececk = {
  id: Scalars['ObjectId']['input'];
  target: __EnumSeoProblemTarget;
};

export type __InputSeoProblemsSearch = {
  input: __InputPagination;
  productGroupId?: InputMaybe<Scalars['ObjectId']['input']>;
};

export type __InputSeoProblemsSettings = {
  descriptionMax: Scalars['Int']['input'];
  descriptionMin: Scalars['Int']['input'];
};

export type __InputSizeGuide = {
  body?: InputMaybe<Scalars['Boolean']['input']>;
  pagination?: InputMaybe<__InputPagination>;
  product?: InputMaybe<Scalars['Boolean']['input']>;
};

export type __InputSlug = {
  slug: Scalars['String']['input'];
};

export type __InputString = {
  string: Scalars['String']['input'];
};

export type __InputSubscriptionsEmailingSettings = {
  newsletter?: InputMaybe<Scalars['Boolean']['input']>;
  reviewRemindersEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  sellerId: Scalars['ObjectId']['input'];
};

export type __InputText = {
  translations: Array<__StringTranslateInput>;
};

export type __InputUiPreviewBox = {
  get: Scalars['String']['input'];
  type: __UiPreviewBoxType;
};

export type __InputUpcomingEntry = {
  enter?: InputMaybe<__InputUpcomingEntryEnter>;
  remove?: InputMaybe<__InputUpcomingEntryRemove>;
};

export type __InputUpcomingEntryEnter = {
  addressId: Scalars['ObjectId']['input'];
  deliveryId?: InputMaybe<Scalars['ObjectId']['input']>;
  lockerId?: InputMaybe<Scalars['String']['input']>;
  paymentType: __PaymentType;
  productId: Scalars['String']['input'];
};

export type __InputUpcomingEntryRemove = {
  delete: Scalars['Boolean']['input'];
  productId: Scalars['ObjectId']['input'];
};

export type __InputVariantVisibility = {
  groupId: Scalars['ObjectId']['input'];
  visibility: __InputProductVisibility;
};

export type __LexicalTranslated = {
  translations: Array<__LexicalTranslatedValue>;
  value?: Maybe<__LexicalTranslatedValue>;
};

export type __LexicalTranslatedValue = {
  json: Scalars['String']['output'];
  lang: Scalars['String']['output'];
};

export type __LikesRef = {
  id: Scalars['ObjectId']['output'];
  total: Scalars['Int']['output'];
  type: __BuyerLikeType;
};

export type __ListingBoxImages = {
  id: Scalars['String']['output'];
  imageBox?: Maybe<__ImageNodeItem>;
  slug: Scalars['String']['output'];
};

export type __ListingOption = {
  hsla?: Maybe<__DocumentColorHsla>;
  id: Scalars['String']['output'];
  image?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
};

export type __Listings = __PaginatedResults & {
  info?: Maybe<__PaginationInfo>;
  items?: Maybe<Array<__ProductListingBox>>;
};

export type __ListingsDiscountPublicCode = {
  code?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['ObjectId']['output']>;
  percent?: Maybe<Scalars['Float']['output']>;
  reduceCombined?: Maybe<Scalars['Boolean']['output']>;
};

export type __LockersItem = {
  address?: Maybe<Scalars['String']['output']>;
  city?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  iso2: Scalars['String']['output'];
  postCode?: Maybe<Scalars['String']['output']>;
  provider: __EnumLockerProvider;
  provider2: Scalars['String']['output'];
  title?: Maybe<Scalars['String']['output']>;
};

export type __LoggingDoc = {
  _id: Scalars['ObjectId']['output'];
  action?: Maybe<__AppLogsInputAction>;
  ads?: Maybe<Scalars['Json']['output']>;
  entry?: Maybe<Scalars['String']['output']>;
  eventAt?: Maybe<Scalars['MongoDate']['output']>;
  label?: Maybe<Scalars['String']['output']>;
  utm?: Maybe<Scalars['Json']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

export type __LoggingDocs = __PaginatedResults & {
  info?: Maybe<__PaginationInfo>;
  items?: Maybe<Array<__LoggingDoc>>;
};

export type __MarketCountries = __PaginatedResults & {
  info?: Maybe<__PaginationInfo>;
  items?: Maybe<Array<__MarketCountry>>;
};

export type __MarketCountriesAll = {
  id: Scalars['String']['output'];
  items: Array<__MarketCountry>;
};

export type __MarketCountriesRef = {
  _country?: Maybe<Array<__MarketCountry>>;
  iso2: Array<Scalars['String']['output']>;
};

export type __MarketCountry = {
  _id: Scalars['ObjectId']['output'];
  altname?: Maybe<Array<Scalars['String']['output']>>;
  continent?: Maybe<__EnumCountryContinent>;
  id?: Maybe<Scalars['String']['output']>;
  img?: Maybe<__Image>;
  isEu?: Maybe<Scalars['Boolean']['output']>;
  iso2: Scalars['String']['output'];
  priority?: Maybe<Scalars['Boolean']['output']>;
  telCode?: Maybe<Scalars['String']['output']>;
  title: __Text;
  vat?: Maybe<Scalars['Float']['output']>;
};

export type __MarketCountryRegion = {
  code: Scalars['String']['output'];
  title: __Text;
  vat?: Maybe<Scalars['Float']['output']>;
};

export type __Me = {
  _id: Scalars['ObjectId']['output'];
  _notification?: Maybe<__BuyerNotification>;
  fullname: Scalars['String']['output'];
  isAuth: Scalars['Boolean']['output'];
  lang: Scalars['String']['output'];
  type: __UserType;
  user?: Maybe<__User>;
};

export type __MediaMeta = {
  audio?: Maybe<Scalars['Boolean']['output']>;
  duration?: Maybe<Scalars['Int']['output']>;
  format?: Maybe<Scalars['String']['output']>;
  height?: Maybe<Scalars['Int']['output']>;
  width?: Maybe<Scalars['Int']['output']>;
};

export type __MediaProduct = {
  images?: Maybe<Array<__ImageTagged>>;
};

export type __Message = {
  _id: Scalars['ObjectId']['output'];
  buyerId: Scalars['ObjectId']['output'];
  createdAt: Scalars['MongoDate']['output'];
  groupId: Scalars['ObjectId']['output'];
  kind: __MessageKind;
  notification?: Maybe<__MessageNotification>;
  readAt?: Maybe<Scalars['MongoDate']['output']>;
  seenAt?: Maybe<Scalars['MongoDate']['output']>;
  seller?: Maybe<__MessageSeller>;
  sellerId: Scalars['ObjectId']['output'];
};

export type __MessageB2BNotification = {
  businessId: Scalars['ObjectId']['output'];
};

export type __MessageB2BRequestNotification = {
  requestId: Scalars['ObjectId']['output'];
};

export const __MessageKind = {
  Notification: 'Notification'
} as const;

export type __MessageKind = typeof __MessageKind[keyof typeof __MessageKind];
export type __MessageNotification = {
  b2b?: Maybe<__MessageB2BNotification>;
  b2bRequest?: Maybe<__MessageB2BRequestNotification>;
  order?: Maybe<__MessageOrderNotification>;
  orderReturn?: Maybe<__MessageReturnNotification>;
  payment?: Maybe<__MessagePaymentNotification>;
  post?: Maybe<__MessagePostNotification>;
  product?: Maybe<__MessageProduct>;
  quote?: Maybe<__MessageQuoteNotification>;
  sourceAvailable: Scalars['Boolean']['output'];
  type: __MessageNotificationType;
};

export const __MessageNotificationType = {
  B2BCreated: 'B2BCreated',
  B2BRequestDenied: 'B2BRequestDenied',
  B2BRequestRegistered: 'B2BRequestRegistered',
  OrderAwaitingPayment: 'OrderAwaitingPayment',
  OrderCanceled: 'OrderCanceled',
  OrderCollectionReady: 'OrderCollectionReady',
  OrderCreatedOpenAccount: 'OrderCreatedOpenAccount',
  OrderReturned: 'OrderReturned',
  OrderReviewReminder: 'OrderReviewReminder',
  OrderShipped: 'OrderShipped',
  PaymentConfirmed: 'PaymentConfirmed',
  PaymentFailed: 'PaymentFailed',
  PaymentInvoiceReady: 'PaymentInvoiceReady',
  PaymentProcessing: 'PaymentProcessing',
  PaymentTransferWaiting: 'PaymentTransferWaiting',
  PaymentTransferWaitingWarning: 'PaymentTransferWaitingWarning',
  PostQuestionAnswered: 'PostQuestionAnswered',
  PostReplyAdded: 'PostReplyAdded',
  ProductBackInStock: 'ProductBackInStock',
  ProductPriceDropped: 'ProductPriceDropped',
  QuoteCanceled: 'QuoteCanceled',
  QuoteCreated: 'QuoteCreated',
  QuoteReviewDone: 'QuoteReviewDone',
  ReturnAccepted: 'ReturnAccepted',
  ReturnCanceled: 'ReturnCanceled',
  ReturnCreated: 'ReturnCreated',
  ReturnReceived: 'ReturnReceived'
} as const;

export type __MessageNotificationType = typeof __MessageNotificationType[keyof typeof __MessageNotificationType];
export type __MessageOrderNotification = {
  orderId: Scalars['ObjectId']['output'];
  orderPrettyId: Scalars['String']['output'];
  paymentId: Scalars['ObjectId']['output'];
};

export type __MessagePaymentNotification = {
  orderIds: Array<Scalars['ObjectId']['output']>;
  orderPrettyIds: Array<Scalars['String']['output']>;
  paymentId: Scalars['ObjectId']['output'];
};

export type __MessagePostNotification = {
  parentPostId?: Maybe<Scalars['ObjectId']['output']>;
  postId: Scalars['ObjectId']['output'];
  question?: Maybe<Scalars['String']['output']>;
  reply?: Maybe<Scalars['String']['output']>;
  rootPostId: Scalars['ObjectId']['output'];
  rootPostType?: Maybe<__SellerPostViewType>;
};

export type __MessageProduct = {
  _id: Scalars['ObjectId']['output'];
  image?: Maybe<__ImageNodeItem>;
  slug: Scalars['String']['output'];
  title: Scalars['String']['output'];
};

export type __MessageQuoteNotification = {
  quoteId: Scalars['ObjectId']['output'];
  quotePrettyId: Scalars['String']['output'];
};

export type __MessageResponse = __MutationResponeMsg & {
  responseInfo: __ResponseInfo;
  summary?: Maybe<__MessageSummary>;
  updated: Scalars['Int']['output'];
};

export type __MessageReturnNotification = {
  orderId: Scalars['ObjectId']['output'];
  orderPrettyId: Scalars['String']['output'];
  returnId: Scalars['ObjectId']['output'];
  returnPrettyId: Scalars['String']['output'];
};

export type __MessageSeller = {
  handle?: Maybe<Scalars['String']['output']>;
  image?: Maybe<__Image>;
  name?: Maybe<Scalars['String']['output']>;
  sellerId: Scalars['ObjectId']['output'];
};

export type __MessageSummary = {
  id: Scalars['ObjectId']['output'];
  unreadCount: Scalars['Int']['output'];
  unseenCount: Scalars['Int']['output'];
};

export type __Messages = {
  cursorNext?: Maybe<Scalars['String']['output']>;
  items: Array<__Message>;
  summary: __MessageSummary;
  throughCursor?: Maybe<Scalars['String']['output']>;
};

export type __ModelUpdateInput = {
  departments: Array<Scalars['String']['input']>;
  groupId: Scalars['ObjectId']['input'];
};

export type __Mutation = {
  adminAuth: __ResponseAuthBuyer;
  adminSubs?: Maybe<__ResponsSellerSubs>;
  appCountry?: Maybe<__ResponseMarketCountry>;
  appLogs?: Maybe<__AppLogsResult>;
  buyerAddress?: Maybe<__ResponseBuyerAddress>;
  buyerAuth: __ResponseAuthBuyer;
  buyerB2b?: Maybe<__ResponseBuyerB2b>;
  buyerBoard: __BuyerBoardResponse;
  buyerCart?: Maybe<__ResponseBuyerCart>;
  buyerCheckout: __BuyerCheckoutResponse;
  buyerCheckoutQuote: __ResponseCheckoutQuote;
  buyerGiftcard?: Maybe<__ResponseGiftcard>;
  buyerImageUpload: __ImageUploadUrlResponse;
  buyerInformation: __ResponseBuyerInformation;
  buyerLikes?: Maybe<__ResponseBuyerLikes>;
  buyerMessages?: Maybe<__MessageResponse>;
  buyerNotify: __ResponseBuyerNotify;
  buyerPayment: __BuyerSellerOrderResponse;
  buyerPaymentCard?: Maybe<__ResponseBuyerEverypayCard>;
  buyerPosts?: Maybe<__PostResponse>;
  buyerProductHistory?: Maybe<__ResponseBuyerProductHistory>;
  buyerReturn?: Maybe<__ResponseSellerReturn>;
  buyerSubscription?: Maybe<__ResponseBuyerSubscription>;
  buyerUpcomingEnter: __ResponseUpcomingEntry;
  sellerArticle?: Maybe<__ResponseSellerArticle>;
  sellerAuthInvitations?: Maybe<__ResponsSellerAdminInvitation>;
  sellerBundle?: Maybe<__SellerBundleResponse>;
  sellerBusiness?: Maybe<__ResponseSellerBusiness>;
  sellerBuyer?: Maybe<__ResponsSellerBuyer>;
  sellerCatalogUi?: Maybe<__SellerCatalogUiResponse>;
  sellerCatalogVisibility?: Maybe<__ResponseSellerCatalogVisibility>;
  sellerColors?: Maybe<__ResponsSellerColors>;
  sellerCreate?: Maybe<__SellerResponse>;
  sellerDelivery?: Maybe<__SellerDeliveryResponse>;
  sellerDeliveryZones?: Maybe<__ResponsSellerDeliveryZones>;
  sellerDepartments?: Maybe<__ResponseSellerDepartments>;
  sellerDiscount?: Maybe<__SellerDiscountResponse>;
  sellerDocument?: Maybe<__SellerDocumentResponse>;
  sellerDocumentsTemplates?: Maybe<__ResponsSellerDocumentTemplates>;
  sellerFaq?: Maybe<__SellerFaqResponse>;
  sellerFileUpload: __ImageUploadFileResponse;
  sellerImageUpload: __ImageUploadUrlResponse;
  sellerLinksOutside?: Maybe<__ResponsSellerLinks>;
  sellerOrderUpdate: __SellerOrderResponse;
  sellerPage: __SellerPageResponse;
  sellerPageSection: __SellerPageSectionResponse;
  sellerPayouts?: Maybe<__ResponseSellerPayouts>;
  sellerPosts?: Maybe<__PostResponse>;
  sellerPriceGroup?: Maybe<__ResponseSellerPriceGroup>;
  sellerProduct?: Maybe<__ResponseSellerProduct>;
  sellerProductField: __SellerProductFieldResponse;
  sellerProductInfo?: Maybe<__SellerProductInfoResponse>;
  sellerProductType?: Maybe<__ResponsProductType>;
  sellerProfiles?: Maybe<__ResposeSellerProfile>;
  sellerQuote?: Maybe<__ResponseSellerQuote>;
  sellerReturn?: Maybe<__ResponseSellerReturn>;
  sellerSeoProblems?: Maybe<__ResponsSeoProblems>;
  sellerSizeGuide?: Maybe<__SellerSizeGuideResponse>;
  sellerSubscription?: Maybe<__ResponseSellerSubscription>;
  sellerTextHelp: __ResponsSellerTextHelp;
  sellerUpdate?: Maybe<__SellerResponse>;
  systemActions: __GodActionsResponse;
  systemBankUpdate: __SystemBanksResponse;
  systemBlacklistingUpdate: __EmailBlacklistinResponse;
  systemPaymentUpdate: __PaymentProviderResponse;
};


export type __MutationAdminAuthArgs = {
  input: __InputAdminAuth;
};


export type __MutationAdminSubsArgs = {
  input: __InputAdminSubs;
};


export type __MutationAppCountryArgs = {
  input: __InputMarketCountry;
};


export type __MutationAppLogsArgs = {
  input: __AppLogsInput;
};


export type __MutationBuyerAddressArgs = {
  input: __InputBuyerAddress;
};


export type __MutationBuyerAuthArgs = {
  input: __InputBuyerAuth;
};


export type __MutationBuyerB2bArgs = {
  input: __InputBuyerBusiness;
};


export type __MutationBuyerBoardArgs = {
  input: __InputBuyerBoard;
};


export type __MutationBuyerCartArgs = {
  input: __InputBuyerCart;
};


export type __MutationBuyerCheckoutArgs = {
  input: __CheckoutDraftInput;
};


export type __MutationBuyerCheckoutQuoteArgs = {
  input: __InputCheckoutQuote;
};


export type __MutationBuyerGiftcardArgs = {
  input: __InputBuyerGiftcard;
};


export type __MutationBuyerImageUploadArgs = {
  input: __InputBuyerImage;
};


export type __MutationBuyerInformationArgs = {
  input: __InputBuyerInformation;
};


export type __MutationBuyerLikesArgs = {
  input: __InputBuyerLikes;
};


export type __MutationBuyerMessagesArgs = {
  input: __InputMessage;
};


export type __MutationBuyerNotifyArgs = {
  input: __InputBuyerNotify;
};


export type __MutationBuyerPaymentArgs = {
  input: __InputBuyerPayment;
};


export type __MutationBuyerPaymentCardArgs = {
  input: __InputBuyerEverypayCard;
};


export type __MutationBuyerPostsArgs = {
  input: __InputBuyerPost;
};


export type __MutationBuyerProductHistoryArgs = {
  input: __InputBuyerProductHistory;
};


export type __MutationBuyerReturnArgs = {
  input: __InputBuyerReturn;
};


export type __MutationBuyerSubscriptionArgs = {
  input: __InputBuyerSubscription;
};


export type __MutationBuyerUpcomingEnterArgs = {
  input: __InputUpcomingEntry;
};


export type __MutationSellerArticleArgs = {
  input: __InputSellerArticle;
};


export type __MutationSellerAuthInvitationsArgs = {
  input: __InputSellerAdminInvitation;
};


export type __MutationSellerBundleArgs = {
  input: __InputSellerBundle;
};


export type __MutationSellerBusinessArgs = {
  input: __InputSellerBusiness;
};


export type __MutationSellerBuyerArgs = {
  input: __InputAdminBuyerMutation;
};


export type __MutationSellerCatalogUiArgs = {
  input: __InputSellerCatalogUi;
};


export type __MutationSellerCatalogVisibilityArgs = {
  input: __InputSellerCatalogVisibility;
};


export type __MutationSellerColorsArgs = {
  input: __InputDocumentColorMutate;
};


export type __MutationSellerCreateArgs = {
  input: __InputSellerCreate;
};


export type __MutationSellerDeliveryArgs = {
  input: __SellerDeliveryInput;
};


export type __MutationSellerDeliveryZonesArgs = {
  input: __InputSellerDeliveryZones;
};


export type __MutationSellerDepartmentsArgs = {
  input: __InputSellerDepartments;
};


export type __MutationSellerDiscountArgs = {
  input: __InputSellerDiscount;
};


export type __MutationSellerDocumentArgs = {
  input: __SellerDocumentInput;
};


export type __MutationSellerDocumentsTemplatesArgs = {
  input: __InputSellerDocumentTemplate;
};


export type __MutationSellerFaqArgs = {
  input: __InputSellerFaq;
};


export type __MutationSellerFileUploadArgs = {
  input: __InputSellerFileMutate;
};


export type __MutationSellerImageUploadArgs = {
  input: __InputSellerImage;
};


export type __MutationSellerLinksOutsideArgs = {
  input: __InputSellerLinks;
};


export type __MutationSellerOrderUpdateArgs = {
  input: __InputSellerOrder;
};


export type __MutationSellerPageArgs = {
  input: __InputSellerPage;
};


export type __MutationSellerPageSectionArgs = {
  input: __InputSellerPageSection;
};


export type __MutationSellerPayoutsArgs = {
  input: __InputSellerPayout;
};


export type __MutationSellerPostsArgs = {
  input: __InputSellerPost;
};


export type __MutationSellerPriceGroupArgs = {
  input: __InputSellerPriceGroup;
};


export type __MutationSellerProductArgs = {
  input: __InputSellerProductUpdate;
};


export type __MutationSellerProductFieldArgs = {
  input: __InputSellerProductField;
};


export type __MutationSellerProductInfoArgs = {
  input: __InputSellerProductInfo;
};


export type __MutationSellerProductTypeArgs = {
  input: __InputSellerProductTypeMutate;
};


export type __MutationSellerProfilesArgs = {
  input: __InputSellerProfiles;
};


export type __MutationSellerQuoteArgs = {
  input: __InputSellerQuote;
};


export type __MutationSellerReturnArgs = {
  input: __InputSellerReturn;
};


export type __MutationSellerSeoProblemsArgs = {
  input: __InputSeoProblems;
};


export type __MutationSellerSizeGuideArgs = {
  input: __SellerSizeGuideInput;
};


export type __MutationSellerSubscriptionArgs = {
  input: __InputSellerSubscription;
};


export type __MutationSellerTextHelpArgs = {
  input: __InputSellerAi;
};


export type __MutationSellerUpdateArgs = {
  input: __InputSellerUpdate;
};


export type __MutationSystemActionsArgs = {
  input: __SystemActionsInput;
};


export type __MutationSystemBankUpdateArgs = {
  input: __SystemBankDetailsInput;
};


export type __MutationSystemBlacklistingUpdateArgs = {
  input: __EmailingUpdating;
};


export type __MutationSystemPaymentUpdateArgs = {
  input: __PaymentInput;
};

export type __MutationResponeMsg = {
  responseInfo: __ResponseInfo;
};

export type __OpeningHours = {
  fri?: Maybe<__OpeningHoursDay>;
  mon?: Maybe<__OpeningHoursDay>;
  sat?: Maybe<__OpeningHoursDay>;
  sun?: Maybe<__OpeningHoursDay>;
  thu?: Maybe<__OpeningHoursDay>;
  timezone?: Maybe<Scalars['String']['output']>;
  tue?: Maybe<__OpeningHoursDay>;
  wed?: Maybe<__OpeningHoursDay>;
};

export type __OpeningHoursDay = {
  close?: Maybe<Scalars['Boolean']['output']>;
  hours?: Maybe<Array<__OpeningHoursDayHours>>;
  open24?: Maybe<Scalars['Boolean']['output']>;
};

export type __OpeningHoursDayHours = {
  close: __OpeningHoursHour;
  open: __OpeningHoursHour;
};

export type __OpeningHoursHour = {
  hour: Scalars['Int']['output'];
  min: Scalars['Int']['output'];
};

export type __OrderDocDiscount = {
  code?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  msg?: Maybe<__Text>;
  name?: Maybe<Scalars['String']['output']>;
};

export type __OrderDocumentSent = {
  file?: Maybe<__SellerFile>;
  id: Scalars['String']['output'];
};

export type __OrderDraftDocGift = {
  giftComment?: Maybe<Scalars['String']['output']>;
  isGift?: Maybe<Scalars['Boolean']['output']>;
};

export type __OrderDraftUpdateInputStart = {
  start?: InputMaybe<Scalars['Boolean']['input']>;
};

export type __OrderInput = {
  prettyId: Scalars['String']['input'];
};

export type __OrderLockerInfo = {
  address?: Maybe<Scalars['String']['output']>;
  city?: Maybe<Scalars['String']['output']>;
  country?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  lockerId?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  postCode?: Maybe<Scalars['String']['output']>;
  provider?: Maybe<Scalars['String']['output']>;
};

export type __OrderPayPaypal = {
  paypalOrderId: Scalars['String']['output'];
  totalPrice: Scalars['Float']['output'];
  transactionId?: Maybe<Scalars['String']['output']>;
};

export type __OrderPayPaysera = {
  totalPrice: Scalars['Float']['output'];
  url: Scalars['String']['output'];
};

export type __OrderUiBox = {
  address?: Maybe<__BuyerAddress>;
  buyerType?: Maybe<__EnumBuyerType>;
  city?: Maybe<Scalars['String']['output']>;
  country?: Maybe<__BuyerAddressCountry>;
  coupon?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['MongoDate']['output']>;
  deliveryType?: Maybe<__SellerDeliveryType>;
  email?: Maybe<Scalars['String']['output']>;
  fullname?: Maybe<Scalars['String']['output']>;
  isAllowToReturn?: Maybe<Scalars['Boolean']['output']>;
  prettyId: Scalars['String']['output'];
  priceFinal?: Maybe<Scalars['String']['output']>;
  productCount?: Maybe<Scalars['Int']['output']>;
  productsManual?: Maybe<Array<__SellerOrderDocProduct>>;
  quoteId?: Maybe<Scalars['ObjectId']['output']>;
  status?: Maybe<__SellerOrderUiStatus>;
  statusPayment: __CheckoutPaymentStatus;
  statusUi: __SellerOrderStatusUi;
  tel: Scalars['String']['output'];
};

export type __OrdersPaginationOptions = {
  buyerId?: InputMaybe<Scalars['ObjectId']['input']>;
  deliveryId?: InputMaybe<Scalars['ObjectId']['input']>;
  discountId?: InputMaybe<Scalars['ObjectId']['input']>;
  paymentId?: InputMaybe<Scalars['ObjectId']['input']>;
  productId?: InputMaybe<Scalars['ObjectId']['input']>;
  type: __EnumOrdersPaginationOptions;
};

export const __PageBackground = {
  Contrast: 'contrast',
  Default: 'default',
  Muted: 'muted'
} as const;

export type __PageBackground = typeof __PageBackground[keyof typeof __PageBackground];
export const __PageContentWidth = {
  Contained: 'contained',
  Full: 'full',
  Wide: 'wide'
} as const;

export type __PageContentWidth = typeof __PageContentWidth[keyof typeof __PageContentWidth];
export type __PageGridBlock = {
  id: Scalars['String']['output'];
  image?: Maybe<__PageImageSection>;
  position: __PageGridPosition;
  richText?: Maybe<__PageRichTextSection>;
  type: __PageGridBlockType;
};

export type __PageGridBlockEditor = {
  id: Scalars['String']['output'];
  image?: Maybe<__PageImageSection>;
  position: __PageGridPosition;
  richText?: Maybe<__PageRichTextEditor>;
  type: __PageGridBlockType;
};

export const __PageGridBlockType = {
  Image: 'image',
  RichText: 'richText'
} as const;

export type __PageGridBlockType = typeof __PageGridBlockType[keyof typeof __PageGridBlockType];
export type __PageGridEditor = {
  blocks: Array<__PageGridBlockEditor>;
  columns: Scalars['Int']['output'];
  gap?: Maybe<__PageSpacing>;
  rows: Scalars['Int']['output'];
};

export type __PageGridPosition = {
  column: Scalars['Int']['output'];
  columnSpan: Scalars['Int']['output'];
  row: Scalars['Int']['output'];
  rowSpan: Scalars['Int']['output'];
};

export type __PageGridSection = {
  blocks: Array<__PageGridBlock>;
  columns: Scalars['Int']['output'];
  gap?: Maybe<__PageSpacing>;
  rows: Scalars['Int']['output'];
};

export type __PageHeroAction = {
  href: Scalars['String']['output'];
  id: Scalars['String']['output'];
  label: Scalars['String']['output'];
  variant: __PageHeroActionVariant;
};

export const __PageHeroActionVariant = {
  Primary: 'primary',
  Secondary: 'secondary'
} as const;

export type __PageHeroActionVariant = typeof __PageHeroActionVariant[keyof typeof __PageHeroActionVariant];
export type __PageHeroEditor = {
  actions?: Maybe<Array<__PageHeroAction>>;
  description?: Maybe<__LexicalTranslated>;
  descriptionHtml?: Maybe<Scalars['String']['output']>;
  focalPoint?: Maybe<__PageHeroFocalPoint>;
  headingLevel?: Maybe<__PageHeroHeadingLevel>;
  height?: Maybe<__PageHeroHeight>;
  horizontalAlign?: Maybe<__PageHeroHorizontalAlign>;
  image: __Image;
  mobileFocalPoint?: Maybe<__PageHeroFocalPoint>;
  mobileImage?: Maybe<__Image>;
  overlay?: Maybe<__PageHeroOverlay>;
  title: Scalars['String']['output'];
  verticalAlign?: Maybe<__PageHeroVerticalAlign>;
};

export type __PageHeroFocalPoint = {
  x: Scalars['Float']['output'];
  y: Scalars['Float']['output'];
};

export const __PageHeroHeadingLevel = {
  H1: 'h1',
  H2: 'h2'
} as const;

export type __PageHeroHeadingLevel = typeof __PageHeroHeadingLevel[keyof typeof __PageHeroHeadingLevel];
export const __PageHeroHeight = {
  Compact: 'compact',
  Regular: 'regular',
  Tall: 'tall'
} as const;

export type __PageHeroHeight = typeof __PageHeroHeight[keyof typeof __PageHeroHeight];
export const __PageHeroHorizontalAlign = {
  Center: 'center',
  Left: 'left'
} as const;

export type __PageHeroHorizontalAlign = typeof __PageHeroHorizontalAlign[keyof typeof __PageHeroHorizontalAlign];
export const __PageHeroOverlay = {
  Dark: 'dark',
  Light: 'light'
} as const;

export type __PageHeroOverlay = typeof __PageHeroOverlay[keyof typeof __PageHeroOverlay];
export type __PageHeroSection = {
  actions?: Maybe<Array<__PageHeroAction>>;
  descriptionHtml?: Maybe<Scalars['String']['output']>;
  focalPoint?: Maybe<__PageHeroFocalPoint>;
  headingLevel?: Maybe<__PageHeroHeadingLevel>;
  height?: Maybe<__PageHeroHeight>;
  horizontalAlign?: Maybe<__PageHeroHorizontalAlign>;
  image: __Image;
  mobileFocalPoint?: Maybe<__PageHeroFocalPoint>;
  mobileImage?: Maybe<__Image>;
  overlay?: Maybe<__PageHeroOverlay>;
  title: Scalars['String']['output'];
  verticalAlign?: Maybe<__PageHeroVerticalAlign>;
};

export const __PageHeroVerticalAlign = {
  Bottom: 'bottom',
  Center: 'center'
} as const;

export type __PageHeroVerticalAlign = typeof __PageHeroVerticalAlign[keyof typeof __PageHeroVerticalAlign];
export const __PageImagePosition = {
  Left: 'left',
  Right: 'right'
} as const;

export type __PageImagePosition = typeof __PageImagePosition[keyof typeof __PageImagePosition];
export const __PageImagePresentation = {
  Banner: 'banner',
  Natural: 'natural'
} as const;

export type __PageImagePresentation = typeof __PageImagePresentation[keyof typeof __PageImagePresentation];
export type __PageImageSection = {
  media: __Image;
  presentation?: Maybe<__PageImagePresentation>;
};

export type __PageInfo = {
  currentPage: Scalars['Int']['output'];
  hasNext: Scalars['Boolean']['output'];
  hasPrevious: Scalars['Boolean']['output'];
  pageSize: Scalars['Int']['output'];
  totalCount: Scalars['Int']['output'];
  totalPageCount: Scalars['Int']['output'];
};

export type __PageListingCard = {
  badge?: Maybe<Scalars['String']['output']>;
  departmentName?: Maybe<Scalars['String']['output']>;
  href: Scalars['String']['output'];
  id: Scalars['String']['output'];
  image: __Image;
  priceForHumans?: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
};

export type __PageProductGridSection = {
  columns?: Maybe<Scalars['Int']['output']>;
  limit?: Maybe<Scalars['Int']['output']>;
  source: __PageProductGridSource;
  title?: Maybe<Scalars['String']['output']>;
};

export type __PageProductGridSource = {
  categoryId?: Maybe<Scalars['String']['output']>;
  listingIds?: Maybe<Array<Scalars['String']['output']>>;
  type: __PageProductGridSourceType;
};

export const __PageProductGridSourceType = {
  Category: 'category',
  Manual: 'manual'
} as const;

export type __PageProductGridSourceType = typeof __PageProductGridSourceType[keyof typeof __PageProductGridSourceType];
export type __PageRichTextEditor = {
  align?: Maybe<__PageTextAlign>;
  html?: Maybe<Scalars['String']['output']>;
  text: __LexicalTranslated;
  textWidth?: Maybe<__PageTextWidth>;
};

export type __PageRichTextSection = {
  align?: Maybe<__PageTextAlign>;
  html: Scalars['String']['output'];
  textWidth?: Maybe<__PageTextWidth>;
};

export type __PageSection = {
  grid?: Maybe<__PageGridSection>;
  hero?: Maybe<__PageHeroSection>;
  id: Scalars['String']['output'];
  image?: Maybe<__PageImageSection>;
  items?: Maybe<Array<__PageListingCard>>;
  productGrid?: Maybe<__PageProductGridSection>;
  richText?: Maybe<__PageRichTextSection>;
  settings?: Maybe<__PageSectionSettings>;
  slider?: Maybe<__PageSliderSection>;
  textImage?: Maybe<__PageTextImageSection>;
  type: __PageSectionType;
};

export type __PageSectionSettings = {
  background?: Maybe<__PageBackground>;
  contentWidth?: Maybe<__PageContentWidth>;
  spacing?: Maybe<__PageSpacing>;
};

export const __PageSectionType = {
  Grid: 'grid',
  Hero: 'hero',
  Image: 'image',
  ProductGrid: 'productGrid',
  RichText: 'richText',
  Slider: 'slider',
  TextImage: 'textImage'
} as const;

export type __PageSectionType = typeof __PageSectionType[keyof typeof __PageSectionType];
export const __PageSliderAspectRatio = {
  Landscape: 'landscape',
  Square: 'square',
  Wide: 'wide'
} as const;

export type __PageSliderAspectRatio = typeof __PageSliderAspectRatio[keyof typeof __PageSliderAspectRatio];
export type __PageSliderSection = {
  aspectRatio?: Maybe<__PageSliderAspectRatio>;
  label?: Maybe<Scalars['String']['output']>;
  showArrows?: Maybe<Scalars['Boolean']['output']>;
  slides: Array<__PageSliderSlide>;
};

export type __PageSliderSlide = {
  caption?: Maybe<Scalars['String']['output']>;
  href?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  image: __Image;
};

export const __PageSpacing = {
  Lg: 'lg',
  Md: 'md',
  None: 'none',
  Sm: 'sm'
} as const;

export type __PageSpacing = typeof __PageSpacing[keyof typeof __PageSpacing];
export const __PageTextAlign = {
  Center: 'center',
  Left: 'left'
} as const;

export type __PageTextAlign = typeof __PageTextAlign[keyof typeof __PageTextAlign];
export type __PageTextImageEditor = {
  html?: Maybe<Scalars['String']['output']>;
  image: __Image;
  imagePosition: __PageImagePosition;
  ratio?: Maybe<Scalars['String']['output']>;
  text: __LexicalTranslated;
  verticalAlign?: Maybe<__PageTextImageVerticalAlign>;
};

export type __PageTextImageSection = {
  html: Scalars['String']['output'];
  image: __Image;
  imagePosition: __PageImagePosition;
  ratio?: Maybe<Scalars['String']['output']>;
  verticalAlign?: Maybe<__PageTextImageVerticalAlign>;
};

export const __PageTextImageVerticalAlign = {
  Center: 'center',
  Start: 'start'
} as const;

export type __PageTextImageVerticalAlign = typeof __PageTextImageVerticalAlign[keyof typeof __PageTextImageVerticalAlign];
export const __PageTextWidth = {
  Readable: 'readable',
  Wide: 'wide'
} as const;

export type __PageTextWidth = typeof __PageTextWidth[keyof typeof __PageTextWidth];
export type __PaginatedResults = {
  info?: Maybe<__PaginationInfo>;
};

export type __PaginationAutocomplete = {
  count?: Maybe<Scalars['Int']['output']>;
  key: Scalars['String']['output'];
};

export type __PaginationFilters = {
  key: Scalars['String']['output'];
  name: Scalars['String']['output'];
  options?: Maybe<__PaginationFiltersOption>;
  type: __FilterType;
};

export type __PaginationFiltersNumber = {
  max?: Maybe<Scalars['Int']['output']>;
  min?: Maybe<Scalars['Int']['output']>;
};

export type __PaginationFiltersOption = {
  choices?: Maybe<Array<__PaginationFiltersOptionChoices>>;
  number?: Maybe<__PaginationFiltersNumber>;
};

export type __PaginationFiltersOptionChoices = {
  key: Scalars['String']['output'];
  msg?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
};

export type __PaginationInfo = {
  autocomplete?: Maybe<Array<__PaginationAutocomplete>>;
  autocompleteExists?: Maybe<Scalars['Boolean']['output']>;
  filters?: Maybe<Array<__PaginationFilters>>;
  getFiltersAsync?: Maybe<__PaginationFilters>;
  init?: Maybe<__PaginationInfoInit>;
  pageInfo?: Maybe<__PageInfo>;
  sorting?: Maybe<Array<__PaginationSorting>>;
};

export type __PaginationInfoInit = {
  hasFilters: Scalars['Boolean']['output'];
  hasSearch: Scalars['Boolean']['output'];
  hasSorting: Scalars['Boolean']['output'];
};

export type __PaginationInputFilters = {
  key: Scalars['String']['input'];
  value: __PaginationInputFiltersValue;
};

export type __PaginationInputFiltersValue = {
  bool?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['Int']['input']>;
  lt?: InputMaybe<Scalars['Int']['input']>;
  string?: InputMaybe<Scalars['String']['input']>;
  values?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type __PaginationSorting = {
  field: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export type __PaginationSortingInput = {
  field: Scalars['String']['input'];
  order: __PaginationSortingOrder;
};

export const __PaginationSortingOrder = {
  Asc: 'Asc',
  Desc: 'Desc'
} as const;

export type __PaginationSortingOrder = typeof __PaginationSortingOrder[keyof typeof __PaginationSortingOrder];
export type __PaymentDocPayEverypay = {
  _full?: Maybe<__PaymentDocPayEverypayFull>;
  completed?: Maybe<Scalars['Boolean']['output']>;
  initialAmount: Scalars['Float']['output'];
  paymentLink?: Maybe<Scalars['String']['output']>;
  referenceId: Scalars['String']['output'];
};

export type __PaymentDocPayEverypayFull = {
  accountName: Scalars['String']['output'];
  apiUsername: Scalars['String']['output'];
  appleMerchantId: Scalars['String']['output'];
  countryCode: Scalars['String']['output'];
  currencyCode: Scalars['String']['output'];
  mobileAccessToken?: Maybe<Scalars['String']['output']>;
  paymentReference: Scalars['String']['output'];
  totalAmount: Scalars['Float']['output'];
};

export type __PaymentDocUi = {
  transferCompleted: Scalars['Boolean']['output'];
};

export type __PaymentInput = {
  paymentCancel?: InputMaybe<__InputPayCancel>;
  paymentEverypayRecheck?: InputMaybe<__InputPayRecheck>;
  paymentReceived?: InputMaybe<__PaymentInputBank>;
  sellerId: Scalars['ObjectId']['input'];
  updateBankTransferDate?: InputMaybe<__PaymentInputBank>;
};

export type __PaymentInputBank = {
  note?: InputMaybe<Scalars['String']['input']>;
  payId?: InputMaybe<Scalars['ObjectId']['input']>;
  paymentId: Scalars['ObjectId']['input'];
  transferDate?: InputMaybe<__InputDate>;
};

export type __PaymentInvoiceDoc = {
  _buyerGiftcard?: Maybe<__Giftcard>;
  _buyerUpcoming?: Maybe<__UpcomingEntry>;
  _id: Scalars['ObjectId']['output'];
  _paymentProviders?: Maybe<Array<__PaymentProviderDoc>>;
  createdAt?: Maybe<Scalars['MongoDate']['output']>;
  history?: Maybe<Array<__CheckoutPaymentHistoryItem>>;
  invoice: __BuyerInvoice;
  modifications?: Maybe<Array<__PaymentPaymentModification>>;
  prices: __PaymentPrices;
  status?: Maybe<__CheckoutPaymentStatus>;
  ui?: Maybe<__PaymentInvoiceDocUi>;
  updatedAt?: Maybe<Scalars['MongoDate']['output']>;
  userId?: Maybe<Scalars['ObjectId']['output']>;
};

export type __PaymentInvoiceDocCount = {
  id: Scalars['String']['output'];
  payments: Scalars['Int']['output'];
  quote: Scalars['Int']['output'];
  toReview: Scalars['Int']['output'];
};

export type __PaymentInvoiceDocUi = {
  billing?: Maybe<__BuyerAddress>;
  changePaymentMethod: Scalars['Boolean']['output'];
  checkoutContinue?: Maybe<Scalars['ObjectId']['output']>;
  expiration?: Maybe<Scalars['MongoDate']['output']>;
  forCheckout: Scalars['Boolean']['output'];
  forGiftCard: Scalars['Boolean']['output'];
  forUpcoming: Scalars['Boolean']['output'];
  fullname: Scalars['String']['output'];
  invoiceNr?: Maybe<Scalars['String']['output']>;
  isUserTransferMade: Scalars['Boolean']['output'];
  payId?: Maybe<Scalars['ObjectId']['output']>;
  payType?: Maybe<__PaymentType>;
  paymentAttmentsCount?: Maybe<Scalars['Int']['output']>;
  paymentCompleted: Scalars['Boolean']['output'];
  paymentForId: Scalars['ObjectId']['output'];
  providerError?: Maybe<Scalars['Boolean']['output']>;
  shippingAddress?: Maybe<__BuyerAddress>;
  transferTotal: __Price2Total;
};

export type __PaymentInvoicesPagination = __PaginatedResults & {
  info?: Maybe<__PaginationInfo>;
  items?: Maybe<Array<__PaymentInvoiceDoc>>;
};

export type __PaymentOpenAccount = {
  invoiceNr: Scalars['String']['output'];
  payUntil?: Maybe<Scalars['MongoDate']['output']>;
  paymentDelayDays?: Maybe<Scalars['Int']['output']>;
  price?: Maybe<Scalars['Float']['output']>;
  uiPrice?: Maybe<__Price2>;
};

export type __PaymentPayOptions = {
  applePay: Scalars['Boolean']['output'];
  everypayLinks: Array<__PaymentPayOptionsEverypayLinks>;
  googlePay: Scalars['Boolean']['output'];
  oneoff: Scalars['Boolean']['output'];
};

export type __PaymentPayOptionsEverypayLinks = {
  available: Scalars['Boolean']['output'];
  iso2: Scalars['String']['output'];
  logoUrl: Scalars['String']['output'];
  name: Scalars['String']['output'];
  paymentLink: Scalars['String']['output'];
  source: Scalars['String']['output'];
  tokenizationSupported: Scalars['Boolean']['output'];
};

export type __PaymentPaymentModification = {
  at: Scalars['MongoDate']['output'];
  msg: Scalars['String']['output'];
  status: __EnumPaymentPaymentModification;
};

export type __PaymentPrices = {
  _ui?: Maybe<__PaymentPricesUi>;
  final: Scalars['Float']['output'];
};

export type __PaymentPricesUi = {
  delivery: __Price2;
  deliveryOld?: Maybe<__Price2>;
  final: __Price2;
  giftcards?: Maybe<__Price2>;
  isTaxed: Scalars['Boolean']['output'];
  productOld?: Maybe<__Price2>;
  products: __Price2;
  taxInfo: __BuyerTaxInfo;
  taxesPayed: __Price2;
  taxfull: __Price2;
  taxfullTaxes: __Price2;
  taxless: __Price2;
  totalSavings?: Maybe<__Price2>;
};

export type __PaymentProviderDoc = {
  _id: Scalars['ObjectId']['output'];
  _options?: Maybe<__PaymentPayOptions>;
  createdAt?: Maybe<Scalars['MongoDate']['output']>;
  everypay?: Maybe<__PaymentDocPayEverypay>;
  history?: Maybe<Array<__CheckoutPaymentHistoryItem>>;
  isUserTransferMade?: Maybe<Scalars['Boolean']['output']>;
  openAccount?: Maybe<__PaymentOpenAccount>;
  paypal?: Maybe<__OrderPayPaypal>;
  paysera?: Maybe<__OrderPayPaysera>;
  prices: __PaymentPrices;
  status?: Maybe<__CheckoutPaymentStatus>;
  transfer?: Maybe<__BankTransferInvoice>;
  transferDate?: Maybe<Scalars['MongoDate']['output']>;
  type: __PaymentType;
  ui?: Maybe<__PaymentDocUi>;
  updatedAt?: Maybe<Scalars['MongoDate']['output']>;
  userId?: Maybe<Scalars['ObjectId']['output']>;
};

export type __PaymentProviderResponse = __MutationResponeMsg & {
  deleted?: Maybe<Scalars['Boolean']['output']>;
  invoice?: Maybe<__PaymentInvoiceDoc>;
  provider?: Maybe<__PaymentProviderDoc>;
  responseInfo: __ResponseInfo;
};

export type __PaymentProvidersPagination = __PaginatedResults & {
  info?: Maybe<__PaginationInfo>;
  items?: Maybe<Array<__PaymentProviderDoc>>;
};

export const __PaymentSimple = {
  Fail: 'Fail',
  Pending: 'Pending',
  Success: 'Success'
} as const;

export type __PaymentSimple = typeof __PaymentSimple[keyof typeof __PaymentSimple];
export const __PaymentType = {
  BankTransfer: 'BankTransfer',
  Everypay: 'Everypay',
  GiftCard: 'GiftCard',
  Manual: 'Manual',
  OpenAccount: 'OpenAccount',
  Paypal: 'Paypal',
  Paysera: 'Paysera'
} as const;

export type __PaymentType = typeof __PaymentType[keyof typeof __PaymentType];
export type __Post = {
  _id: Scalars['ObjectId']['output'];
  _owner?: Maybe<__PostOwner>;
  _reference?: Maybe<__PostReviewReference>;
  _typecheck: Scalars['Int']['output'];
  comment: Scalars['String']['output'];
  createdAt?: Maybe<Scalars['MongoDate']['output']>;
  disableReason?: Maybe<Scalars['String']['output']>;
  emailNotificationsEnabled?: Maybe<Scalars['Boolean']['output']>;
  images?: Maybe<Array<__Image>>;
  isComment?: Maybe<Scalars['Boolean']['output']>;
  isEdited?: Maybe<Scalars['Boolean']['output']>;
  isQuestion?: Maybe<Scalars['Boolean']['output']>;
  isReview?: Maybe<Scalars['Boolean']['output']>;
  iso2?: Maybe<Scalars['String']['output']>;
  lang: Scalars['String']['output'];
  likes?: Maybe<__LikesRef>;
  order?: Maybe<__PostReviewOrder>;
  pinedReply?: Maybe<__Post>;
  rating?: Maybe<__PostReviewRating>;
  repliedTo?: Maybe<__Post>;
  repliedToDeleted?: Maybe<Scalars['Boolean']['output']>;
  replies?: Maybe<Scalars['Int']['output']>;
  reportedBy?: Maybe<Array<Scalars['String']['output']>>;
  sellerInbox?: Maybe<__PostSellerInbox>;
  sellerLiked: Scalars['Boolean']['output'];
  sellerReplied?: Maybe<Scalars['Boolean']['output']>;
  status?: Maybe<__EnumPostStatus>;
};

export type __PostArticleCommentOverview = {
  id: Scalars['String']['output'];
  totalCount: Scalars['Int']['output'];
};

export type __PostCursorInput = {
  cursorNext?: InputMaybe<Scalars['String']['input']>;
  find: __InputPostsFind;
  findRating?: InputMaybe<Scalars['Int']['input']>;
  size?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<__PostSort>;
};

export const __PostGetInputType = {
  ArticleComments: 'ArticleComments',
  ProductReviews: 'ProductReviews',
  Questions: 'Questions',
  Replies: 'Replies',
  SellerReviews: 'SellerReviews'
} as const;

export type __PostGetInputType = typeof __PostGetInputType[keyof typeof __PostGetInputType];
export type __PostNodes = {
  countries?: Maybe<__MarketCountriesRef>;
  posts: Array<__Post>;
};

export type __PostOwner = {
  handle?: Maybe<Scalars['String']['output']>;
  publicName: Scalars['String']['output'];
  sellerId?: Maybe<Scalars['String']['output']>;
  userId?: Maybe<Scalars['String']['output']>;
};

export type __PostQuestionsOverview = {
  answeredCount: Scalars['Int']['output'];
  id: Scalars['String']['output'];
  totalCount: Scalars['Int']['output'];
};

export type __PostResponse = __MutationResponeMsg & {
  deleted?: Maybe<Scalars['Boolean']['output']>;
  doc?: Maybe<__Post>;
  docParent?: Maybe<__Post>;
  ref?: Maybe<__BuyerPostRef>;
  responseInfo: __ResponseInfo;
};

export type __PostReviewOrder = {
  orderedAt?: Maybe<Scalars['MongoDate']['output']>;
  prettyId?: Maybe<Scalars['String']['output']>;
};

export type __PostReviewRating = {
  count?: Maybe<Scalars['Int']['output']>;
  delivery?: Maybe<Scalars['Int']['output']>;
  fit?: Maybe<Scalars['Int']['output']>;
  match?: Maybe<Scalars['Int']['output']>;
  quality?: Maybe<Scalars['Int']['output']>;
  rating?: Maybe<Scalars['Int']['output']>;
  recommend?: Maybe<Scalars['Int']['output']>;
  seller?: Maybe<Scalars['Int']['output']>;
};

export type __PostReviewReference = {
  _id: Scalars['ObjectId']['output'];
  img?: Maybe<__ImageNodeItem>;
  isArticle?: Maybe<Scalars['Boolean']['output']>;
  isProduct?: Maybe<Scalars['Boolean']['output']>;
  slug: Scalars['String']['output'];
  title: Scalars['String']['output'];
};

export type __PostReviewsOverview = {
  hasPhotos?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['String']['output'];
  productReviewCount?: Maybe<Scalars['Int']['output']>;
  rating1: __PostReviewsOverviewStarStats;
  rating2: __PostReviewsOverviewStarStats;
  rating3: __PostReviewsOverviewStarStats;
  rating4: __PostReviewsOverviewStarStats;
  rating5: __PostReviewsOverviewStarStats;
  reviewValues?: Maybe<__PostReviewRating>;
  sellerReviewCount?: Maybe<Scalars['Int']['output']>;
};

export type __PostReviewsOverviewStarStats = {
  count: Scalars['Int']['output'];
  percent: Scalars['Int']['output'];
};

export type __PostReviewsPhotos = {
  cursorNext?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  images: Array<__PostReviewsPhotosItem>;
};

export type __PostReviewsPhotosItem = {
  image: __Image;
  imageCount: Scalars['Int']['output'];
  reviewId: Scalars['ObjectId']['output'];
};

export type __PostSellerInbox = {
  handledAt?: Maybe<Scalars['MongoDate']['output']>;
  handledBy?: Maybe<Scalars['ObjectId']['output']>;
  latestCustomerPostAt: Scalars['MongoDate']['output'];
  latestCustomerPostId: Scalars['ObjectId']['output'];
  needsAttention: Scalars['Boolean']['output'];
};

export const __PostSort = {
  Default: 'Default',
  Newest: 'Newest',
  Oldest: 'Oldest'
} as const;

export type __PostSort = typeof __PostSort[keyof typeof __PostSort];
export type __Posts = {
  cursorNext?: Maybe<Scalars['String']['output']>;
  findRating?: Maybe<Scalars['Int']['output']>;
  items: Array<__Post>;
  sort?: Maybe<__PostSort>;
};

export type __PostsPagination = __PaginatedResults & {
  info?: Maybe<__PaginationInfo>;
  items?: Maybe<Array<__Post>>;
};

export type __Price2 = {
  price: Scalars['Float']['output'];
  total?: Maybe<__Price2Total>;
};

export type __Price2Total = {
  currency: Scalars['String']['output'];
  currencySign: Scalars['String']['output'];
  isNull?: Maybe<Scalars['Boolean']['output']>;
  isPositive?: Maybe<Scalars['Boolean']['output']>;
  number: Scalars['Float']['output'];
  priceForHumans: Scalars['String']['output'];
};

export type __PriceGroup = {
  bulk?: Maybe<Array<__PriceVariantBulk>>;
  bundle?: Maybe<Array<__PriceVariantBundle>>;
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  price?: Maybe<Scalars['Float']['output']>;
  reduceType?: Maybe<__DiscountType2>;
  reduceValue?: Maybe<Scalars['Float']['output']>;
};

export type __PriceVariantBulk = {
  price: Scalars['Float']['output'];
  qty: Scalars['Float']['output'];
};

export type __PriceVariantBundle = {
  entries?: Maybe<Array<__PriceVariantBundleEntry>>;
  entryId: Scalars['String']['output'];
  minQty: Scalars['Float']['output'];
};

export type __PriceVariantBundleEntry = {
  groupId: Scalars['ObjectId']['output'];
  variantIds?: Maybe<Array<Scalars['ObjectId']['output']>>;
};

export type __ProductAttrs = {
  key: Scalars['String']['output'];
  uiKey?: Maybe<Scalars['String']['output']>;
  uiOption?: Maybe<Scalars['Boolean']['output']>;
  uiValue?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

export const __ProductAvailabilityType = {
  Limited: 'Limited',
  Normal: 'Normal',
  Upcoming: 'Upcoming'
} as const;

export type __ProductAvailabilityType = typeof __ProductAvailabilityType[keyof typeof __ProductAvailabilityType];
export type __ProductCache = {
  departmentId?: Maybe<Scalars['String']['output']>;
  departmentIds?: Maybe<Array<Scalars['String']['output']>>;
  departments?: Maybe<Array<__Text>>;
  description?: Maybe<__Text>;
  groupId?: Maybe<Scalars['ObjectId']['output']>;
  id: Scalars['ObjectId']['output'];
  image?: Maybe<Scalars['String']['output']>;
  imageFull?: Maybe<__Image>;
  isManual?: Maybe<Scalars['Boolean']['output']>;
  option?: Maybe<__Text>;
  options2: Array<__ProductCacheOptions>;
  priceUnit?: Maybe<Scalars['Float']['output']>;
  sellerId?: Maybe<Scalars['ObjectId']['output']>;
  sku: Scalars['String']['output'];
  slug?: Maybe<Scalars['String']['output']>;
  title?: Maybe<__Text>;
  volumeCategory?: Maybe<__EnumProductVolumeCategory>;
  weightGrams?: Maybe<Scalars['Int']['output']>;
};

export type __ProductCacheOptions = {
  name?: Maybe<__Text>;
  value?: Maybe<__Text>;
};

export type __ProductCertificate = {
  description?: Maybe<__Text>;
  image: __Image;
  title: __Text;
};

export type __ProductDetails = {
  description: __Text;
};

export type __ProductExtra = {
  address?: Maybe<__SellerInfoAddress>;
  care?: Maybe<__ProductExtraCare>;
  certificates?: Maybe<Array<__ProductCertificate>>;
  details?: Maybe<__ProductDetails>;
  fabric?: Maybe<__ProductExtraFabric>;
  factory?: Maybe<__ProductExtraFactory>;
  returnDoc?: Maybe<__ProductExtraReturn>;
  shop?: Maybe<__ProductExtraShop>;
  stockLocation?: Maybe<__ProductExtraStockLocation>;
  warranty?: Maybe<__ProductWarranty>;
};

export type __ProductExtraCare = {
  _careIcons?: Maybe<Array<__ProductExtraCareIcon>>;
  careIconsIds: Array<Scalars['ObjectId']['output']>;
  message?: Maybe<__Text>;
};

export type __ProductExtraCareIcon = {
  image: __Image;
  title: __Text;
};

export type __ProductExtraFabric = {
  _care?: Maybe<__ProductExtraCare>;
  careId?: Maybe<Scalars['ObjectId']['output']>;
  description: __Text;
  image: __Image;
  title: __Text;
};

export type __ProductExtraFactory = {
  document?: Maybe<__SellerDocumentPublic>;
  id: Scalars['String']['output'];
  image?: Maybe<__Image>;
  location?: Maybe<__Text>;
  title: __Text;
};

export type __ProductExtraReturn = {
  document?: Maybe<__SellerDocumentPublic>;
  duration?: Maybe<__Duration>;
  id: Scalars['String']['output'];
  message: __Text;
  returnsNotAllowed?: Maybe<Scalars['Boolean']['output']>;
  title: __Text;
};

export type __ProductExtraShop = {
  address: __Text;
  city: __Text;
  contacts?: Maybe<__SellerContacts>;
  country?: Maybe<__BuyerAddressCountry>;
  document?: Maybe<__SellerDocumentPublic>;
  id: Scalars['String']['output'];
  image?: Maybe<__Image>;
  title: __Text;
};

export type __ProductExtraShops = {
  items: Array<__ProductExtraShop>;
};

export type __ProductExtraStockLocation = {
  country: __BuyerAddressCountry;
  location: __Text;
  locationShort?: Maybe<__Text>;
};

export type __ProductGroup = {
  _googleProductCategoryAssignedByGoogle?: Maybe<__GoogleProductCategory>;
  _publishedAt?: Maybe<Scalars['MongoDate']['output']>;
  baseDeleteStatus?: Maybe<__ProductModelDeleteStatus>;
  baseDepartments?: Maybe<Array<Scalars['String']['output']>>;
  baseIsPublished: Scalars['Boolean']['output'];
  baseMainVariantId?: Maybe<Scalars['ObjectId']['output']>;
  createdAt?: Maybe<Scalars['MongoDate']['output']>;
  feedAttr?: Maybe<__ProductVariantFeedAttr>;
  googleProductCategoryOverride?: Maybe<__GoogleProductCategory>;
  groupCareId?: Maybe<Scalars['ObjectId']['output']>;
  groupCertificateIds?: Maybe<Array<Scalars['ObjectId']['output']>>;
  groupCollection?: Maybe<__SellerArticleRef>;
  groupDetailsId?: Maybe<Scalars['ObjectId']['output']>;
  groupDocument?: Maybe<__SellerDocumentPublic>;
  groupFabricId?: Maybe<Scalars['ObjectId']['output']>;
  groupFactoryId?: Maybe<Scalars['ObjectId']['output']>;
  groupId: Scalars['ObjectId']['output'];
  groupOptions2Values?: Maybe<Array<__ProductPropertyVal4>>;
  groupOptionsFieldUis?: Maybe<Array<__ProductPropertyVal4FieldUi>>;
  groupOptionsUis?: Maybe<Array<__ProductPropertyVal4Ui>>;
  groupProductType?: Maybe<__SellerProductTypeRef>;
  groupReturnId?: Maybe<Scalars['ObjectId']['output']>;
  groupStockLocationId?: Maybe<Scalars['ObjectId']['output']>;
  groupUpdatedAt?: Maybe<Scalars['MongoDate']['output']>;
  groupVisibility?: Maybe<__ProductVisibility>;
  groupWarrantyId?: Maybe<Scalars['ObjectId']['output']>;
  id: Scalars['ObjectId']['output'];
  settingsQty?: Maybe<__ProductSettingsQty>;
  variants?: Maybe<Array<__ProductVariant>>;
};

export type __ProductIds = {
  productIds: Array<Scalars['ObjectId']['output']>;
};

export type __ProductListing = {
  _oldProductCareHtml: Scalars['String']['output'];
  _oldProductReturnsHtml: Scalars['String']['output'];
  _oldProductSizeHtml: Scalars['String']['output'];
  _values?: Maybe<__ProductListingValues>;
  _weight?: Maybe<__UiWeight>;
  attrs: Array<__ProductAttrs>;
  audience?: Maybe<Scalars['String']['output']>;
  availabilityType?: Maybe<__ProductAvailabilityType>;
  availableAt?: Maybe<Scalars['MongoDate']['output']>;
  careId?: Maybe<Scalars['ObjectId']['output']>;
  certificateIds?: Maybe<Array<Scalars['ObjectId']['output']>>;
  collection?: Maybe<__SellerArticleRef>;
  color?: Maybe<Scalars['String']['output']>;
  departmentName?: Maybe<Scalars['String']['output']>;
  depertments2?: Maybe<Array<Maybe<Array<__ProductListingDepartments>>>>;
  descriptionShort?: Maybe<Scalars['String']['output']>;
  descriptionTechnical?: Maybe<Scalars['String']['output']>;
  detailsId?: Maybe<Scalars['ObjectId']['output']>;
  document?: Maybe<__SellerDocumentPublic>;
  fabricId?: Maybe<Scalars['ObjectId']['output']>;
  factoryId?: Maybe<Scalars['ObjectId']['output']>;
  gender?: Maybe<Scalars['String']['output']>;
  groupId: Scalars['String']['output'];
  gtin?: Maybe<Scalars['String']['output']>;
  gtin8?: Maybe<Scalars['String']['output']>;
  gtin12?: Maybe<Scalars['String']['output']>;
  gtin13?: Maybe<Scalars['String']['output']>;
  hasBundles?: Maybe<Scalars['Boolean']['output']>;
  height?: Maybe<Scalars['Int']['output']>;
  id: Scalars['String']['output'];
  imageBox?: Maybe<__ImageNodeItem>;
  img1?: Maybe<Scalars['String']['output']>;
  isDiscontinued?: Maybe<Scalars['Boolean']['output']>;
  isDiscounted: Scalars['Boolean']['output'];
  isNew: Scalars['Boolean']['output'];
  isbn?: Maybe<Scalars['String']['output']>;
  lang: Scalars['String']['output'];
  length?: Maybe<Scalars['Int']['output']>;
  material?: Maybe<Scalars['String']['output']>;
  media?: Maybe<__MediaProduct>;
  mpn?: Maybe<Scalars['String']['output']>;
  pattern?: Maybe<Scalars['String']['output']>;
  privateVisibility?: Maybe<Scalars['Boolean']['output']>;
  productId: Scalars['String']['output'];
  quantityLimit?: Maybe<Scalars['Int']['output']>;
  rating?: Maybe<__PostReviewRating>;
  returnId?: Maybe<Scalars['ObjectId']['output']>;
  returnsNotAllowed?: Maybe<Scalars['Boolean']['output']>;
  seller?: Maybe<__SellerDoc>;
  sellerId?: Maybe<Scalars['String']['output']>;
  settingsQty?: Maybe<__ProductSettingsQty>;
  sku: Scalars['String']['output'];
  slug: Scalars['String']['output'];
  stockLocationId?: Maybe<Scalars['ObjectId']['output']>;
  title: Scalars['String']['output'];
  updatedAt?: Maybe<Scalars['MongoDate']['output']>;
  volumeCategory?: Maybe<__EnumProductVolumeCategory>;
  warrantyId?: Maybe<Scalars['ObjectId']['output']>;
  weightGrams: Scalars['Float']['output'];
  width?: Maybe<Scalars['Int']['output']>;
};

export type __ProductListingBox = {
  _values?: Maybe<__ProductListingValues>;
  _weight?: Maybe<__UiWeight>;
  availabilityType?: Maybe<__ProductAvailabilityType>;
  availableAt?: Maybe<Scalars['MongoDate']['output']>;
  color?: Maybe<Scalars['String']['output']>;
  departmentName?: Maybe<Scalars['String']['output']>;
  groupId: Scalars['String']['output'];
  id: Scalars['String']['output'];
  imageCount?: Maybe<Scalars['Int']['output']>;
  images?: Maybe<Array<__ImageNodeItem>>;
  img1?: Maybe<Scalars['String']['output']>;
  isNew: Scalars['Boolean']['output'];
  option?: Maybe<Array<__ProductAttrs>>;
  privateVisibility?: Maybe<Scalars['Boolean']['output']>;
  quantityLimit?: Maybe<Scalars['Int']['output']>;
  rating?: Maybe<__PostReviewRating>;
  returnsNotAllowed?: Maybe<Scalars['Boolean']['output']>;
  sellerId?: Maybe<Scalars['String']['output']>;
  settingsQty?: Maybe<__ProductSettingsQty>;
  sku?: Maybe<Scalars['String']['output']>;
  slug: Scalars['String']['output'];
  title: Scalars['String']['output'];
  weightGrams: Scalars['Float']['output'];
};

export type __ProductListingBoxUiPrice = {
  _limited?: Maybe<__ProductListingBoxUiPriceLimited>;
  bulk?: Maybe<Array<__PriceVariantBulk>>;
  endAt?: Maybe<Scalars['MongoDate']['output']>;
  limit?: Maybe<Scalars['Int']['output']>;
  limitUsed?: Maybe<Scalars['Int']['output']>;
  lineItems: Array<__ProductPriceLineItem>;
  price: __Price2Total;
  priceOld?: Maybe<__Price2Total>;
  priceTaxless: __Price2Total;
  publicCode?: Maybe<__ProductListingBoxUiPricePublicCode>;
};

export type __ProductListingBoxUiPriceLimited = {
  left: Scalars['Int']['output'];
  leftPercent: Scalars['Int']['output'];
  limit: Scalars['Int']['output'];
};

export type __ProductListingBoxUiPricePublicCode = {
  code: Scalars['String']['output'];
  percent?: Maybe<Scalars['String']['output']>;
  price: __Price2Total;
};

export type __ProductListingDepartments = {
  key: Scalars['String']['output'];
  title: Scalars['String']['output'];
};

export type __ProductListingPreviewBox = {
  departmentName?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  imageBox?: Maybe<__ImageNodeItem>;
  option?: Maybe<Array<__ProductAttrs>>;
  privateVisibility: Scalars['Boolean']['output'];
  slug: Scalars['String']['output'];
  title: Scalars['String']['output'];
};

export type __ProductListingPrivate = {
  id: Scalars['String']['output'];
  values: __ProductListingValues;
};

export type __ProductListingValues = {
  _uiPrice?: Maybe<__ProductListingBoxUiPrice>;
  _variantsSeo?: Maybe<__ProductListingValuesSeo>;
  inStock?: Maybe<Scalars['Boolean']['output']>;
  option?: Maybe<Array<__ProductAttrs>>;
  options?: Maybe<Array<__ProductOptionsItem>>;
  price?: Maybe<__Price2Total>;
  priceBase?: Maybe<__Price2Total>;
  stock?: Maybe<Scalars['Float']['output']>;
  variantAvailableCount?: Maybe<Scalars['Int']['output']>;
  variantBoxList?: Maybe<Array<__ListingBoxImages>>;
  variantCount?: Maybe<Scalars['Int']['output']>;
};

export type __ProductListingValuesSeo = {
  items: Array<__ProductListingValuesSeoItems>;
  variantsSeoVariesBy: Array<Scalars['String']['output']>;
};

export type __ProductListingValuesSeoItems = {
  color?: Maybe<Scalars['String']['output']>;
  image?: Maybe<Scalars['String']['output']>;
  inStock: Scalars['Boolean']['output'];
  material?: Maybe<Scalars['String']['output']>;
  pattern?: Maybe<Scalars['String']['output']>;
  price: Scalars['Float']['output'];
  productId: Scalars['String']['output'];
  size?: Maybe<Scalars['String']['output']>;
  sku: Scalars['String']['output'];
  slug: Scalars['String']['output'];
  title: Scalars['String']['output'];
};

export type __ProductMinVariantIdInput = {
  groupId: Scalars['ObjectId']['input'];
  mainVariantId?: InputMaybe<Scalars['ObjectId']['input']>;
};

export type __ProductModelDeleteStatus = {
  deletionDate?: Maybe<Scalars['MongoDate']['output']>;
  isDeleted: Scalars['Boolean']['output'];
};

export type __ProductOptionsItem = {
  guideBodyId?: Maybe<Scalars['String']['output']>;
  guideProductId?: Maybe<Scalars['String']['output']>;
  key: Scalars['String']['output'];
  name: Scalars['String']['output'];
  values: Array<__ProductOptionsItemValues>;
};

export type __ProductOptionsItemValues = {
  hsla?: Maybe<__DocumentColorHsla>;
  image?: Maybe<__ImageNodeItem>;
  name?: Maybe<Scalars['String']['output']>;
  product?: Maybe<__ProductOptionsItemValuesProduct>;
};

export type __ProductOptionsItemValuesProduct = {
  image?: Maybe<__ImageNodeItem>;
  inStock: Scalars['Boolean']['output'];
  productId: Scalars['ObjectId']['output'];
  slug: Scalars['String']['output'];
  title?: Maybe<Scalars['String']['output']>;
};

export type __ProductPriceLineItem = {
  entryId?: Maybe<Scalars['String']['output']>;
  price: __Price2Total;
  qty: Scalars['Float']['output'];
  ui?: Maybe<Array<__DiscountUi>>;
};

export type __ProductPropertyVal4 = {
  fieldId: Scalars['ObjectId']['output'];
  number?: Maybe<Scalars['Float']['output']>;
  text?: Maybe<__Text>;
  val4Id: Scalars['String']['output'];
};

export type __ProductPropertyVal4FieldUi = {
  disabled?: Maybe<Scalars['Boolean']['output']>;
  expandInCatalog?: Maybe<Scalars['Boolean']['output']>;
  fieldId: Scalars['ObjectId']['output'];
  guideBodyId?: Maybe<Scalars['String']['output']>;
  guideProductId?: Maybe<Scalars['String']['output']>;
  order?: Maybe<Scalars['Int']['output']>;
  reTitle?: Maybe<__Text>;
};

export type __ProductPropertyVal4Ui = {
  hsla?: Maybe<__DocumentColorHsla>;
  image?: Maybe<__Image>;
  order?: Maybe<Scalars['Int']['output']>;
  val4Id: Scalars['String']['output'];
};

export type __ProductRecomended = {
  cursorNext?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  items?: Maybe<Array<__ProductListingBox>>;
};

export type __ProductSettingsQty = {
  max?: Maybe<Scalars['Float']['output']>;
  min?: Maybe<Scalars['Float']['output']>;
  step?: Maybe<Scalars['Float']['output']>;
  stockMsg?: Maybe<__StockMsg>;
  unit?: Maybe<__EnumProductQtyUnit>;
};

export type __ProductStock = {
  availableStock: Scalars['Float']['output'];
  daysOutOfStock?: Maybe<Scalars['Int']['output']>;
  isInStock: Scalars['Boolean']['output'];
  outOfStockAt?: Maybe<Scalars['MongoDate']['output']>;
  reservationCount: Scalars['Int']['output'];
  reserverdStock: Scalars['Float']['output'];
  stockCover?: Maybe<Scalars['Int']['output']>;
  totalStock: Scalars['Float']['output'];
};

export type __ProductVariant = {
  _err?: Maybe<Array<Scalars['String']['output']>>;
  _googleProductCategoryAssignedByGoogle?: Maybe<__GoogleProductCategory>;
  _id: Scalars['ObjectId']['output'];
  _publishedAt?: Maybe<Scalars['MongoDate']['output']>;
  _skuCorrect?: Maybe<Scalars['Boolean']['output']>;
  _statisticsBuyers?: Maybe<__ProductVariantStatisticsBuyers>;
  _statisticsBuyersGroup?: Maybe<__ProductVariantStatisticsBuyers>;
  availabilityType?: Maybe<__ProductAvailabilityType>;
  availableAt?: Maybe<Scalars['MongoDate']['output']>;
  baseIsPublishedAt?: Maybe<Scalars['MongoDate']['output']>;
  descriptionShort?: Maybe<__Text>;
  descriptionTechnical?: Maybe<__Text>;
  editedAt?: Maybe<Scalars['MongoDate']['output']>;
  feedAttr?: Maybe<__ProductVariantFeedAttr>;
  googleProductCategoryOverride?: Maybe<__GoogleProductCategory>;
  groupDepartments?: Maybe<Array<Scalars['String']['output']>>;
  groupId: Scalars['ObjectId']['output'];
  groupProductType?: Maybe<__SellerProductTypeRef>;
  groupUiPriceMax?: Maybe<Scalars['Float']['output']>;
  groupUiPriceMin?: Maybe<Scalars['Float']['output']>;
  isActivated: Scalars['Boolean']['output'];
  isDeleted?: Maybe<Scalars['Boolean']['output']>;
  media?: Maybe<__MediaProduct>;
  options2?: Maybe<Array<__ProductPropertyVal4>>;
  price: Scalars['Float']['output'];
  priceGroups?: Maybe<Array<__PriceGroup>>;
  pricePrime?: Maybe<Scalars['Float']['output']>;
  quantityLimit?: Maybe<Scalars['Int']['output']>;
  sellerId?: Maybe<Scalars['ObjectId']['output']>;
  settingsQty?: Maybe<__ProductSettingsQty>;
  sku: Scalars['String']['output'];
  slug?: Maybe<Scalars['String']['output']>;
  stock: Scalars['Float']['output'];
  syncedAt?: Maybe<Scalars['MongoDate']['output']>;
  title: __Text;
  uiBaseVariants?: Maybe<__ProductVariantNumber>;
  uiBox?: Maybe<__ProductVariantUiBox>;
  uiDiscounts?: Maybe<Array<__ProductVariantUiDiscounts>>;
  uiReservations?: Maybe<Array<__ProductVariantReservations>>;
  uiStatus?: Maybe<__ProductVariantStatus>;
  uiStock?: Maybe<__ProductStock>;
  uiWeight?: Maybe<__UiWeight>;
  updatedAt?: Maybe<Scalars['MongoDate']['output']>;
  volumeCategory?: Maybe<__EnumProductVolumeCategory>;
};

export type __ProductVariantFeedAttr = {
  audience?: Maybe<Scalars['String']['output']>;
  gender?: Maybe<Scalars['String']['output']>;
  gtin?: Maybe<Scalars['String']['output']>;
  gtin8?: Maybe<Scalars['String']['output']>;
  gtin12?: Maybe<Scalars['String']['output']>;
  gtin13?: Maybe<Scalars['String']['output']>;
  height?: Maybe<Scalars['Int']['output']>;
  isbn?: Maybe<Scalars['String']['output']>;
  length?: Maybe<Scalars['Int']['output']>;
  material?: Maybe<Scalars['String']['output']>;
  mpn?: Maybe<Scalars['String']['output']>;
  pattern?: Maybe<Scalars['String']['output']>;
  width?: Maybe<Scalars['Int']['output']>;
};

export type __ProductVariantNumber = {
  current?: Maybe<Scalars['Int']['output']>;
  total?: Maybe<Scalars['Int']['output']>;
};

export type __ProductVariantReservations = {
  at?: Maybe<Scalars['MongoDate']['output']>;
  isPayed?: Maybe<Scalars['Boolean']['output']>;
  orderId?: Maybe<Scalars['ObjectId']['output']>;
  qty?: Maybe<Scalars['Float']['output']>;
  quoteId?: Maybe<Scalars['ObjectId']['output']>;
};

export type __ProductVariantStatisticsBuyers = {
  averageSalesQty?: Maybe<Scalars['Float']['output']>;
  averageSalesQtyMonth?: Maybe<Scalars['Float']['output']>;
  averageSalesQtyWeek?: Maybe<Scalars['Float']['output']>;
  carts?: Maybe<Scalars['Int']['output']>;
  cartsMonth?: Maybe<Scalars['Int']['output']>;
  cartsQty?: Maybe<Scalars['Float']['output']>;
  cartsQtyMonth?: Maybe<Scalars['Float']['output']>;
  cartsQtyWeek?: Maybe<Scalars['Float']['output']>;
  cartsWeek?: Maybe<Scalars['Int']['output']>;
  googleDay?: Maybe<Scalars['Int']['output']>;
  googleMonth?: Maybe<Scalars['Int']['output']>;
  googleTotal?: Maybe<Scalars['Int']['output']>;
  googleWeek?: Maybe<Scalars['Int']['output']>;
  inStock?: Maybe<Scalars['Boolean']['output']>;
  lastSaleAt?: Maybe<Scalars['MongoDate']['output']>;
  notifyPrice?: Maybe<Scalars['Int']['output']>;
  notifyStock?: Maybe<Scalars['Int']['output']>;
  orders?: Maybe<Scalars['Int']['output']>;
  ordersMonth?: Maybe<Scalars['Float']['output']>;
  ordersWeek?: Maybe<Scalars['Float']['output']>;
  qty?: Maybe<Scalars['Float']['output']>;
  qtyDay?: Maybe<Scalars['Float']['output']>;
  qtyMonth?: Maybe<Scalars['Float']['output']>;
  qtyWeek?: Maybe<Scalars['Float']['output']>;
  returns?: Maybe<Scalars['Float']['output']>;
  sales?: Maybe<Scalars['Float']['output']>;
  salesMonth?: Maybe<Scalars['Float']['output']>;
  salesWeek?: Maybe<Scalars['Float']['output']>;
  saved?: Maybe<Scalars['Int']['output']>;
  stockCover?: Maybe<Scalars['Int']['output']>;
  syncedAt?: Maybe<Scalars['MongoDate']['output']>;
  viewsDay?: Maybe<Scalars['Int']['output']>;
  viewsMonth?: Maybe<Scalars['Int']['output']>;
  viewsTotal?: Maybe<Scalars['Int']['output']>;
  viewsWeek?: Maybe<Scalars['Int']['output']>;
};

export const __ProductVariantStatus = {
  Deleted: 'Deleted',
  Disabled: 'Disabled',
  OutOfStock: 'OutOfStock',
  Published: 'Published'
} as const;

export type __ProductVariantStatus = typeof __ProductVariantStatus[keyof typeof __ProductVariantStatus];
export type __ProductVariantUiBox = {
  groupPriceRange: Scalars['String']['output'];
  price?: Maybe<__Price2>;
  priceSale?: Maybe<__Price2>;
  priceTaxless?: Maybe<__Price2>;
  seoProblems?: Maybe<Scalars['Int']['output']>;
};

export type __ProductVariantUiDiscounts = {
  endAt?: Maybe<Scalars['MongoDate']['output']>;
  id: Scalars['String']['output'];
  limit?: Maybe<Scalars['Int']['output']>;
  limitUsed?: Maybe<Scalars['Float']['output']>;
  price?: Maybe<__Price2>;
  priceGroups?: Maybe<Array<Scalars['String']['output']>>;
  public?: Maybe<Scalars['Boolean']['output']>;
  publicCode?: Maybe<Scalars['String']['output']>;
  title?: Maybe<__Text>;
  type?: Maybe<__EnumPriceEntry>;
};

export type __ProductVariants = __PaginatedResults & {
  info?: Maybe<__PaginationInfo>;
  items?: Maybe<Array<__ProductVariant>>;
};

export type __ProductVisibility = {
  all: Scalars['Boolean']['output'];
  ids?: Maybe<Array<Scalars['ObjectId']['output']>>;
};

export type __ProductWarranty = {
  document?: Maybe<__SellerDocumentPublic>;
  duration?: Maybe<__Duration>;
  title: __Text;
};

export type __ProductsMultiget = {
  items?: Maybe<Array<__ProductVariant>>;
};

export type __ProfileHandleCheck = {
  isAvailable: Scalars['Boolean']['output'];
  isValid: Scalars['Boolean']['output'];
};

export type __PublicArticles = {
  cursorNext?: Maybe<Scalars['ObjectId']['output']>;
  items?: Maybe<Array<__SellerArticle>>;
  tags?: Maybe<Array<Scalars['String']['output']>>;
};

export type __PublicArticlesFilters = {
  tags?: Maybe<Array<__PaginationAutocomplete>>;
};

export type __PublicDeliveryProduct = {
  collectBy?: Maybe<Scalars['String']['output']>;
  dispatchCountry?: Maybe<Scalars['String']['output']>;
  dispatchLocation?: Maybe<Scalars['String']['output']>;
  locker?: Maybe<__SellerDeliveryUiProductAggFrom>;
  orderBy?: Maybe<Scalars['MongoDate']['output']>;
  orderWithin?: Maybe<Scalars['String']['output']>;
  receiveBy?: Maybe<Scalars['String']['output']>;
  receiveBySource?: Maybe<__PublicDeliveryPromiseSource>;
  receiveByType?: Maybe<__PublicDeliveryPromiseType>;
  shipping?: Maybe<__SellerDeliveryUiProductAggFrom>;
  shippingDelayEnd?: Maybe<Scalars['MongoDate']['output']>;
  shippingDelayStart?: Maybe<Scalars['MongoDate']['output']>;
};

export const __PublicDeliveryPromiseSource = {
  Calendar: 'Calendar',
  Configured: 'Configured'
} as const;

export type __PublicDeliveryPromiseSource = typeof __PublicDeliveryPromiseSource[keyof typeof __PublicDeliveryPromiseSource];
export const __PublicDeliveryPromiseType = {
  Locker: 'Locker',
  Shipping: 'Shipping'
} as const;

export type __PublicDeliveryPromiseType = typeof __PublicDeliveryPromiseType[keyof typeof __PublicDeliveryPromiseType];
export type __PublicDeliverySeller = {
  location?: Maybe<Array<__UiSellerDeliveryProductView>>;
  locker?: Maybe<Array<__UiSellerDeliveryProductView>>;
  shipping?: Maybe<Array<__UiSellerDeliveryProductView>>;
};

export type __PublicDeliverySellerOne = {
  id: Scalars['String']['output'];
  items: Array<__PublicDeliverySellerOneItem>;
};

export type __PublicDeliverySellerOneItem = {
  all?: Maybe<Scalars['Boolean']['output']>;
  mainland?: Maybe<Scalars['Boolean']['output']>;
  prices: Array<__PublicDeliverySellerOnePrice>;
  type?: Maybe<Scalars['String']['output']>;
  zoneTitle?: Maybe<Scalars['String']['output']>;
};

export type __PublicDeliverySellerOnePrice = {
  price: Scalars['String']['output'];
  weightUi: Scalars['String']['output'];
};

export type __PublicSellerDepartments = {
  id: Scalars['String']['output'];
  items?: Maybe<Array<__PublicSellerDepartmentsItem>>;
};

export type __PublicSellerDepartmentsItem = {
  img?: Maybe<__Image>;
  parentSlug?: Maybe<Scalars['String']['output']>;
  slug: Scalars['String']['output'];
  title: __Text;
};

export type __Query = {
  buyerAddress: __BuyerAddressNode;
  buyerAddressAutocomplete?: Maybe<__AddessAutocomplete>;
  buyerAddressAutocompleteDetails?: Maybe<__AddessAutocompleteDetails>;
  buyerB2b: __BuyerB2b;
  buyerBoardsAll?: Maybe<__BuyerBoardsAll>;
  buyerBoardsCheck?: Maybe<Array<__BuyerBoardCheck>>;
  buyerBoardsProducts?: Maybe<__BuyerProductBoard>;
  buyerBundles?: Maybe<__BuyerBundles>;
  buyerBundlesProducts: __BuyerBundleProducts;
  buyerBundlesProductsOne: __BuyerBundleProductsItem;
  buyerCart: __BuyerCart;
  buyerCheckout?: Maybe<__CheckoutDraft>;
  buyerCheckoutQuote?: Maybe<__CheckoutQuote>;
  buyerCheckoutQuoteActions?: Maybe<__CheckoutQuoteActions>;
  buyerCheckoutQuotes?: Maybe<__CheckoutQuotes>;
  buyerGiftcard: __Giftcard;
  buyerGiftcardBalance: __GiftcardUiReceiver;
  buyerGiftcards?: Maybe<__Giftcards>;
  buyerInteractions?: Maybe<__BuyerInteractions>;
  buyerLikes: Array<__BuyerLikes>;
  buyerMessages?: Maybe<__Messages>;
  buyerMessagesSummary: __MessageSummary;
  buyerNotification?: Maybe<__BuyerNotifyDoc>;
  buyerNotifications?: Maybe<__BuyerNotifications>;
  buyerOrder?: Maybe<__SellerOrderDoc>;
  buyerOrderInvoicePdf?: Maybe<__SellerOrderDocPdf>;
  buyerOrderPaymentList?: Maybe<__BuyerOrderPaymentList>;
  buyerOrderPaymentListYears?: Maybe<__BuyerOrderPaymentListYears>;
  buyerOrderProducts?: Maybe<__BuyerOrderProducts>;
  buyerOrders?: Maybe<__CheckoutOrders>;
  buyerOrdersList?: Maybe<__SellerOrderPagination>;
  buyerPaymentCards?: Maybe<__BuyerEverypayCards>;
  buyerPaymentInvoiceCount?: Maybe<__PaymentInvoiceDocCount>;
  buyerPaymentMethods?: Maybe<__PaymentPayOptions>;
  buyerPostExists?: Maybe<__BuyerPostExists>;
  buyerPostMultiget: __BuyerPostReviewMultiget;
  buyerPostOne?: Maybe<__Post>;
  buyerPosts?: Maybe<__PostNodes>;
  buyerPostsAll?: Maybe<__PostsPagination>;
  buyerPostsProduct: __BuyerReviewsProduct;
  buyerProductHistory?: Maybe<__BuyerProductHistory>;
  buyerProductHistoryStats?: Maybe<__BuyerProductHistoryStats>;
  buyerReturn: __SellerReturn;
  buyerReturnOrders: __BuyerReturnOrders;
  buyerReturns: __SellerReturns;
  buyerShipmentHistory?: Maybe<__SellerShipmentHistory>;
  buyerSubscriptions?: Maybe<__BuyerSubscriptions>;
  buyerSubscriptionsCheck?: Maybe<__BuyerSubscriptions>;
  buyerUpcomingDeliveryOptions: __CheckoutUpcomingDeliveryOptions;
  buyerUpcomingEnterPreEnter: __UpcomingEntryPreEnter;
  buyerUpcomingEntries: __UpcomingEntries;
  buyerUpcomingEntry: __UpcomingEntry;
  catalogDepartments?: Maybe<__PublicSellerDepartments>;
  catalogFiltersInit: __SearchCatalogFiltersInit;
  catalogFiltersSeller?: Maybe<__SearchCatalogFiltersSeller>;
  catalogProduct?: Maybe<__ProductListing>;
  catalogProductPrivate?: Maybe<Array<__ProductListingPrivate>>;
  catalogSearch: __SearchOptionsRes;
  catalogSearchTerm: __SearchTermRes;
  catalogSeller?: Maybe<__SearchCatalogSeller>;
  internalImageMultiget?: Maybe<Array<__ImageInternalKeyed>>;
  marketCountries?: Maybe<__MarketCountries>;
  me: __Me;
  publicArticle?: Maybe<__SellerArticle>;
  publicArticleCommentOverview?: Maybe<__PostArticleCommentOverview>;
  publicArticles?: Maybe<__PublicArticles>;
  publicArticlesFilters?: Maybe<__PublicArticlesFilters>;
  publicB2bActive?: Maybe<__SellerBusinessActive>;
  publicBoard?: Maybe<__BuyerProductBoard>;
  publicBoards?: Maybe<__UserProductBoards>;
  publicDeliveryProduct: __PublicDeliveryProduct;
  publicDeliverySeller?: Maybe<__PublicDeliverySeller>;
  publicDeliverySellerOne?: Maybe<__PublicDeliverySellerOne>;
  publicDiscountCode?: Maybe<Array<__ListingsDiscountPublicCode>>;
  publicInfoMultiget: Array<__SellerProductInfo>;
  publicListingsGroup?: Maybe<Array<__ProductListingBox>>;
  publicListingsMultiget?: Maybe<Array<__ProductListingBox>>;
  publicLockers?: Maybe<__CheckoutDraftLockers>;
  publicLockersCities?: Maybe<__CheckoutDraftLockersCities>;
  publicLockersMultiget?: Maybe<Array<__LockersItem>>;
  publicMarketCountries?: Maybe<__MarketCountriesAll>;
  publicMarketCountryMultiget?: Maybe<Array<__MarketCountry>>;
  publicPage?: Maybe<__SellerPageView>;
  publicPosts?: Maybe<__Posts>;
  publicPostsGetOne: __PostNodes;
  publicPreviewBox?: Maybe<__UiPreviewBox>;
  publicProductInfo?: Maybe<__ProductExtra>;
  publicProductRecomended?: Maybe<__ProductRecomended>;
  publicProfile?: Maybe<__SellerProfile>;
  publicProfileHandleFree?: Maybe<__ProfileHandleCheck>;
  publicProfiles?: Maybe<Array<__SellerProfile>>;
  publicQuestionsOverview?: Maybe<__PostQuestionsOverview>;
  publicReturnAddress?: Maybe<__SellerInfoAddress>;
  publicReviewsOverview?: Maybe<__PostReviewsOverview>;
  publicReviewsPhotos?: Maybe<__PostReviewsPhotos>;
  publicSeller?: Maybe<__SellerPublic>;
  publicSellerCareIcons?: Maybe<Array<__ProductExtraCareIcon>>;
  publicSellerCertificates?: Maybe<Array<__ProductCertificate>>;
  publicSellerDocument?: Maybe<__SellerDocumentSf>;
  publicSellerDocumentAds?: Maybe<__SellerDocumentSfAds>;
  publicSellerFabrics?: Maybe<Array<__ProductExtraFabric>>;
  publicSellerFactories?: Maybe<Array<__ProductExtraFactory>>;
  publicSellerFaq?: Maybe<Array<__SellerFaqFull>>;
  publicSellerFaqDoc?: Maybe<__SellerFaqQa>;
  publicSellerReturns?: Maybe<Array<__ProductExtraReturn>>;
  publicSellerShops?: Maybe<__ProductExtraShops>;
  publicSellerWarranty?: Maybe<Array<__ProductWarranty>>;
  publicSellers?: Maybe<__SellerPublicList>;
  publicSizeGuide?: Maybe<__SellerSizeGuide>;
  publicSizeGuides?: Maybe<__SellerSizeGuides>;
  seller?: Maybe<__Seller>;
  sellerArticlesTags?: Maybe<__PublicArticlesFilters>;
  sellers?: Maybe<__Sellers>;
  storeConfig?: Maybe<__StoreConfig>;
  system?: Maybe<__System>;
  systemBanks?: Maybe<__SystemBankDetails>;
};


export type __QueryBuyerAddressAutocompleteArgs = {
  input: __InputAddressAutocomplete;
};


export type __QueryBuyerAddressAutocompleteDetailsArgs = {
  input: __InputAddressAutocompleteDetails;
};


export type __QueryBuyerB2bArgs = {
  sellerId: Scalars['ObjectId']['input'];
};


export type __QueryBuyerBoardsAllArgs = {
  input: __InputBuyerBoardCursor;
};


export type __QueryBuyerBoardsCheckArgs = {
  input: __InputIds;
};


export type __QueryBuyerBoardsProductsArgs = {
  input: __InputId;
};


export type __QueryBuyerBundlesArgs = {
  input: __InputBuyerBundles;
};


export type __QueryBuyerBundlesProductsArgs = {
  input: __InputBuyerBundleProducts;
};


export type __QueryBuyerBundlesProductsOneArgs = {
  input: __InputBuyerBundleProductsOne;
};


export type __QueryBuyerCheckoutArgs = {
  checkout: __InputId;
};


export type __QueryBuyerCheckoutQuoteArgs = {
  checkout: __InputId;
};


export type __QueryBuyerCheckoutQuoteActionsArgs = {
  input: __InputCheckoutQuoteActions;
};


export type __QueryBuyerCheckoutQuotesArgs = {
  input: __InputPaymentInvoicesPagination;
};


export type __QueryBuyerGiftcardArgs = {
  input: __InputId;
};


export type __QueryBuyerGiftcardBalanceArgs = {
  input: __InputCode;
};


export type __QueryBuyerGiftcardsArgs = {
  input: __InputPagination;
};


export type __QueryBuyerLikesArgs = {
  posts: Array<Scalars['ObjectId']['input']>;
};


export type __QueryBuyerMessagesArgs = {
  input: __InputMessagesPag;
};


export type __QueryBuyerNotificationArgs = {
  input: __InputId;
};


export type __QueryBuyerNotificationsArgs = {
  input: __InputBuyerNotificationCursor;
};


export type __QueryBuyerOrderArgs = {
  input: __OrderInput;
};


export type __QueryBuyerOrderInvoicePdfArgs = {
  input: __OrderInput;
};


export type __QueryBuyerOrderPaymentListArgs = {
  input: __InputPaymentInvoicesPagination;
};


export type __QueryBuyerOrderPaymentListYearsArgs = {
  input: __InputPaymentInvoicesPaginationFilters;
};


export type __QueryBuyerOrderProductsArgs = {
  input: __InputBuyerOrderProductsCursor;
};


export type __QueryBuyerOrdersArgs = {
  payment: __InputIdString;
};


export type __QueryBuyerOrdersListArgs = {
  input: __InputPagination;
};


export type __QueryBuyerPaymentCardsArgs = {
  input: __InputBuyerEverypayCards;
};


export type __QueryBuyerPostExistsArgs = {
  input: __InputPostsFind;
};


export type __QueryBuyerPostMultigetArgs = {
  input: __InputProductIds;
};


export type __QueryBuyerPostOneArgs = {
  input: __InputId;
};


export type __QueryBuyerPostsArgs = {
  input: __InputPostsFind;
};


export type __QueryBuyerPostsAllArgs = {
  input: __InputBuyerPosts;
};


export type __QueryBuyerPostsProductArgs = {
  input: __InputProductId;
};


export type __QueryBuyerProductHistoryArgs = {
  input: __InputBuyerProductHistoryCursor;
};


export type __QueryBuyerReturnArgs = {
  input: __OrderInput;
};


export type __QueryBuyerReturnOrdersArgs = {
  input: __InputPagination;
};


export type __QueryBuyerReturnsArgs = {
  input: __InputPagination;
};


export type __QueryBuyerShipmentHistoryArgs = {
  input: __InputId;
};


export type __QueryBuyerSubscriptionsCheckArgs = {
  sellerIds: __InputIds;
};


export type __QueryBuyerUpcomingDeliveryOptionsArgs = {
  input: __InputCheckoutUpcomingDeliveryOptions;
};


export type __QueryBuyerUpcomingEnterPreEnterArgs = {
  input: __InputUpcomingEntryEnter;
};


export type __QueryBuyerUpcomingEntriesArgs = {
  input: __InputPagination;
};


export type __QueryBuyerUpcomingEntryArgs = {
  input: __InputProductId;
};


export type __QueryCatalogDepartmentsArgs = {
  input: __InputSellerId;
};


export type __QueryCatalogFiltersInitArgs = {
  input: __InputSearchCatalogFiltersInit;
};


export type __QueryCatalogFiltersSellerArgs = {
  input: __InputSearchCatalogFiltersSeller;
};


export type __QueryCatalogProductArgs = {
  input: __InputProductGet;
};


export type __QueryCatalogProductPrivateArgs = {
  input: __InputIds;
};


export type __QueryCatalogSearchArgs = {
  input: __SearchOptionsInput;
};


export type __QueryCatalogSearchTermArgs = {
  input: __SearchTermInput;
};


export type __QueryCatalogSellerArgs = {
  input: __InputCatalog;
};


export type __QueryInternalImageMultigetArgs = {
  input: Array<Scalars['String']['input']>;
};


export type __QueryMarketCountriesArgs = {
  input: __InputPagination;
  sellerId: __InputId;
};


export type __QueryPublicArticleArgs = {
  input: __InputSlug;
};


export type __QueryPublicArticleCommentOverviewArgs = {
  input: __InputPostsFind;
};


export type __QueryPublicArticlesArgs = {
  input: __InputArticlesFilter;
};


export type __QueryPublicArticlesFiltersArgs = {
  input: __InputArticlesFilter;
};


export type __QueryPublicB2bActiveArgs = {
  input: __InputIdString;
};


export type __QueryPublicBoardArgs = {
  input: __InputId;
};


export type __QueryPublicBoardsArgs = {
  input: __InputPublicBoard;
};


export type __QueryPublicDeliveryProductArgs = {
  input: __InputPublicDeliveryProduct;
};


export type __QueryPublicDeliverySellerArgs = {
  input: __InputPublicDeliverySeller;
};


export type __QueryPublicDeliverySellerOneArgs = {
  id: __InputId;
  input: __InputPublicDeliverySeller;
};


export type __QueryPublicDiscountCodeArgs = {
  input: __InputSellerId;
};


export type __QueryPublicInfoMultigetArgs = {
  input: __InputIds;
};


export type __QueryPublicListingsGroupArgs = {
  input: __InputPublicListingsGroup;
};


export type __QueryPublicListingsMultigetArgs = {
  input: Array<Scalars['String']['input']>;
};


export type __QueryPublicLockersArgs = {
  input: __InputPublicLockers;
};


export type __QueryPublicLockersCitiesArgs = {
  input: __InputLockersCities;
};


export type __QueryPublicLockersMultigetArgs = {
  input: __InputIds;
};


export type __QueryPublicMarketCountryMultigetArgs = {
  iso2: Array<Scalars['String']['input']>;
};


export type __QueryPublicPageArgs = {
  input: __InputSellerPageSf;
};


export type __QueryPublicPostsArgs = {
  input: __PostCursorInput;
};


export type __QueryPublicPostsGetOneArgs = {
  input: __InputId;
};


export type __QueryPublicPreviewBoxArgs = {
  input: __InputUiPreviewBox;
};


export type __QueryPublicProductInfoArgs = {
  input: __InputProductExtra;
};


export type __QueryPublicProductRecomendedArgs = {
  input: __InputProductRecomended;
};


export type __QueryPublicProfileArgs = {
  input: __InputHandle;
};


export type __QueryPublicProfileHandleFreeArgs = {
  input: __InputHandle;
};


export type __QueryPublicProfilesArgs = {
  input: Array<Scalars['ObjectId']['input']>;
};


export type __QueryPublicQuestionsOverviewArgs = {
  input: __InputPostsFind;
};


export type __QueryPublicReturnAddressArgs = {
  sellerId: Scalars['ObjectId']['input'];
};


export type __QueryPublicReviewsOverviewArgs = {
  input: __InputPostsFind;
};


export type __QueryPublicReviewsPhotosArgs = {
  input: __InputPostReviewsPhotos;
};


export type __QueryPublicSellerArgs = {
  handle: Scalars['String']['input'];
};


export type __QueryPublicSellerCareIconsArgs = {
  sellerId: Scalars['ObjectId']['input'];
};


export type __QueryPublicSellerCertificatesArgs = {
  sellerId: Scalars['ObjectId']['input'];
};


export type __QueryPublicSellerDocumentArgs = {
  input: __InputSellerDocumentSf;
};


export type __QueryPublicSellerDocumentAdsArgs = {
  input: __InputSellerDocumentSf;
};


export type __QueryPublicSellerFabricsArgs = {
  sellerId: Scalars['ObjectId']['input'];
};


export type __QueryPublicSellerFactoriesArgs = {
  input: __InputProductExtraShops;
};


export type __QueryPublicSellerFaqArgs = {
  sellerId: Scalars['ObjectId']['input'];
};


export type __QueryPublicSellerFaqDocArgs = {
  slug: Scalars['String']['input'];
};


export type __QueryPublicSellerReturnsArgs = {
  sellerId: Scalars['ObjectId']['input'];
};


export type __QueryPublicSellerShopsArgs = {
  input: __InputProductExtraShops;
};


export type __QueryPublicSellerWarrantyArgs = {
  sellerId: Scalars['ObjectId']['input'];
};


export type __QueryPublicSizeGuideArgs = {
  guideId: Scalars['ObjectId']['input'];
};


export type __QueryPublicSizeGuidesArgs = {
  input: __InputPagination;
  sellerId: Scalars['ObjectId']['input'];
};


export type __QuerySellerArgs = {
  input: Scalars['ObjectId']['input'];
};


export type __QuerySellerArticlesTagsArgs = {
  query: Scalars['String']['input'];
};


export type __QuerySellersArgs = {
  find: __EnumSellerFind;
  input: __InputPagination;
};

export type __ResponsProductType = __MutationResponeMsg & {
  deleted?: Maybe<Scalars['Boolean']['output']>;
  productType?: Maybe<__SellerProductType>;
  responseInfo: __ResponseInfo;
};

export type __ResponsSellerAdminInvitation = __MutationResponeMsg & {
  deleted?: Maybe<Scalars['Boolean']['output']>;
  doc?: Maybe<__SellerAdminInvitation>;
  responseInfo: __ResponseInfo;
};

export type __ResponsSellerBuyer = __MutationResponeMsg & {
  deleted?: Maybe<Scalars['Boolean']['output']>;
  responseInfo: __ResponseInfo;
  user?: Maybe<__User>;
};

export type __ResponsSellerColors = __MutationResponeMsg & {
  deleted?: Maybe<Scalars['Boolean']['output']>;
  doc?: Maybe<__DocumentColor>;
  responseInfo: __ResponseInfo;
};

export type __ResponsSellerDeliveryZones = __MutationResponeMsg & {
  deleted?: Maybe<Scalars['Boolean']['output']>;
  doc?: Maybe<__SellerDeliveryZone>;
  responseInfo: __ResponseInfo;
};

export type __ResponsSellerDocumentTemplates = __MutationResponeMsg & {
  deleted?: Maybe<Scalars['Boolean']['output']>;
  responseInfo: __ResponseInfo;
  template?: Maybe<__SellerDocumentTemplate>;
};

export type __ResponsSellerLinks = __MutationResponeMsg & {
  deleted?: Maybe<Scalars['Boolean']['output']>;
  doc?: Maybe<__SellerLinkOutside>;
  responseInfo: __ResponseInfo;
};

export type __ResponsSellerSubs = __MutationResponeMsg & {
  deleted?: Maybe<Scalars['Boolean']['output']>;
  doc?: Maybe<__AdminSub>;
  responseInfo: __ResponseInfo;
};

export type __ResponsSellerTextHelp = __MutationResponeMsg & {
  responseInfo: __ResponseInfo;
  text?: Maybe<Scalars['String']['output']>;
};

export type __ResponsSeoProblems = __MutationResponeMsg & {
  deleted?: Maybe<Scalars['Boolean']['output']>;
  doc?: Maybe<__SeoProblem>;
  keyword?: Maybe<__SeoProblemKeyword>;
  responseInfo: __ResponseInfo;
  settings?: Maybe<__SeoProblemsSettings>;
};

export type __ResponseAuthBuyer = __MutationResponeMsg & {
  admin?: Maybe<__AdminAuth>;
  authChanged?: Maybe<Scalars['Boolean']['output']>;
  codeRefNumber?: Maybe<__AuthCodeRef>;
  emailInvalid?: Maybe<Scalars['Boolean']['output']>;
  emailStatus?: Maybe<Scalars['Boolean']['output']>;
  me?: Maybe<__Me>;
  responseInfo: __ResponseInfo;
  urlCodeValid?: Maybe<Scalars['Boolean']['output']>;
  urlCodeValidCb?: Maybe<Scalars['String']['output']>;
};

export type __ResponseBuyerAddress = __MutationResponeMsg & {
  address?: Maybe<__BuyerAddressDoc>;
  addressNew?: Maybe<__BuyerAddress>;
  defaultAddress?: Maybe<__BuyerAddress>;
  invoiceNew?: Maybe<Scalars['ObjectId']['output']>;
  me: __Me;
  responseInfo: __ResponseInfo;
};

export type __ResponseBuyerB2b = __MutationResponeMsg & {
  b2b?: Maybe<__SellerBusiness>;
  deleted?: Maybe<Scalars['Boolean']['output']>;
  request?: Maybe<__SellerBusinessRequest>;
  responseInfo: __ResponseInfo;
};

export type __ResponseBuyerCart = __MutationResponeMsg & {
  cart?: Maybe<__BuyerCart>;
  responseInfo: __ResponseInfo;
};

export type __ResponseBuyerEverypayCard = __MutationResponeMsg & {
  createStart?: Maybe<__ResponseBuyerEverypayCardCreate>;
  deleted?: Maybe<Scalars['Boolean']['output']>;
  doc?: Maybe<__BuyerEverypayCard>;
  responseInfo: __ResponseInfo;
};

export type __ResponseBuyerEverypayCardCreate = {
  paymentLink: Scalars['String']['output'];
};

export type __ResponseBuyerInformation = __MutationResponeMsg & {
  codeRefNumber?: Maybe<__AuthCodeRef>;
  me?: Maybe<__Me>;
  passwordExists?: Maybe<Scalars['Boolean']['output']>;
  responseInfo: __ResponseInfo;
};

export type __ResponseBuyerLikes = __MutationResponeMsg & {
  buyerLikes?: Maybe<Array<__BuyerLikes>>;
  likes?: Maybe<__LikesRef>;
  responseInfo: __ResponseInfo;
};

export type __ResponseBuyerNotify = __MutationResponeMsg & {
  doc?: Maybe<__BuyerNotifyDoc>;
  responseInfo: __ResponseInfo;
};

export type __ResponseBuyerProductHistory = __MutationResponeMsg & {
  doc?: Maybe<__BuyerProductHistoryItem>;
  responseInfo: __ResponseInfo;
  stats?: Maybe<__BuyerProductHistoryStats>;
};

export type __ResponseBuyerSubscription = __MutationResponeMsg & {
  check?: Maybe<__BuyerSubscriptionsItem>;
  responseInfo: __ResponseInfo;
};

export type __ResponseCheckoutQuote = __MutationResponeMsg & {
  order?: Maybe<__SellerOrderDoc>;
  paymentInvoice?: Maybe<__PaymentInvoiceDoc>;
  quote?: Maybe<__CheckoutQuote>;
  responseInfo: __ResponseInfo;
};

export type __ResponseGiftcard = __MutationResponeMsg & {
  giftcard?: Maybe<__Giftcard>;
  paymentInvoice?: Maybe<__PaymentInvoiceDoc>;
  responseInfo: __ResponseInfo;
};

export type __ResponseInfo = {
  error?: Maybe<Scalars['String']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  status: __ResponseInfoStatus;
  success: Scalars['Boolean']['output'];
};

export const __ResponseInfoStatus = {
  Error: 'Error',
  Forbidden: 'Forbidden',
  InternalServerError: 'InternalServerError',
  NotFound: 'NotFound',
  Success: 'Success'
} as const;

export type __ResponseInfoStatus = typeof __ResponseInfoStatus[keyof typeof __ResponseInfoStatus];
export type __ResponseMarketCountry = __MutationResponeMsg & {
  deleted?: Maybe<Scalars['Boolean']['output']>;
  doc?: Maybe<__MarketCountry>;
  responseInfo: __ResponseInfo;
};

export type __ResponseSellerArticle = __MutationResponeMsg & {
  article?: Maybe<__SellerArticle>;
  deleted?: Maybe<Scalars['Boolean']['output']>;
  responseInfo: __ResponseInfo;
};

export type __ResponseSellerBusiness = __MutationResponeMsg & {
  business?: Maybe<__SellerBusiness>;
  deleted?: Maybe<Scalars['Boolean']['output']>;
  responseInfo: __ResponseInfo;
};

export type __ResponseSellerCatalogVisibility = __MutationResponeMsg & {
  deleted?: Maybe<Scalars['Boolean']['output']>;
  doc?: Maybe<__SellerCatalogVisibility>;
  responseInfo: __ResponseInfo;
};

export type __ResponseSellerDepartments = __MutationResponeMsg & {
  deleted?: Maybe<Scalars['Boolean']['output']>;
  doc?: Maybe<__SellerDepartmentItem>;
  responseInfo: __ResponseInfo;
};

export type __ResponseSellerPayouts = __MutationResponeMsg & {
  doc?: Maybe<Array<__SellerPayout>>;
  responseInfo: __ResponseInfo;
};

export type __ResponseSellerPriceGroup = __MutationResponeMsg & {
  deleted?: Maybe<Scalars['Boolean']['output']>;
  priceGroup?: Maybe<__SellerPriceGroup>;
  responseInfo: __ResponseInfo;
};

export type __ResponseSellerProduct = __MutationResponeMsg & {
  createdIds?: Maybe<Array<Scalars['ObjectId']['output']>>;
  group?: Maybe<Array<__ProductGroup>>;
  responseInfo: __ResponseInfo;
};

export type __ResponseSellerQuote = __MutationResponeMsg & {
  deleted?: Maybe<Scalars['Boolean']['output']>;
  doc?: Maybe<__CheckoutQuote>;
  productRetailDiscount?: Maybe<__CheckoutQuoteCalcRetailProductDiscount>;
  responseInfo: __ResponseInfo;
};

export type __ResponseSellerReturn = __MutationResponeMsg & {
  doc?: Maybe<__SellerReturn>;
  responseInfo: __ResponseInfo;
};

export type __ResponseSellerSubscription = __MutationResponeMsg & {
  doc?: Maybe<__SellerSubscription>;
  responseInfo: __ResponseInfo;
};

export type __ResponseUpcomingEntry = __MutationResponeMsg & {
  doc?: Maybe<__UpcomingEntry>;
  paymentInvoice?: Maybe<__PaymentInvoiceDoc>;
  responseInfo: __ResponseInfo;
};

export type __ResposeSellerProfile = __MutationResponeMsg & {
  deleted?: Maybe<Scalars['Boolean']['output']>;
  doc?: Maybe<__SellerProfile>;
  responseInfo: __ResponseInfo;
};

export type __SearchCatalogFilters2Deparament = {
  count?: Maybe<Scalars['Int']['output']>;
  key: Scalars['String']['output'];
};

export type __SearchCatalogFilters2Deparaments = {
  items?: Maybe<Array<__SearchCatalogFilters2Deparament>>;
  total?: Maybe<Scalars['Int']['output']>;
};

export type __SearchCatalogFilters2LimitToCount = {
  items: Array<__SearchCatalogFilters2LimitToCountItems>;
};

export type __SearchCatalogFilters2LimitToCountItems = {
  count?: Maybe<Scalars['Int']['output']>;
  key?: Maybe<__CatalogSearchLimitTo>;
};

export type __SearchCatalogFilters2Range = {
  histogram: Array<__SearchCatalogFilters2RangeHistogramItem>;
  max?: Maybe<Scalars['Int']['output']>;
  min?: Maybe<Scalars['Int']['output']>;
};

export type __SearchCatalogFilters2RangeHistogramItem = {
  count: Scalars['Int']['output'];
  key: Scalars['Float']['output'];
};

export type __SearchCatalogFiltersInit = {
  multi?: Maybe<Array<__ListingOption>>;
  tags?: Maybe<Array<__SearchCatalogFiltersSellerTag>>;
};

export type __SearchCatalogFiltersSeller = {
  deparamentsCount?: Maybe<__SearchCatalogFilters2Deparaments>;
  input: __InputSearchCatalogFiltersSellerType;
  limitToCount?: Maybe<__SearchCatalogFilters2LimitToCount>;
  multi?: Maybe<__SearchCatalogFiltersSellerMulti>;
  range?: Maybe<__SearchCatalogFilters2Range>;
  tags?: Maybe<Array<__SearchCatalogFiltersSellerTag>>;
};

export type __SearchCatalogFiltersSellerMulti = {
  items: Array<__SearchCatalogFiltersSellerMultiItem>;
};

export type __SearchCatalogFiltersSellerMultiItem = {
  count: Scalars['Int']['output'];
  item: __ListingOption;
};

export type __SearchCatalogFiltersSellerTag = {
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  range: Scalars['Boolean']['output'];
};

export type __SearchCatalogSeller = {
  breadcrums?: Maybe<Array<__SearchCatalogSellerBreadcrums>>;
  catalogUiFiltersValues?: Maybe<Array<Scalars['String']['output']>>;
  departmentName?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  document?: Maybe<__SellerDocumentPublic>;
  image?: Maybe<__Image>;
  input?: Maybe<__CatalogInputType>;
  items?: Maybe<Array<__ProductListingBox>>;
  pageInfo?: Maybe<__PageInfo>;
  slugEn?: Maybe<Scalars['String']['output']>;
  slugLt?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
};

export type __SearchCatalogSellerBreadcrums = {
  sellerId?: Maybe<Scalars['String']['output']>;
  slug: Scalars['String']['output'];
  title: Scalars['String']['output'];
  type: __EnumSearchCatalogSellerBreadcrums;
};

export type __SearchOptions = {
  count: Scalars['Int']['output'];
  key: Scalars['String']['output'];
  title: Scalars['String']['output'];
};

export type __SearchOptionsInput = {
  query: Scalars['String']['input'];
  seller: __InputSellerId;
};

export type __SearchOptionsRes = {
  products?: Maybe<Array<__ProductListingPreviewBox>>;
  suggestions?: Maybe<Array<__SearchOptions>>;
  totalCount?: Maybe<Scalars['Int']['output']>;
};

export type __SearchTermInput = {
  query: Scalars['String']['input'];
  seller: __InputSellerId;
  term: Scalars['String']['input'];
};

export type __SearchTermInputType = {
  query: Scalars['String']['output'];
  term: Scalars['String']['output'];
};

export type __SearchTermRes = {
  input?: Maybe<__SearchTermInputType>;
  products?: Maybe<Array<__ProductListingPreviewBox>>;
  totalCount?: Maybe<Scalars['Int']['output']>;
};

export type __SelleCheckoutDraftProduct = {
  _uiPrice: __ProductListingBoxUiPrice;
  action?: Maybe<__CartProductActionType>;
  available?: Maybe<__CartAvailability>;
  discounts?: Maybe<Array<__CheckoutDraftValuesDiscount>>;
  id: Scalars['String']['output'];
  inStock?: Maybe<Scalars['Boolean']['output']>;
  isDiscounted?: Maybe<Scalars['Boolean']['output']>;
  priceTotal: __Price2Total;
  priceTotalBase: __Price2Total;
  priceUnit: __Price2Total;
  priceUnitBase?: Maybe<__Price2Total>;
  quantity: Scalars['Float']['output'];
  stockLeft?: Maybe<Scalars['Float']['output']>;
  weightGramsTotal?: Maybe<Scalars['Int']['output']>;
};

export type __Seller = {
  _id: Scalars['ObjectId']['output'];
  access?: Maybe<__SellerAccess>;
  activity?: Maybe<__SellerActivity>;
  adminSubs?: Maybe<__AdminSubs>;
  authInvitations?: Maybe<__SellerAdminInvitations>;
  business?: Maybe<__SellerBusiness>;
  businessInit?: Maybe<__SellerBusinessInit>;
  businessRequest?: Maybe<__SellerBusinessRequest>;
  businessRequests?: Maybe<__SellerBusinessRequests>;
  businesses?: Maybe<__SellerBusinesses>;
  buyer?: Maybe<__SellerBuyer>;
  buyerCheckout?: Maybe<__SellerCheckoutFull>;
  buyerCheckouts?: Maybe<__SellerCheckoutPagination>;
  buyers?: Maybe<__SellerBuyers>;
  colors?: Maybe<__DocumentColorSearch>;
  deliveries?: Maybe<__SellerDeliveries>;
  delivery?: Maybe<__SellerDelivery>;
  deliveryLockerAll?: Maybe<__SellerDeliveryLockerChoices>;
  deliveryLockersItems?: Maybe<__SellerLockerItems>;
  deliveryZones?: Maybe<__SellerDeliveryZones>;
  deliveryZonesForCountry?: Maybe<Array<__SellerDeliveryZone>>;
  discount?: Maybe<__SellerDiscount>;
  discountCodes?: Maybe<__SellerDiscountCodes>;
  discounts?: Maybe<__SellerDiscounts>;
  document?: Maybe<__SellerDocumentView>;
  documents?: Maybe<__SellerDocuments>;
  documentsTemplates?: Maybe<__SellerDocumentTemplates>;
  files?: Maybe<__SellerFiles>;
  full?: Maybe<__SellerDoc>;
  googleProductCategoryList?: Maybe<__GoogleProductCategoryList>;
  image?: Maybe<__Image>;
  imageTags?: Maybe<__PublicArticlesFilters>;
  images?: Maybe<__SellerImages>;
  linkPreview?: Maybe<__SellerLinkPreview>;
  linksOutside?: Maybe<__SellerLinksOutside>;
  listings?: Maybe<__Listings>;
  logs?: Maybe<__LoggingDocs>;
  notification?: Maybe<__SellerAppNotifications>;
  order?: Maybe<__SellerOrderDoc>;
  orderPdfInvoice?: Maybe<__SellerOrderDocPdf>;
  orders?: Maybe<__SellerOrderPagination>;
  ordersMultiget?: Maybe<Array<__SellerOrderDoc>>;
  page?: Maybe<__SellerPage>;
  pageSection?: Maybe<__SellerPageSection>;
  pageSections?: Maybe<__SellerPageSections>;
  pages?: Maybe<__SellerPages>;
  paymentInvoice?: Maybe<__PaymentInvoiceDoc>;
  paymentInvoices?: Maybe<__PaymentInvoicesPagination>;
  paymentProviders?: Maybe<__PaymentProvidersPagination>;
  payout?: Maybe<__SellerPayout>;
  payouts?: Maybe<__SellerPayouts>;
  priceGroup?: Maybe<__SellerPriceGroup>;
  priceGroups?: Maybe<__SellerPriceGroups>;
  product?: Maybe<__ProductVariant>;
  productCount?: Maybe<Scalars['Int']['output']>;
  productGroup?: Maybe<__ProductGroup>;
  productMultiget?: Maybe<__ProductsMultiget>;
  productType?: Maybe<__SellerProductType>;
  productTypes?: Maybe<__SellerProductTypes>;
  products?: Maybe<__ProductVariants>;
  profile?: Maybe<__SellerProfile>;
  profiles?: Maybe<__SellerProfiles>;
  quote?: Maybe<__CheckoutQuote>;
  quotes?: Maybe<__CheckoutQuotes>;
  quotesActions?: Maybe<__CheckoutQuoteActions>;
  sellerArticle?: Maybe<__SellerArticle>;
  sellerArticles?: Maybe<__SellerArticles>;
  sellerBundle?: Maybe<__SellerBundle>;
  sellerBundles?: Maybe<__SellerBundles>;
  sellerCatalogUi?: Maybe<__SellerCatalogUi>;
  sellerCatalogUis?: Maybe<__SellerCatalogUis>;
  sellerCatalogVisibility?: Maybe<__SellerCatalogVisibility>;
  sellerCatalogVisibilityList?: Maybe<__SellerCatalogVisibilityList>;
  sellerDepartments?: Maybe<__SellerDepartments>;
  sellerFaq?: Maybe<__SellerFaqFull>;
  sellerFaqList?: Maybe<__SellerFaqList>;
  sellerGiftcard?: Maybe<__SellerGiftcard>;
  sellerGiftcards?: Maybe<__SellerGiftcards>;
  sellerPost?: Maybe<__PostNodes>;
  sellerPostReplies?: Maybe<__PostsPagination>;
  sellerPosts?: Maybe<__PostsPagination>;
  sellerProductFieldValuesUis?: Maybe<__SellerProductFieldValuesUis>;
  sellerProductFields?: Maybe<__SellerProductFields>;
  sellerProductInfoList?: Maybe<__SellerProductInfoList>;
  sellerReturn?: Maybe<__SellerReturn>;
  sellerReturns?: Maybe<__SellerReturns>;
  sellerSubscription?: Maybe<__SellerSubscription>;
  sellerSubscriptions?: Maybe<__SellerSubscriptions>;
  seoProblems?: Maybe<__SeoProblems>;
  seoProblemsKeywords?: Maybe<__SeoProblemsKeywords>;
  seoProblemsSettings?: Maybe<__SeoProblemsSettings>;
  shipments?: Maybe<__SellerShipments>;
  sizeGuides?: Maybe<__SellerSizeGuides>;
};


export type __SellerActivityArgs = {
  input: __InputSellerActivity;
};


export type __SellerAdminSubsArgs = {
  input: __InputPagination;
};


export type __SellerAuthInvitationsArgs = {
  input: __InputPagination;
};


export type __SellerBusinessArgs = {
  input: __InputId;
};


export type __SellerBusinessRequestArgs = {
  input: __InputId;
};


export type __SellerBusinessRequestsArgs = {
  input: __InputPagination;
};


export type __SellerBusinessesArgs = {
  find?: InputMaybe<__InputSellerBusinessesFind>;
  input: __InputPagination;
};


export type __SellerBuyerArgs = {
  input: __InputId;
};


export type __SellerBuyerCheckoutArgs = {
  checkoutId: Scalars['ObjectId']['input'];
};


export type __SellerBuyerCheckoutsArgs = {
  buyerId: Scalars['ObjectId']['input'];
  input: __InputPagination;
};


export type __SellerBuyersArgs = {
  input: __InputPagination;
  type: __EnumUserType;
};


export type __SellerColorsArgs = {
  input: __InputDocumentColorSearch;
};


export type __SellerDeliveriesArgs = {
  input: __InputPagination;
};


export type __SellerDeliveryArgs = {
  deliveryId: Scalars['ObjectId']['input'];
};


export type __SellerDeliveryLockersItemsArgs = {
  input: __InputSellerLockerItems;
};


export type __SellerDeliveryZonesArgs = {
  input: __InputPagination;
};


export type __SellerDeliveryZonesForCountryArgs = {
  iso2: Array<Scalars['String']['input']>;
};


export type __SellerDiscountArgs = {
  input: __InputId;
};


export type __SellerDiscountCodesArgs = {
  input: __InputPagination;
};


export type __SellerDiscountsArgs = {
  find?: InputMaybe<__InputSellerDiscountsFind>;
  input?: InputMaybe<__InputPagination>;
};


export type __SellerDocumentArgs = {
  input: __InputDocumentView;
};


export type __SellerDocumentsArgs = {
  input: __InputPagination;
};


export type __SellerDocumentsTemplatesArgs = {
  input: __InputPagination;
};


export type __SellerFilesArgs = {
  input: __InputPagination;
};


export type __SellerImageArgs = {
  input: __InputId;
};


export type __SellerImageTagsArgs = {
  input?: InputMaybe<Scalars['String']['input']>;
};


export type __SellerImagesArgs = {
  input: __InputPagination;
};


export type __SellerLinkPreviewArgs = {
  input: __InputSellerLink;
};


export type __SellerLinksOutsideArgs = {
  input: __InputPagination;
};


export type __SellerListingsArgs = {
  input: __InputListingsPagination;
};


export type __SellerLogsArgs = {
  input: __InputLoggingPagination;
};


export type __SellerOrderArgs = {
  input: __OrderInput;
};


export type __SellerOrderPdfInvoiceArgs = {
  input: __InputSellerOrderDocPdf;
};


export type __SellerOrdersArgs = {
  input: __InputPagination;
  options?: InputMaybe<__OrdersPaginationOptions>;
};


export type __SellerOrdersMultigetArgs = {
  input: __InputIds;
};


export type __SellerPageArgs = {
  input: __InputId;
};


export type __SellerPageSectionArgs = {
  input: __InputId;
};


export type __SellerPageSectionsArgs = {
  input: __InputPagination;
};


export type __SellerPagesArgs = {
  archived?: InputMaybe<Scalars['Boolean']['input']>;
  draftsOnly?: InputMaybe<Scalars['Boolean']['input']>;
  input: __InputPagination;
};


export type __SellerPaymentInvoiceArgs = {
  input: __InputId;
};


export type __SellerPaymentInvoicesArgs = {
  input: __InputPayments;
};


export type __SellerPaymentProvidersArgs = {
  input: __InputPaymentProvidersPagination;
};


export type __SellerPayoutArgs = {
  input: __InputId;
};


export type __SellerPayoutsArgs = {
  find: __InputSellerPayoutFind;
  input: __InputPagination;
};


export type __SellerPriceGroupArgs = {
  input: __InputId;
};


export type __SellerPriceGroupsArgs = {
  find?: InputMaybe<__InputPriceGroupsFind>;
  input: __InputPagination;
};


export type __SellerProductArgs = {
  input: __InputId;
};


export type __SellerProductGroupArgs = {
  input: __InputId;
};


export type __SellerProductMultigetArgs = {
  input: __InputProductsMultiget;
};


export type __SellerProductTypeArgs = {
  input: __InputId;
};


export type __SellerProductTypesArgs = {
  input: __InputPagination;
};


export type __SellerProductsArgs = {
  find?: InputMaybe<__InputSellerProductFind>;
  input: __InputPagination;
};


export type __SellerProfileArgs = {
  input: __InputId;
};


export type __SellerProfilesArgs = {
  input: __InputPagination;
};


export type __SellerQuoteArgs = {
  input: __InputId;
};


export type __SellerQuotesArgs = {
  input: __InputPagination;
  options: __InputSellerQuotesPagination;
};


export type __SellerQuotesActionsArgs = {
  input: __InputCheckoutQuoteActions;
};


export type __SellerSellerArticleArgs = {
  input: __InputId;
};


export type __SellerSellerArticlesArgs = {
  input: __InputPagination;
};


export type __SellerSellerBundleArgs = {
  input: __InputId;
};


export type __SellerSellerBundlesArgs = {
  input: __InputPagination;
};


export type __SellerSellerCatalogUiArgs = {
  input: __InputId;
};


export type __SellerSellerCatalogUisArgs = {
  input: __InputSellerCatalogUis;
};


export type __SellerSellerCatalogVisibilityArgs = {
  input: __InputId;
};


export type __SellerSellerCatalogVisibilityListArgs = {
  find?: InputMaybe<__InputCatalogVisibilityFind>;
  input: __InputPagination;
};


export type __SellerSellerDepartmentsArgs = {
  input: __InputPagination;
};


export type __SellerSellerFaqArgs = {
  input: __InputId;
};


export type __SellerSellerFaqListArgs = {
  input: __InputPagination;
};


export type __SellerSellerGiftcardArgs = {
  input: __InputId;
};


export type __SellerSellerGiftcardsArgs = {
  input: __InputPagination;
};


export type __SellerSellerPostArgs = {
  input: __InputId;
};


export type __SellerSellerPostRepliesArgs = {
  input: __InputPagination;
  parent: __InputId;
};


export type __SellerSellerPostsArgs = {
  input: __InputPagination;
  status: __EnumPostStatus;
  type: __SellerPostViewType;
};


export type __SellerSellerProductFieldValuesUisArgs = {
  input: __InputSellerProductFieldValuesUis;
};


export type __SellerSellerProductFieldsArgs = {
  input: __InputPagination;
};


export type __SellerSellerProductInfoListArgs = {
  input: __InputPagination;
  type?: InputMaybe<__SellerProductInfoType>;
};


export type __SellerSellerReturnArgs = {
  input: __InputId;
};


export type __SellerSellerReturnsArgs = {
  input: __InputPagination;
  options: __InputSellerReturns;
};


export type __SellerSellerSubscriptionArgs = {
  input: __InputId;
};


export type __SellerSellerSubscriptionsArgs = {
  input: __InputPagination;
};


export type __SellerSeoProblemsArgs = {
  input: __InputSeoProblemsSearch;
};


export type __SellerSeoProblemsKeywordsArgs = {
  input: __InputPagination;
};


export type __SellerShipmentsArgs = {
  input: __InputPagination;
};


export type __SellerSizeGuidesArgs = {
  input: __InputSizeGuide;
};

export type __SellerAccess = {
  admins: Array<__User>;
  sharedSellers: Array<__SellerAccessSeller>;
};

export type __SellerAccessSeller = {
  limit?: Maybe<Array<Scalars['String']['output']>>;
  seller: __SellerDoc;
};

export type __SellerActivity = {
  cursorNext?: Maybe<Scalars['String']['output']>;
  items: Array<__SellerActivityItem>;
};

export type __SellerActivityItem = {
  _id: Scalars['ObjectId']['output'];
  changes?: Maybe<Array<__SellerActivityItemChanges>>;
  createdAt: Scalars['MongoDate']['output'];
  msg: Scalars['String']['output'];
  userId?: Maybe<Scalars['ObjectId']['output']>;
  userName?: Maybe<Scalars['String']['output']>;
};

export type __SellerActivityItemChanges = {
  from?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  to?: Maybe<Scalars['String']['output']>;
};

export type __SellerAdminInvitation = {
  _id: Scalars['ObjectId']['output'];
  createdUserId?: Maybe<Scalars['ObjectId']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  isActive?: Maybe<Scalars['Boolean']['output']>;
};

export type __SellerAdminInvitations = __PaginatedResults & {
  info?: Maybe<__PaginationInfo>;
  items?: Maybe<Array<__SellerAdminInvitation>>;
};

export type __SellerAppNotifications = {
  _id: Scalars['ObjectId']['output'];
  b2b?: Maybe<Scalars['Int']['output']>;
  orders?: Maybe<Scalars['Int']['output']>;
  payments?: Maybe<Scalars['Int']['output']>;
  payouts?: Maybe<Scalars['Int']['output']>;
  postsComments?: Maybe<Scalars['Int']['output']>;
  postsQuestions?: Maybe<Scalars['Int']['output']>;
  postsReviews?: Maybe<Scalars['Int']['output']>;
  quote?: Maybe<Scalars['Int']['output']>;
  returns?: Maybe<Scalars['Int']['output']>;
};

export type __SellerArticle = {
  _author?: Maybe<__SellerProfile>;
  _id: Scalars['ObjectId']['output'];
  _listings?: Maybe<Array<__ProductListingBox>>;
  _productCount?: Maybe<Scalars['Int']['output']>;
  authorId?: Maybe<Scalars['ObjectId']['output']>;
  createdAt?: Maybe<Scalars['MongoDate']['output']>;
  document?: Maybe<__SellerDocumentPublic>;
  image?: Maybe<__Image>;
  isActive?: Maybe<Scalars['Boolean']['output']>;
  likes?: Maybe<__LikesRef>;
  sellerId: Scalars['ObjectId']['output'];
  slug: Scalars['String']['output'];
  tags?: Maybe<Array<Scalars['String']['output']>>;
  title?: Maybe<__Text>;
  type: __SellerArticleType;
  updatedAt?: Maybe<Scalars['MongoDate']['output']>;
};


export type __SellerArticle_ListingsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
};

export type __SellerArticleRef = {
  _id?: Maybe<Scalars['ObjectId']['output']>;
  doc?: Maybe<__SellerArticle>;
};

export const __SellerArticleType = {
  Article: 'Article',
  Collection: 'Collection',
  Event: 'Event'
} as const;

export type __SellerArticleType = typeof __SellerArticleType[keyof typeof __SellerArticleType];
export type __SellerArticles = __PaginatedResults & {
  info?: Maybe<__PaginationInfo>;
  items?: Maybe<Array<__SellerArticle>>;
};

export type __SellerBundle = {
  _id: Scalars['ObjectId']['output'];
  description?: Maybe<__Text>;
  discountId?: Maybe<Scalars['ObjectId']['output']>;
  entries?: Maybe<Array<__PriceVariantBundle>>;
  imageTagged?: Maybe<__ImageTagged>;
  isActive?: Maybe<Scalars['Boolean']['output']>;
  percentValue: Scalars['Int']['output'];
  sellerId: Scalars['ObjectId']['output'];
  title?: Maybe<__Text>;
};

export type __SellerBundleResponse = __MutationResponeMsg & {
  deleted?: Maybe<Scalars['Boolean']['output']>;
  doc?: Maybe<__SellerBundle>;
  responseInfo: __ResponseInfo;
};

export type __SellerBundles = __PaginatedResults & {
  info?: Maybe<__PaginationInfo>;
  items?: Maybe<Array<__SellerBundle>>;
};

export type __SellerBusiness = {
  _admin?: Maybe<__SellerBusinessAdmin>;
  _id: Scalars['ObjectId']['output'];
  _manager?: Maybe<__SellerProfile>;
  _ui?: Maybe<__SellerBusinessUi>;
  _user?: Maybe<__User>;
  billingDetails: __SellerBusinessBillingDetails;
  orderTotalMin?: Maybe<Scalars['Int']['output']>;
  priceGroups?: Maybe<Array<Scalars['ObjectId']['output']>>;
  profileId?: Maybe<Scalars['ObjectId']['output']>;
  sellerId: Scalars['ObjectId']['output'];
  status?: Maybe<__EnumSellerBusinessStatus>;
  website?: Maybe<Scalars['String']['output']>;
};

export type __SellerBusinessActive = {
  doc?: Maybe<__SellerBusinessActiveDoc>;
  id: Scalars['String']['output'];
};

export type __SellerBusinessActiveDoc = {
  _id: Scalars['ObjectId']['output'];
  claimed: Scalars['Boolean']['output'];
  email: Scalars['String']['output'];
  errorWrongAuth: Scalars['Boolean']['output'];
  isAuth: Scalars['Boolean']['output'];
  isAuthCorrect: Scalars['Boolean']['output'];
  title: Scalars['String']['output'];
};

export type __SellerBusinessAdmin = {
  emailHistory?: Maybe<Array<__SellerBusinessEmail>>;
};

export type __SellerBusinessBillingDetails = {
  company?: Maybe<__BuyerInvoiceCompany>;
  personal?: Maybe<__BuyerInvoicePersonal>;
};

export type __SellerBusinessEmail = {
  at: Scalars['MongoDate']['output'];
  email: Scalars['String']['output'];
  status: __EnumSellerBusinessStatus;
};

export type __SellerBusinessInit = {
  _id: Scalars['ObjectId']['output'];
  likuciai?: Maybe<__SellerFile>;
  pakuotes?: Maybe<__SellerFile>;
  prekesKnygosIrasai?: Maybe<__SellerFile>;
  skuFile?: Maybe<__SellerFile>;
  updatedAt?: Maybe<Scalars['MongoDate']['output']>;
};

export type __SellerBusinessRequest = {
  _id: Scalars['ObjectId']['output'];
  _user?: Maybe<__User>;
  createdAt?: Maybe<Scalars['MongoDate']['output']>;
  email: Scalars['String']['output'];
  invoice?: Maybe<__BuyerInvoice>;
  message: Scalars['String']['output'];
  website?: Maybe<Scalars['String']['output']>;
};

export type __SellerBusinessRequests = __PaginatedResults & {
  info?: Maybe<__PaginationInfo>;
  items?: Maybe<Array<__SellerBusinessRequest>>;
};

export type __SellerBusinessUi = {
  discountPercent?: Maybe<Scalars['Int']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  paymentDelayDays?: Maybe<Scalars['Int']['output']>;
};

export type __SellerBusinesses = __PaginatedResults & {
  info?: Maybe<__PaginationInfo>;
  items?: Maybe<Array<__SellerBusiness>>;
};

export type __SellerBuyer = {
  id: Scalars['ObjectId']['output'];
  profile?: Maybe<__SellerProfile>;
  user: __User;
};

export type __SellerBuyers = __PaginatedResults & {
  info?: Maybe<__PaginationInfo>;
  items?: Maybe<Array<__SellerBuyer>>;
};

export type __SellerCatalogInput = {
  department?: Maybe<Scalars['String']['output']>;
  filters?: Maybe<Array<__CatalogFiltersInputType>>;
  limitTo?: Maybe<Array<__CatalogSearchLimitTo>>;
  sellerId?: Maybe<Scalars['String']['output']>;
};

export type __SellerCatalogUi = {
  _id: Scalars['ObjectId']['output'];
  description?: Maybe<__Text>;
  document?: Maybe<__SellerDocumentPublic>;
  hits?: Maybe<Scalars['Int']['output']>;
  input: __SellerCatalogInput;
  inputHash: Scalars['String']['output'];
  isActive?: Maybe<Scalars['Boolean']['output']>;
  productCount: Scalars['Int']['output'];
  slug?: Maybe<Scalars['String']['output']>;
  slugLt?: Maybe<Scalars['String']['output']>;
  title?: Maybe<__Text>;
  uiFilters?: Maybe<Array<__SellerCatalogUiFilter>>;
};

export type __SellerCatalogUiFilter = {
  key: Scalars['String']['output'];
  name: __Text;
};

export type __SellerCatalogUiResponse = __MutationResponeMsg & {
  doc?: Maybe<__SellerCatalogUi>;
  responseInfo: __ResponseInfo;
};

export type __SellerCatalogUis = __PaginatedResults & {
  info?: Maybe<__PaginationInfo>;
  items?: Maybe<Array<__SellerCatalogUi>>;
};

export type __SellerCatalogVisibility = {
  _id: Scalars['ObjectId']['output'];
  adminNote?: Maybe<Scalars['String']['output']>;
  isActive: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  sellerId: Scalars['ObjectId']['output'];
};

export type __SellerCatalogVisibilityList = __PaginatedResults & {
  info?: Maybe<__PaginationInfo>;
  items?: Maybe<Array<__SellerCatalogVisibility>>;
};

export type __SellerCheckout = {
  _id: Scalars['ObjectId']['output'];
  address?: Maybe<__BuyerAddress>;
  createdAt?: Maybe<Scalars['MongoDate']['output']>;
  discountCodes?: Maybe<Array<Scalars['String']['output']>>;
  invoiceSelected?: Maybe<Scalars['Boolean']['output']>;
  paymentId?: Maybe<Scalars['ObjectId']['output']>;
  products?: Maybe<Array<__SellerCheckoutProduct>>;
  weightGramsTotal?: Maybe<__UiWeight>;
};

export type __SellerCheckoutCode = {
  _id: Scalars['ObjectId']['output'];
  caseInsensitive?: Maybe<Scalars['Boolean']['output']>;
  code: Scalars['String']['output'];
  codeLowerCase: Scalars['String']['output'];
  docId?: Maybe<Scalars['ObjectId']['output']>;
  isActive?: Maybe<Scalars['Boolean']['output']>;
  limit?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  note?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  used?: Maybe<Scalars['Int']['output']>;
};

export type __SellerCheckoutCompeted = {
  document?: Maybe<__SellerDocumentPublic>;
  text?: Maybe<__Text>;
};

export type __SellerCheckoutFull = {
  _id: Scalars['ObjectId']['output'];
  address?: Maybe<__BuyerAddress>;
  createdAt?: Maybe<Scalars['MongoDate']['output']>;
  discountCodes?: Maybe<Array<Scalars['String']['output']>>;
  invoice?: Maybe<__BuyerInvoice>;
  invoiceSelected?: Maybe<Scalars['Boolean']['output']>;
  isAllowedToPay: Scalars['Boolean']['output'];
  isAuth: Scalars['Boolean']['output'];
  isCartPriceValid: Scalars['Boolean']['output'];
  isDoneDelivery: Scalars['Boolean']['output'];
  isDoneProducts: Scalars['Boolean']['output'];
  isEmpty: Scalars['Boolean']['output'];
  isPayedWithGiftCards: Scalars['Boolean']['output'];
  paymentId?: Maybe<Scalars['ObjectId']['output']>;
  prices?: Maybe<__PaymentPrices>;
  products?: Maybe<Array<__SellerCheckoutProduct>>;
  values?: Maybe<__CheckoutDraftSeller>;
  weightGramsTotal?: Maybe<__UiWeight>;
};

export type __SellerCheckoutPagination = __PaginatedResults & {
  info?: Maybe<__PaginationInfo>;
  items?: Maybe<Array<__SellerCheckout>>;
};

export type __SellerCheckoutProduct = {
  productId: Scalars['String']['output'];
  qty: Scalars['Float']['output'];
};

export type __SellerContacts = {
  emails?: Maybe<Array<Scalars['String']['output']>>;
  links?: Maybe<Array<__SellerSocialItem>>;
  openingHours?: Maybe<__OpeningHours>;
  tels?: Maybe<Array<Scalars['String']['output']>>;
};

export type __SellerDeliveries = __PaginatedResults & {
  info?: Maybe<__PaginationInfo>;
  items?: Maybe<Array<__SellerDelivery>>;
};

export type __SellerDelivery = {
  _id: Scalars['ObjectId']['output'];
  deliveryDuraitonDays?: Maybe<Scalars['Int']['output']>;
  description?: Maybe<__Text>;
  disabledCountries?: Maybe<Array<__SellerDeliveryShippingCountry>>;
  dispatchHour?: Maybe<Scalars['Int']['output']>;
  index?: Maybe<Scalars['Int']['output']>;
  isActive?: Maybe<Scalars['Boolean']['output']>;
  locationShopId?: Maybe<Scalars['ObjectId']['output']>;
  lockerProvider?: Maybe<__EnumLockerProvider>;
  pricingFreeCountries?: Maybe<Array<__SellerDeliveryShippingCountry>>;
  pricingTable?: Maybe<__SellerDeliveryTable>;
  pricingType?: Maybe<__EnumSellerDeliveryPricing>;
  sellerId: Scalars['ObjectId']['output'];
  shippingEmailTemplate?: Maybe<__SellerDeliveryEmailTemplate>;
  title?: Maybe<__Text>;
  trackingProvider?: Maybe<__EnumDeliveryTrackingProvider>;
  type?: Maybe<__SellerDeliveryType>;
};

export type __SellerDeliveryEmailTemplate = {
  courierName: Scalars['String']['output'];
  trackingPageUrl?: Maybe<Scalars['String']['output']>;
  urlPart1?: Maybe<Scalars['String']['output']>;
  urlPart2?: Maybe<Scalars['String']['output']>;
};

export type __SellerDeliveryInput = {
  billing?: InputMaybe<__SellerDeliveryInputFedexBilling>;
  create?: InputMaybe<__InputSellerDeliveryCreate>;
  delete?: InputMaybe<__InputId>;
  order?: InputMaybe<__InputObjectIds>;
  sellerId: Scalars['ObjectId']['input'];
  tracking?: InputMaybe<__InputSellerDeliveryTracking>;
  update?: InputMaybe<__InputSellerDeliveryUpdate>;
  updatePricing?: InputMaybe<__InputSellerDeliveryUpdatePricing>;
};

export type __SellerDeliveryInputEmailTemplate = {
  courierName?: InputMaybe<Scalars['String']['input']>;
  trackingPageUrl?: InputMaybe<Scalars['String']['input']>;
  urlPart1?: InputMaybe<Scalars['String']['input']>;
  urlPart2?: InputMaybe<Scalars['String']['input']>;
};

export type __SellerDeliveryInputFedexBilling = {
  files: Array<__InputSellerFile>;
  type: __EnumDeliveryTrackingProvider;
};

export type __SellerDeliveryLockerChoices = {
  items?: Maybe<Array<__SellerDeliveryLockerChoicesItem>>;
};

export type __SellerDeliveryLockerChoicesItem = {
  iso2: Array<Scalars['String']['output']>;
  lockerProvider: __EnumLockerProvider;
  provider: Scalars['String']['output'];
};

export type __SellerDeliveryResponse = __MutationResponeMsg & {
  deleted?: Maybe<Scalars['Boolean']['output']>;
  delivery?: Maybe<__SellerDelivery>;
  responseInfo: __ResponseInfo;
};

export type __SellerDeliveryShippingCountry = {
  all?: Maybe<Scalars['Boolean']['output']>;
  iso2: Scalars['String']['output'];
  mainland?: Maybe<Scalars['Boolean']['output']>;
  postCodeZones?: Maybe<Array<Scalars['String']['output']>>;
};

export type __SellerDeliveryTable = {
  types: Array<__SellerDeliveryTablePage>;
  values: Array<__SellerDeliveryTableValue>;
  weights: Array<__SellerDeliveryTableWeight>;
  zones: Array<__SellerDeliveryTableZone>;
};

export type __SellerDeliveryTablePage = {
  deliveryDuraitonDays?: Maybe<Scalars['Int']['output']>;
  disabled?: Maybe<Scalars['Boolean']['output']>;
  title?: Maybe<__Text>;
  type: Scalars['String']['output'];
};

export type __SellerDeliveryTableValue = {
  price: Scalars['Float']['output'];
  type: Scalars['String']['output'];
  weightGrams: Scalars['Int']['output'];
  zone: Scalars['String']['output'];
};

export type __SellerDeliveryTableWeight = {
  weightGrams: Scalars['Int']['output'];
};

export type __SellerDeliveryTableZone = {
  countries: Array<__SellerDeliveryShippingCountry>;
  disabled?: Maybe<Scalars['Boolean']['output']>;
  zone: Scalars['String']['output'];
};

export const __SellerDeliveryType = {
  Location: 'Location',
  Locker: 'Locker',
  Shipping: 'Shipping'
} as const;

export type __SellerDeliveryType = typeof __SellerDeliveryType[keyof typeof __SellerDeliveryType];
export type __SellerDeliveryUiProductAggFrom = {
  freeFromPrice?: Maybe<Scalars['String']['output']>;
  fromPrice?: Maybe<Scalars['String']['output']>;
  isFree?: Maybe<Scalars['Boolean']['output']>;
};

export type __SellerDeliveryZone = {
  _id: Scalars['ObjectId']['output'];
  code: Scalars['String']['output'];
  exact?: Maybe<Array<Scalars['String']['output']>>;
  id: Scalars['String']['output'];
  isActive: Scalars['Boolean']['output'];
  iso2: Scalars['String']['output'];
  prefixes?: Maybe<Array<Scalars['String']['output']>>;
  ranges?: Maybe<Array<__SellerDeliveryZoneRange>>;
  sellerId: Scalars['ObjectId']['output'];
  title: __Text;
  zoneId: Scalars['ObjectId']['output'];
};

export type __SellerDeliveryZoneRange = {
  max: Scalars['Int']['output'];
  min: Scalars['Int']['output'];
};

export type __SellerDeliveryZones = __PaginatedResults & {
  info?: Maybe<__PaginationInfo>;
  items?: Maybe<Array<__SellerDeliveryZone>>;
};

export type __SellerDepartmentItem = {
  _id: Scalars['ObjectId']['output'];
  description?: Maybe<__Text>;
  img?: Maybe<__Image>;
  isActive: Scalars['Boolean']['output'];
  parentId?: Maybe<Scalars['ObjectId']['output']>;
  sellerId: Scalars['ObjectId']['output'];
  slug: Scalars['String']['output'];
  stats?: Maybe<Scalars['Boolean']['output']>;
  title: __Text;
};

export type __SellerDepartments = __PaginatedResults & {
  info?: Maybe<__PaginationInfo>;
  items?: Maybe<Array<__SellerDepartmentItem>>;
};

export type __SellerDiscount = {
  _id: Scalars['ObjectId']['output'];
  codeCaseInsensitive?: Maybe<Scalars['Boolean']['output']>;
  codes?: Maybe<Array<__SellerDiscountCode>>;
  codesDeleted?: Maybe<Array<__SellerCheckoutCode>>;
  createdAt: Scalars['MongoDate']['output'];
  endAt?: Maybe<Scalars['MongoDate']['output']>;
  givesDiscountOrder?: Maybe<__SellerDiscountGivesOrder>;
  givesFreeShippingAll?: Maybe<Scalars['Boolean']['output']>;
  givesFreeShippingIds?: Maybe<Array<Scalars['ObjectId']['output']>>;
  givesType: __SellerDiscountGivesType;
  isActive?: Maybe<Scalars['Boolean']['output']>;
  isCombined?: Maybe<Scalars['Boolean']['output']>;
  isDeleted?: Maybe<Scalars['Boolean']['output']>;
  name: Scalars['String']['output'];
  priceGroupIds?: Maybe<Array<Scalars['ObjectId']['output']>>;
  requirementsOrderTotal?: Maybe<Scalars['Float']['output']>;
  salePublicCode?: Maybe<Scalars['String']['output']>;
  sellerId: Scalars['ObjectId']['output'];
  startAt?: Maybe<Scalars['MongoDate']['output']>;
  title?: Maybe<__Text>;
  type: __SellerDiscountType;
  ui?: Maybe<__SellerDiscountUi>;
};

export type __SellerDiscountCode = {
  active?: Maybe<Scalars['Boolean']['output']>;
  code: Scalars['String']['output'];
  codeLowerCase: Scalars['String']['output'];
  limit?: Maybe<Scalars['Int']['output']>;
  note?: Maybe<Scalars['String']['output']>;
};

export type __SellerDiscountCodes = __PaginatedResults & {
  info?: Maybe<__PaginationInfo>;
  items?: Maybe<Array<__SellerCheckoutCode>>;
};

export type __SellerDiscountGivesOrder = {
  codePublic?: Maybe<Scalars['Boolean']['output']>;
  percentage: Scalars['Float']['output'];
  reduceCombined?: Maybe<Scalars['Boolean']['output']>;
};

export const __SellerDiscountGivesType = {
  FreeShipping: 'FreeShipping',
  OrderDiscount: 'OrderDiscount',
  ProductDiscount: 'ProductDiscount'
} as const;

export type __SellerDiscountGivesType = typeof __SellerDiscountGivesType[keyof typeof __SellerDiscountGivesType];
export type __SellerDiscountProductPricingInputMapped = {
  productId: Scalars['ObjectId']['input'];
  value: __InputSellerPricesValue;
};

export type __SellerDiscountResponse = __MutationResponeMsg & {
  discount?: Maybe<__SellerDiscount>;
  responseInfo: __ResponseInfo;
};

export const __SellerDiscountType = {
  Auto: 'Auto',
  Bundle: 'Bundle',
  Code: 'Code',
  Sale: 'Sale'
} as const;

export type __SellerDiscountType = typeof __SellerDiscountType[keyof typeof __SellerDiscountType];
export type __SellerDiscountUi = {
  hasDeliveries?: Maybe<Scalars['Boolean']['output']>;
  hasProducts?: Maybe<Scalars['Boolean']['output']>;
  isDiscoutnAuto?: Maybe<Scalars['Boolean']['output']>;
  isDiscoutnCode?: Maybe<Scalars['Boolean']['output']>;
  isDiscoutnSale?: Maybe<Scalars['Boolean']['output']>;
  status?: Maybe<__EnumSellerDiscountStatus>;
};

export type __SellerDiscounts = __PaginatedResults & {
  info?: Maybe<__PaginationInfo>;
  items?: Maybe<Array<__SellerDiscount>>;
};

export type __SellerDoc = {
  _id: Scalars['ObjectId']['output'];
  _stockLocation?: Maybe<__ProductExtraStockLocation>;
  _uiProfile?: Maybe<__SellerProfile>;
  aboutUs?: Maybe<__SellerDocumentPublic>;
  care?: Maybe<__SellerDocumentPublic>;
  certificate?: Maybe<__SellerDocumentPublic>;
  checkoutCompleted?: Maybe<__SellerCheckoutCompeted>;
  checkoutType?: Maybe<__EnumSellerCheckoutType>;
  contacts?: Maybe<__SellerContacts>;
  cookiePolicy?: Maybe<__SellerDocumentPublic>;
  emailSubs?: Maybe<Array<Scalars['String']['output']>>;
  fabrics?: Maybe<__SellerDocumentPublic>;
  footerTxt?: Maybe<__Text>;
  handle: Scalars['String']['output'];
  homepage?: Maybe<__SellerDocumentPublic>;
  invoiceDetails?: Maybe<__SellerInvoiceDetails>;
  logo?: Maybe<__Image>;
  logoFull?: Maybe<__Image>;
  message?: Maybe<__SellerMessage>;
  name?: Maybe<Scalars['String']['output']>;
  navigation?: Maybe<__SellerNavigation>;
  off?: Maybe<__SellerDocOff>;
  privacyPolicy?: Maybe<__SellerDocumentPublic>;
  productDetailsId?: Maybe<Scalars['ObjectId']['output']>;
  productFactoryId?: Maybe<Scalars['ObjectId']['output']>;
  productPrivateVisibility?: Maybe<Scalars['Boolean']['output']>;
  productReturnId?: Maybe<Scalars['ObjectId']['output']>;
  productStockLocationId?: Maybe<Scalars['ObjectId']['output']>;
  productWarrantyId?: Maybe<Scalars['ObjectId']['output']>;
  returnAddressId?: Maybe<Scalars['ObjectId']['output']>;
  returnDocs?: Maybe<__SellerReturnFiles>;
  returns?: Maybe<__SellerDocumentPublic>;
  shipping?: Maybe<__SellerDocumentPublic>;
  shippingDelay?: Maybe<__SellerShippingDelay>;
  taxStrategy?: Maybe<__EnumSellerTaxStrategy>;
  termsAndConditions?: Maybe<__SellerDocumentPublic>;
  warranty?: Maybe<__SellerDocumentPublic>;
};

export type __SellerDocOff = {
  isOff?: Maybe<Scalars['Boolean']['output']>;
  msg?: Maybe<__Text>;
  offlineAt?: Maybe<Scalars['MongoDate']['output']>;
};

export type __SellerDocument = {
  _id: Scalars['ObjectId']['output'];
  createdAt?: Maybe<Scalars['MongoDate']['output']>;
  draftUpdatedAt?: Maybe<Scalars['MongoDate']['output']>;
  main?: Maybe<Array<__DocumentSection>>;
  mainDraft?: Maybe<Array<__DocumentSection>>;
  mobile?: Maybe<Array<__DocumentSection>>;
  mobileDraft?: Maybe<Array<__DocumentSection>>;
  name?: Maybe<Scalars['String']['output']>;
  sellerId: Scalars['ObjectId']['output'];
  tags?: Maybe<Array<Scalars['String']['output']>>;
  updatedAt?: Maybe<Scalars['MongoDate']['output']>;
};

export const __SellerDocumentBlocksType = {
  Grid: 'Grid',
  Scroll: 'Scroll'
} as const;

export type __SellerDocumentBlocksType = typeof __SellerDocumentBlocksType[keyof typeof __SellerDocumentBlocksType];
export type __SellerDocumentBox = {
  _box?: Maybe<Array<__DocumentSection>>;
  _id: Scalars['ObjectId']['output'];
  createdAt?: Maybe<Scalars['MongoDate']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  sellerId: Scalars['ObjectId']['output'];
  tags?: Maybe<Array<Scalars['String']['output']>>;
  updatedAt?: Maybe<Scalars['MongoDate']['output']>;
};

export type __SellerDocumentInput = {
  documentCreate?: InputMaybe<__InputSellerDocumentCreate>;
  documentDelete?: InputMaybe<__InputDocumentIdMust>;
  documentSet?: InputMaybe<__SellerDocumentInputSet>;
  draftDocumentDiscard?: InputMaybe<__InputDocumentIdMust>;
  draftDocumentSave?: InputMaybe<__InputDocumentIdMust>;
  draftDocumentStart?: InputMaybe<__InputDocumentIdMust>;
  draftSectionAdd?: InputMaybe<__SellerDocumentInputCreate>;
  draftSectionDelete?: InputMaybe<__InputSellerDocumentComponentDelete>;
  draftSectionHide?: InputMaybe<__InputSellerDocumentComponentHide>;
  draftSectionUpdate?: InputMaybe<__SellerDocumentInputUpdate>;
  sellerId: Scalars['ObjectId']['input'];
};

export type __SellerDocumentInputCreate = {
  documentId: Scalars['ObjectId']['input'];
  mobile: Scalars['Boolean']['input'];
  value: __InputDocumentSection;
};

export type __SellerDocumentInputSet = {
  documentId: Scalars['ObjectId']['input'];
  name: Scalars['String']['input'];
  tags: Array<Scalars['String']['input']>;
};

export type __SellerDocumentInputUpdate = {
  documentId: Scalars['ObjectId']['input'];
  mobile: Scalars['Boolean']['input'];
  reorder?: InputMaybe<Array<Scalars['ObjectId']['input']>>;
  value?: InputMaybe<__InputDocumentSection>;
};

export type __SellerDocumentPublic = {
  _id: Scalars['ObjectId']['output'];
};

export type __SellerDocumentResponse = __MutationResponeMsg & {
  deleted?: Maybe<Scalars['Boolean']['output']>;
  document?: Maybe<__SellerDocument>;
  newSectionId?: Maybe<Scalars['ObjectId']['output']>;
  responseInfo: __ResponseInfo;
  sectionDeleted?: Maybe<Scalars['Boolean']['output']>;
};

export type __SellerDocumentSf = {
  components?: Maybe<Array<__DocumentSection>>;
  listings?: Maybe<Array<__ProductListingBox>>;
};

export type __SellerDocumentSfAds = {
  id: Scalars['String']['output'];
  items: Array<__SellerDocumentSfAdsItem>;
};

export type __SellerDocumentSfAdsItem = {
  items: Array<__ProductListingBox>;
  title: Scalars['String']['output'];
};

export type __SellerDocumentTemplate = {
  _id: Scalars['ObjectId']['output'];
  name: Scalars['String']['output'];
  section: __DocumentSection;
};

export type __SellerDocumentTemplates = __PaginatedResults & {
  info?: Maybe<__PaginationInfo>;
  items?: Maybe<Array<__SellerDocumentTemplate>>;
};

export type __SellerDocumentView = {
  id: Scalars['String']['output'];
  sections?: Maybe<Array<__DocumentSection>>;
};

export type __SellerDocuments = __PaginatedResults & {
  info?: Maybe<__PaginationInfo>;
  items?: Maybe<Array<__SellerDocumentBox>>;
};

export type __SellerFaq = {
  _id: Scalars['ObjectId']['output'];
  index?: Maybe<Scalars['Int']['output']>;
  isActive: Scalars['Boolean']['output'];
  questionActiveCount?: Maybe<Scalars['Int']['output']>;
  questionCount?: Maybe<Scalars['Int']['output']>;
  sellerId: Scalars['ObjectId']['output'];
  slug?: Maybe<Scalars['String']['output']>;
  title: __Text;
};

export type __SellerFaqFull = {
  id: Scalars['ObjectId']['output'];
  questions: Array<__SellerFaqQa>;
  section: __SellerFaq;
};

export type __SellerFaqList = __PaginatedResults & {
  info?: Maybe<__PaginationInfo>;
  items?: Maybe<Array<__SellerFaq>>;
};

export type __SellerFaqQa = {
  _id: Scalars['ObjectId']['output'];
  document?: Maybe<__SellerDocumentPublic>;
  index?: Maybe<Scalars['Int']['output']>;
  isActive: Scalars['Boolean']['output'];
  slug: Scalars['String']['output'];
  text?: Maybe<__Text>;
  title: __Text;
};

export type __SellerFaqResponse = __MutationResponeMsg & {
  deleted?: Maybe<Scalars['Boolean']['output']>;
  responseInfo: __ResponseInfo;
  section?: Maybe<__SellerFaqFull>;
};

export type __SellerFile = {
  _id: Scalars['ObjectId']['output'];
  filename?: Maybe<Scalars['String']['output']>;
  key?: Maybe<Scalars['String']['output']>;
  original?: Maybe<Scalars['String']['output']>;
  private?: Maybe<Scalars['Boolean']['output']>;
  sellerId?: Maybe<Scalars['ObjectId']['output']>;
  size?: Maybe<Scalars['Int']['output']>;
  tags?: Maybe<Array<Scalars['String']['output']>>;
  type?: Maybe<Scalars['String']['output']>;
};

export type __SellerFiles = __PaginatedResults & {
  info?: Maybe<__PaginationInfo>;
  items?: Maybe<Array<__SellerFile>>;
};

export type __SellerGiftcard = {
  _id: Scalars['ObjectId']['output'];
  amount: __Price2Total;
  amountAvailable: __Price2Total;
  buyerFullname: Scalars['String']['output'];
  createdAt: Scalars['MongoDate']['output'];
  emailWasSendAt?: Maybe<Scalars['MongoDate']['output']>;
  expiry: Scalars['MongoDate']['output'];
  history: Array<__GiftcardPublicHistory>;
  isActive: Scalars['Boolean']['output'];
  payment: __PaymentSimple;
  receiverEmail: Scalars['String']['output'];
  receiverFullname: Scalars['String']['output'];
};

export type __SellerGiftcards = __PaginatedResults & {
  info?: Maybe<__PaginationInfo>;
  items?: Maybe<Array<__SellerGiftcard>>;
};

export type __SellerGuideArea = {
  description?: Maybe<__Text>;
  key: Scalars['String']['output'];
  name?: Maybe<Scalars['String']['output']>;
  title?: Maybe<__Text>;
};

export type __SellerGuideSize = {
  key: Scalars['String']['output'];
  title?: Maybe<__Text>;
};

export type __SellerGuideUnit = {
  key: Scalars['String']['output'];
  unit: Scalars['String']['output'];
};

export type __SellerGuideValue = {
  areaKey: Scalars['String']['output'];
  sizeKey: Scalars['String']['output'];
  unitKey: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

export type __SellerId = {
  sellerId?: Maybe<Scalars['ObjectId']['output']>;
};

export type __SellerImages = __PaginatedResults & {
  info?: Maybe<__PaginationInfo>;
  items?: Maybe<Array<__Image>>;
};

export type __SellerInfoAddress = {
  apartment?: Maybe<__Text>;
  city: __Text;
  country: __BuyerAddressCountry;
  deliveryInstruction?: Maybe<__Text>;
  fullname: __Text;
  postCode: __Text;
  state?: Maybe<__Text>;
  street: __Text;
  tel?: Maybe<__Text>;
};

export type __SellerInvoiceDetails = {
  SWIFT?: Maybe<Scalars['String']['output']>;
  comanyAddress?: Maybe<__Text>;
  companyCode?: Maybe<Scalars['String']['output']>;
  companyName?: Maybe<__Text>;
  companyVAT?: Maybe<Scalars['String']['output']>;
  invoiceBank?: Maybe<__Text>;
  invoiceBankAccount?: Maybe<Scalars['String']['output']>;
  invoiceBankCode?: Maybe<Scalars['String']['output']>;
};

export type __SellerLink = {
  alt?: Maybe<Scalars['String']['output']>;
  sellerId: Scalars['String']['output'];
  slug: Scalars['String']['output'];
  type: __SellerLinkType;
};

export type __SellerLinkOutside = {
  _id: Scalars['ObjectId']['output'];
  text: __Text;
  url: Scalars['String']['output'];
};

export type __SellerLinkPreview = {
  id: Scalars['ObjectId']['output'];
  img?: Maybe<__Image>;
  message?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
};

export const __SellerLinkType = {
  Article: 'Article',
  CatalogUi: 'CatalogUi',
  Faq: 'Faq',
  GlobalClient: 'GlobalClient',
  GlobalDepartment: 'GlobalDepartment',
  Outside: 'Outside',
  Profile: 'Profile',
  SellerClient: 'SellerClient',
  SellerListing: 'SellerListing',
  SizeGuide: 'SizeGuide'
} as const;

export type __SellerLinkType = typeof __SellerLinkType[keyof typeof __SellerLinkType];
export type __SellerLinksOutside = {
  info?: Maybe<__PaginationInfo>;
  items?: Maybe<Array<__SellerLinkOutside>>;
};

export type __SellerListEntry = {
  letter: Scalars['String']['output'];
  seller: __SellerDoc;
};

export type __SellerLockerItems = __PaginatedResults & {
  info?: Maybe<__PaginationInfo>;
  items: Array<__LockersItem>;
};

export type __SellerMessage = {
  id: Scalars['String']['output'];
  items?: Maybe<Array<__SellerTextLink>>;
};

export type __SellerMessageInput = {
  items?: InputMaybe<Array<__InputSellerTextLink>>;
};

export type __SellerNavigation = {
  id: Scalars['String']['output'];
  pages?: Maybe<Array<__SellerNavigationPage>>;
};

export type __SellerNavigationCol = {
  image?: Maybe<__Image>;
  imageRatio?: Maybe<__ImageTaggedRatio>;
  off?: Maybe<Scalars['Boolean']['output']>;
  rows?: Maybe<Array<__SellerNavigationRow>>;
  title?: Maybe<__SellerTextLink>;
};

export type __SellerNavigationInput = {
  pages: Array<__SellerNavigationInputPage>;
};

export type __SellerNavigationInputCol = {
  image?: InputMaybe<__ImageInput>;
  imageRatio?: InputMaybe<__ImageTaggedRatio>;
  off?: InputMaybe<Scalars['Boolean']['input']>;
  rows?: InputMaybe<Array<__SellerNavigationInputRow>>;
  title?: InputMaybe<__InputSellerTextLink>;
};

export type __SellerNavigationInputPage = {
  cols: Array<__SellerNavigationInputCol>;
  off?: InputMaybe<Scalars['Boolean']['input']>;
  title: __InputSellerTextLink;
};

export type __SellerNavigationInputRow = {
  image?: InputMaybe<__ImageInput>;
  imageRatio?: InputMaybe<__ImageTaggedRatio>;
  off?: InputMaybe<Scalars['Boolean']['input']>;
  title: __InputSellerTextLink;
};

export type __SellerNavigationPage = {
  cols?: Maybe<Array<__SellerNavigationCol>>;
  off?: Maybe<Scalars['Boolean']['output']>;
  title?: Maybe<__SellerTextLink>;
};

export type __SellerNavigationRow = {
  image?: Maybe<__Image>;
  imageRatio?: Maybe<__ImageTaggedRatio>;
  off?: Maybe<Scalars['Boolean']['output']>;
  title: __SellerTextLink;
};

export type __SellerOrderAdmin = {
  _id: Scalars['ObjectId']['output'];
  _stats?: Maybe<__SellerOrderDocStats>;
  address?: Maybe<__BuyerAddress>;
  addressOld?: Maybe<__BuyerAddress>;
  adminNote?: Maybe<Scalars['String']['output']>;
  billing?: Maybe<__BuyerAddress>;
  billingOld?: Maybe<__BuyerAddress>;
  cancelReasonAdmin?: Maybe<Scalars['String']['output']>;
  cancelReasonBuyer?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['MongoDate']['output']>;
  delivery?: Maybe<__SellerOrderDelivery>;
  discounts?: Maybe<Array<__OrderDocDiscount>>;
  documentsSent?: Maybe<Array<__OrderDocumentSent>>;
  giftDoc?: Maybe<__OrderDraftDocGift>;
  invoice?: Maybe<__BuyerInvoice>;
  invoiceOld?: Maybe<__BuyerInvoice>;
  invoicePdf?: Maybe<Array<__SellerFile>>;
  invoicedDefaultPdf: Scalars['Boolean']['output'];
  isAllowSetTransferReceived?: Maybe<Scalars['Boolean']['output']>;
  isAllowToReturn?: Maybe<Scalars['Boolean']['output']>;
  isFulfillmentAllowed?: Maybe<Scalars['Boolean']['output']>;
  lockerInfo?: Maybe<__OrderLockerInfo>;
  paylink?: Maybe<Scalars['String']['output']>;
  paylinkSent?: Maybe<Scalars['Boolean']['output']>;
  paymentId: Scalars['ObjectId']['output'];
  paymentType?: Maybe<__PaymentType>;
  pdfLang?: Maybe<Scalars['String']['output']>;
  prettyId: Scalars['String']['output'];
  productCount?: Maybe<Scalars['Int']['output']>;
  sellerId: Scalars['ObjectId']['output'];
  shipments?: Maybe<Array<__SellerShipment>>;
  status?: Maybe<__SellerOrderUiStatus>;
  statusDelivery: __CheckoutDeliveryStatus;
  statusOrder?: Maybe<__SellerOrderStatus>;
  statusPayment: __CheckoutPaymentStatus;
  statusUi: __SellerOrderStatusUi;
  transferDate?: Maybe<Scalars['MongoDate']['output']>;
  weightGramsTotal?: Maybe<__UiWeight>;
};

export type __SellerOrderDelivery = {
  deliveryId: Scalars['ObjectId']['output'];
  description?: Maybe<__Text>;
  locationShopId?: Maybe<Scalars['ObjectId']['output']>;
  option?: Maybe<__CheckoutDraftDeliveryItem>;
  title?: Maybe<__Text>;
  type: __SellerDeliveryType;
};

export type __SellerOrderDoc = {
  _admin?: Maybe<__SellerOrderAdmin>;
  _attributionLogs?: Maybe<Array<__LoggingDoc>>;
  _id: Scalars['ObjectId']['output'];
  _listingsAll?: Maybe<Array<__SellerOrderProductsListing>>;
  _paymentInvoice?: Maybe<__PaymentInvoiceDoc>;
  _productsAll?: Maybe<Array<__SellerOrderProductsVariant>>;
  _sf?: Maybe<__SellerOrderSf>;
  address?: Maybe<__BuyerAddress>;
  adminNote: Scalars['String']['output'];
  cancelReason?: Maybe<Scalars['String']['output']>;
  checkoutDurationS?: Maybe<Scalars['Float']['output']>;
  createdAt: Scalars['MongoDate']['output'];
  delivery?: Maybe<__SellerOrderDelivery>;
  discounts?: Maybe<Array<__OrderDocDiscount>>;
  email?: Maybe<Scalars['String']['output']>;
  historyDelivery?: Maybe<Array<__SellerOrderHistoryDeliveryItem>>;
  historyOrder?: Maybe<Array<__CheckoutOrderHistoryItem>>;
  historyPayment?: Maybe<Array<__CheckoutPaymentHistoryItem>>;
  idString: Scalars['String']['output'];
  invoice?: Maybe<__BuyerInvoice>;
  lang?: Maybe<Scalars['String']['output']>;
  lockerInfo?: Maybe<__OrderLockerInfo>;
  paymentId: Scalars['ObjectId']['output'];
  prettyId: Scalars['String']['output'];
  prices: __PaymentPrices;
  productCount: Scalars['Int']['output'];
  products: Array<__SellerOrderDocProduct>;
  productsManual?: Maybe<Array<__SellerOrderDocProduct>>;
  productsReturned: Array<__SellerOrderProductsReturned>;
  sellerId: Scalars['ObjectId']['output'];
  sessionId?: Maybe<Scalars['String']['output']>;
  statusActiveOrSuccesfull?: Maybe<Scalars['Boolean']['output']>;
  statusDelivery: __CheckoutDeliveryStatus;
  statusOrder?: Maybe<__SellerOrderStatus>;
  statusPayment: __CheckoutPaymentStatus;
  stockError?: Maybe<Scalars['Boolean']['output']>;
  uiBox?: Maybe<__OrderUiBox>;
  updatedAt?: Maybe<Scalars['MongoDate']['output']>;
  usedDiscounts?: Maybe<Array<Maybe<Scalars['ObjectId']['output']>>>;
  userId?: Maybe<Scalars['ObjectId']['output']>;
  userOrderIndex?: Maybe<Scalars['Int']['output']>;
  weightGramsTotal: Scalars['Int']['output'];
};


export type __SellerOrderDoc_ListingsAllArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  returns?: InputMaybe<Scalars['Boolean']['input']>;
};

export type __SellerOrderDocEditsAddress = {
  apartment?: InputMaybe<Scalars['String']['input']>;
  city: Scalars['String']['input'];
  country?: InputMaybe<__InputBuyerAddressCountry>;
  lastname: Scalars['String']['input'];
  name: Scalars['String']['input'];
  postCode: Scalars['String']['input'];
  state?: InputMaybe<Scalars['String']['input']>;
  street: Scalars['String']['input'];
  tel: Scalars['String']['input'];
};

export type __SellerOrderDocEditsInputDelete = {
  delete: Scalars['Boolean']['input'];
};

export type __SellerOrderDocEditsInputDeliveryId = {
  deliveryId: Scalars['ObjectId']['input'];
};

export type __SellerOrderDocEditsInputLocker = {
  lockerId: Scalars['String']['input'];
};

export type __SellerOrderDocEditsInvoice = {
  company?: InputMaybe<__InputBuyerInvoiceCompany>;
  personal?: InputMaybe<__InputBuyerInvoicePersonal>;
};

export type __SellerOrderDocPdf = {
  id: Scalars['String']['output'];
  pdfBase64?: Maybe<Array<__SellerOrderDocPdfFile>>;
};

export type __SellerOrderDocPdfFile = {
  defaultPdfLang?: Maybe<Scalars['String']['output']>;
  fileId?: Maybe<Scalars['ObjectId']['output']>;
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  pdfBase64?: Maybe<Scalars['String']['output']>;
  url?: Maybe<Scalars['String']['output']>;
};

export type __SellerOrderDocProduct = {
  discounts?: Maybe<Array<__SellerOrderDocProductDiscount>>;
  lineItems?: Maybe<Array<__ProductPriceLineItem>>;
  priceTotalFinal: __Price2Total;
  priceTotalTaxes?: Maybe<__Price2Total>;
  priceTotalTaxfull?: Maybe<__Price2Total>;
  priceTotalTaxless?: Maybe<__Price2Total>;
  priceUnitFinal: __Price2Total;
  priceUnitTaxes: __Price2Total;
  priceUnitTaxfull?: Maybe<__Price2Total>;
  priceUnitTaxless?: Maybe<__Price2Total>;
  product: __ProductCache;
  qty: Scalars['Float']['output'];
  returnDoc?: Maybe<__ProductExtraReturn>;
  savingsDiscountPercentage?: Maybe<Scalars['Float']['output']>;
  savingsTotalFinal: Scalars['Float']['output'];
  savingsTotalTaxfull: Scalars['Float']['output'];
  savingsTotalTaxless: Scalars['Float']['output'];
  savingsUnitFinal: Scalars['Float']['output'];
  savingsUnitTaxfull?: Maybe<Scalars['Float']['output']>;
  savingsUnitTaxless: Scalars['Float']['output'];
};

export type __SellerOrderDocProductDiscount = {
  code?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  msg?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  priceFull?: Maybe<Scalars['Float']['output']>;
  priceUnit?: Maybe<Scalars['Float']['output']>;
};

export type __SellerOrderDocStats = {
  buyerType?: Maybe<__EnumBuyerType>;
  entry?: Maybe<Scalars['String']['output']>;
};

export type __SellerOrderHistoryDeliveryItem = {
  at: Scalars['MongoDate']['output'];
  status: __CheckoutDeliveryStatus;
};

export type __SellerOrderInputCancel = {
  isActive: Scalars['Boolean']['input'];
  messageAdmin: Scalars['String']['input'];
  messageBuyer?: InputMaybe<Scalars['String']['input']>;
};

export type __SellerOrderInputNote = {
  note: Scalars['String']['input'];
};

export type __SellerOrderPagination = __PaginatedResults & {
  info?: Maybe<__PaginationInfo>;
  items?: Maybe<Array<__SellerOrderDoc>>;
};

export type __SellerOrderProductsListing = {
  isAllowToReturn: Scalars['Boolean']['output'];
  isManual: Scalars['Boolean']['output'];
  listing?: Maybe<__ProductListingBox>;
  qtyAllowedToReturn: Scalars['Float']['output'];
  ref: __SellerOrderDocProduct;
  returnUntil?: Maybe<Scalars['MongoDate']['output']>;
};

export type __SellerOrderProductsReturned = {
  productId: Scalars['ObjectId']['output'];
  qtyReturned: Scalars['Float']['output'];
  returnId: Scalars['ObjectId']['output'];
};

export type __SellerOrderProductsVariant = {
  isManual: Scalars['Boolean']['output'];
  ref: __SellerOrderDocProduct;
  returnedFully?: Maybe<Scalars['Boolean']['output']>;
  returnedQty?: Maybe<Scalars['Float']['output']>;
  shippedFully?: Maybe<Scalars['Boolean']['output']>;
  shippedQty?: Maybe<Scalars['Float']['output']>;
  variant?: Maybe<__ProductVariant>;
};

export type __SellerOrderResponse = __MutationResponeMsg & {
  doc?: Maybe<__SellerOrderDoc>;
  responseInfo: __ResponseInfo;
  shipping?: Maybe<Array<__SellerShipment>>;
};

export type __SellerOrderSf = {
  delivery?: Maybe<__SellerOrderDelivery>;
  deliveryCity?: Maybe<__Text>;
  deliveryCountry?: Maybe<__BuyerAddressCountry>;
  hasInvoicePdf: Scalars['Boolean']['output'];
  lockerInfo?: Maybe<__OrderLockerInfo>;
  productsManual?: Maybe<Array<__SellerOrderDocProduct>>;
  repeat?: Maybe<Scalars['Boolean']['output']>;
  shipments?: Maybe<Array<__SellerShipment>>;
  shop?: Maybe<__ProductExtraShop>;
  status?: Maybe<__SellerOrderUiStatus>;
};

export const __SellerOrderStatus = {
  Accepted: 'Accepted',
  Created: 'Created',
  Denied: 'Denied',
  Packing: 'Packing',
  Returned: 'Returned',
  ReturnedPartially: 'ReturnedPartially'
} as const;

export type __SellerOrderStatus = typeof __SellerOrderStatus[keyof typeof __SellerOrderStatus];
export const __SellerOrderStatusUi = {
  Canceled: 'Canceled',
  CollectionReady: 'CollectionReady',
  Created: 'Created',
  Delivered: 'Delivered',
  OpenAccount: 'OpenAccount',
  Packing: 'Packing',
  PaymentAwaiting: 'PaymentAwaiting',
  PaymentReceived: 'PaymentReceived',
  Returned: 'Returned',
  ReturnedPartially: 'ReturnedPartially',
  Shipped: 'Shipped',
  ShippedPartially: 'ShippedPartially'
} as const;

export type __SellerOrderStatusUi = typeof __SellerOrderStatusUi[keyof typeof __SellerOrderStatusUi];
export type __SellerOrderTrackingNumber = {
  number?: Maybe<Scalars['String']['output']>;
};

export type __SellerOrderTrackingOneProduct = {
  productId: Scalars['ObjectId']['output'];
  qty: Scalars['Float']['output'];
};

export type __SellerOrderTrackingUpdate = {
  courierName?: Maybe<Scalars['String']['output']>;
  number?: Maybe<Scalars['String']['output']>;
  trackingPageUrl?: Maybe<Scalars['String']['output']>;
  url?: Maybe<Scalars['String']['output']>;
};

export type __SellerOrderUiStatus = {
  history: Array<__SellerOrderUiStatusHisto>;
  status: __SellerOrderUiStatusValue;
};

export type __SellerOrderUiStatusHisto = {
  at: Scalars['MongoDate']['output'];
  status: __SellerOrderUiStatusValue;
};

export type __SellerOrderUiStatusValue = {
  delivery?: Maybe<__CheckoutDeliveryStatus>;
  order?: Maybe<__SellerOrderStatus>;
  payment?: Maybe<__CheckoutPaymentStatus>;
};

export type __SellerPage = {
  _id: Scalars['ObjectId']['output'];
  archived: Scalars['Boolean']['output'];
  archivedAt?: Maybe<Scalars['MongoDate']['output']>;
  createdAt?: Maybe<Scalars['MongoDate']['output']>;
  draftAt?: Maybe<Scalars['MongoDate']['output']>;
  draftUpdatedAt?: Maybe<Scalars['MongoDate']['output']>;
  hiddenSections: Array<Scalars['ObjectId']['output']>;
  name: Scalars['String']['output'];
  notes: Scalars['String']['output'];
  pinned: Scalars['Boolean']['output'];
  preview?: Maybe<__SellerPageView>;
  published: __SellerPagePublished;
  resolvedSections: Array<__SellerPageSection>;
  revision: Scalars['String']['output'];
  sections: Array<Scalars['ObjectId']['output']>;
  sellerId: Scalars['ObjectId']['output'];
  tags?: Maybe<Array<Scalars['String']['output']>>;
  updatedAt?: Maybe<Scalars['MongoDate']['output']>;
};

export type __SellerPageBox = {
  _id: Scalars['ObjectId']['output'];
  archived: Scalars['Boolean']['output'];
  archivedAt?: Maybe<Scalars['MongoDate']['output']>;
  createdAt?: Maybe<Scalars['MongoDate']['output']>;
  draftUpdatedAt?: Maybe<Scalars['MongoDate']['output']>;
  name: Scalars['String']['output'];
  pinned: Scalars['Boolean']['output'];
  sections: Array<Scalars['ObjectId']['output']>;
  sellerId: Scalars['ObjectId']['output'];
  tags?: Maybe<Array<Scalars['String']['output']>>;
  updatedAt?: Maybe<Scalars['MongoDate']['output']>;
};

export type __SellerPagePublic = {
  _id: Scalars['ObjectId']['output'];
};

export type __SellerPagePublished = {
  hiddenSections: Array<Scalars['ObjectId']['output']>;
  name: Scalars['String']['output'];
  notes: Scalars['String']['output'];
  sections: Array<__SellerPageSectionBox>;
  tags?: Maybe<Array<Scalars['String']['output']>>;
};

export type __SellerPageResponse = __MutationResponeMsg & {
  conflict?: Maybe<Scalars['Boolean']['output']>;
  deleted?: Maybe<Scalars['Boolean']['output']>;
  newSectionId?: Maybe<Scalars['ObjectId']['output']>;
  page?: Maybe<__SellerPage>;
  responseInfo: __ResponseInfo;
  sectionDeleted?: Maybe<Scalars['Boolean']['output']>;
};

export type __SellerPageSection = {
  _id: Scalars['ObjectId']['output'];
  createdAt?: Maybe<Scalars['MongoDate']['output']>;
  grid?: Maybe<__PageGridEditor>;
  hero?: Maybe<__PageHeroEditor>;
  image?: Maybe<__PageImageSection>;
  name: Scalars['String']['output'];
  productGrid?: Maybe<__PageProductGridSection>;
  richText?: Maybe<__PageRichTextEditor>;
  sellerId: Scalars['ObjectId']['output'];
  settings?: Maybe<__PageSectionSettings>;
  slider?: Maybe<__PageSliderSection>;
  tags?: Maybe<Array<Scalars['String']['output']>>;
  textImage?: Maybe<__PageTextImageEditor>;
  type: __PageSectionType;
  updatedAt?: Maybe<Scalars['MongoDate']['output']>;
  usedInPages?: Maybe<__SellerPages>;
};


export type __SellerPageSectionUsedInPagesArgs = {
  input: __InputPagination;
};

export type __SellerPageSectionBox = {
  _id: Scalars['ObjectId']['output'];
  createdAt?: Maybe<Scalars['MongoDate']['output']>;
  name: Scalars['String']['output'];
  preview?: Maybe<__PageSection>;
  sellerId: Scalars['ObjectId']['output'];
  tags?: Maybe<Array<Scalars['String']['output']>>;
  type: __PageSectionType;
  updatedAt?: Maybe<Scalars['MongoDate']['output']>;
  usageCount?: Maybe<Scalars['Int']['output']>;
};

export type __SellerPageSectionResponse = {
  deleted?: Maybe<Scalars['Boolean']['output']>;
  newSectionId?: Maybe<Scalars['ObjectId']['output']>;
  responseInfo: __ResponseInfo;
  section?: Maybe<__SellerPageSection>;
  sectionDeleted?: Maybe<Scalars['Boolean']['output']>;
};

export type __SellerPageSections = __PaginatedResults & {
  info?: Maybe<__PaginationInfo>;
  items?: Maybe<Array<__SellerPageSectionBox>>;
};

export type __SellerPageView = {
  id: Scalars['String']['output'];
  sections: Array<__PageSection>;
};

export type __SellerPages = __PaginatedResults & {
  info?: Maybe<__PaginationInfo>;
  items?: Maybe<Array<__SellerPageBox>>;
};

export type __SellerPayout = {
  _id: Scalars['ObjectId']['output'];
  amount: __Price2;
  bank?: Maybe<__SellerPayoutBank>;
  bankEdit?: Maybe<__SellerPayoutBank>;
  createdAt: Scalars['MongoDate']['output'];
  history?: Maybe<Array<__SellerPayoutHistoryItem>>;
  orderId?: Maybe<Scalars['ObjectId']['output']>;
  paymentId?: Maybe<Scalars['ObjectId']['output']>;
  returnId?: Maybe<Scalars['ObjectId']['output']>;
  sellerId: Scalars['ObjectId']['output'];
  status: __EnumPayoutStatus;
  userId?: Maybe<Scalars['ObjectId']['output']>;
};

export type __SellerPayoutBank = {
  bankAcconutHolderName: Scalars['String']['output'];
  bankAccountNumber: Scalars['String']['output'];
  bankSwift: Scalars['String']['output'];
  bankTitle: Scalars['String']['output'];
};

export type __SellerPayoutHistoryItem = {
  at: Scalars['MongoDate']['output'];
  status: __EnumPayoutStatus;
};

export type __SellerPayouts = __PaginatedResults & {
  info?: Maybe<__PaginationInfo>;
  items?: Maybe<Array<__SellerPayout>>;
};

export const __SellerPostViewType = {
  Comment: 'Comment',
  Question: 'Question',
  Review: 'Review'
} as const;

export type __SellerPostViewType = typeof __SellerPostViewType[keyof typeof __SellerPostViewType];
export type __SellerPriceGroup = {
  _id: Scalars['ObjectId']['output'];
  createdAt?: Maybe<Scalars['MongoDate']['output']>;
  endAt?: Maybe<Scalars['MongoDate']['output']>;
  isActive?: Maybe<Scalars['Boolean']['output']>;
  limit?: Maybe<Scalars['Int']['output']>;
  name: Scalars['String']['output'];
  priceVariantCount?: Maybe<Scalars['Int']['output']>;
  sellerId: Scalars['ObjectId']['output'];
  updatedAt?: Maybe<Scalars['MongoDate']['output']>;
};

export type __SellerPriceGroupInputCreate = {
  name: Scalars['String']['input'];
};

export type __SellerPriceGroupInputUpdate = {
  name: Scalars['String']['input'];
  priceGroupId: Scalars['ObjectId']['input'];
};

export type __SellerPriceGroups = __PaginatedResults & {
  info?: Maybe<__PaginationInfo>;
  items?: Maybe<Array<__SellerPriceGroup>>;
};

export type __SellerProductField = {
  _id: Scalars['ObjectId']['output'];
  expandInCatalog?: Maybe<Scalars['Boolean']['output']>;
  forceDisplayUi?: Maybe<Scalars['Boolean']['output']>;
  guideBodyId?: Maybe<Scalars['String']['output']>;
  guideProductId?: Maybe<Scalars['String']['output']>;
  isColor?: Maybe<Scalars['Boolean']['output']>;
  sellerId?: Maybe<Scalars['ObjectId']['output']>;
  showInEmail?: Maybe<Scalars['Boolean']['output']>;
  slug?: Maybe<Scalars['String']['output']>;
  title: __Text;
  ui?: Maybe<__SellerProductFieldUi>;
};

export type __SellerProductFieldResponse = __MutationResponeMsg & {
  deleted?: Maybe<Scalars['Boolean']['output']>;
  doc?: Maybe<__SellerProductField>;
  responseInfo: __ResponseInfo;
};

export type __SellerProductFieldUi = {
  isNumber?: Maybe<Scalars['Boolean']['output']>;
  isText?: Maybe<Scalars['Boolean']['output']>;
};

export type __SellerProductFieldValuesUis = __PaginatedResults & {
  info?: Maybe<__PaginationInfo>;
  items: Array<__SellerProductFieldValuesUisItem>;
};

export type __SellerProductFieldValuesUisItem = {
  hsla?: Maybe<__DocumentColorHsla>;
  image?: Maybe<__Image>;
  order?: Maybe<Scalars['Int']['output']>;
  val4: __ProductPropertyVal4;
};

export type __SellerProductFields = __PaginatedResults & {
  info?: Maybe<__PaginationInfo>;
  items?: Maybe<Array<__SellerProductField>>;
};

export type __SellerProductInfo = {
  _id: Scalars['ObjectId']['output'];
  address?: Maybe<__SellerInfoAddress>;
  care?: Maybe<__ProductExtraCare>;
  careIcon?: Maybe<__ProductExtraCareIcon>;
  certificate?: Maybe<__ProductCertificate>;
  details?: Maybe<__ProductDetails>;
  fabric?: Maybe<__ProductExtraFabric>;
  factory?: Maybe<__ProductExtraFactory>;
  name: Scalars['String']['output'];
  return?: Maybe<__ProductExtraReturn>;
  sellerId: Scalars['ObjectId']['output'];
  shop?: Maybe<__ProductExtraShop>;
  stockLocation?: Maybe<__ProductExtraStockLocation>;
  type: __SellerProductInfoType;
  warranty?: Maybe<__ProductWarranty>;
};

export type __SellerProductInfoList = __PaginatedResults & {
  info?: Maybe<__PaginationInfo>;
  items?: Maybe<Array<__SellerProductInfo>>;
};

export type __SellerProductInfoResponse = __MutationResponeMsg & {
  deleted?: Maybe<Scalars['Boolean']['output']>;
  doc?: Maybe<__SellerProductInfo>;
  responseInfo: __ResponseInfo;
};

export const __SellerProductInfoType = {
  Address: 'Address',
  Care: 'Care',
  CareIcon: 'CareIcon',
  Certificate: 'Certificate',
  Details: 'Details',
  Fabric: 'Fabric',
  Factory: 'Factory',
  Return: 'Return',
  Shop: 'Shop',
  StockLocation: 'StockLocation',
  Warranty: 'Warranty'
} as const;

export type __SellerProductInfoType = typeof __SellerProductInfoType[keyof typeof __SellerProductInfoType];
export type __SellerProductType = {
  _id: Scalars['ObjectId']['output'];
  csvFieldValue?: Maybe<Scalars['String']['output']>;
  info?: Maybe<__InputProductExtraType>;
  name: Scalars['String']['output'];
  productFieldIds?: Maybe<Array<Scalars['ObjectId']['output']>>;
  settingsQty?: Maybe<__ProductSettingsQty>;
};

export type __SellerProductTypeRef = {
  _id: Scalars['ObjectId']['output'];
  name: Scalars['String']['output'];
};

export type __SellerProductTypes = __PaginatedResults & {
  info?: Maybe<__PaginationInfo>;
  items: Array<__SellerProductType>;
};

export type __SellerProductUpdateInputDocument = {
  documentId?: InputMaybe<Scalars['ObjectId']['input']>;
  groupId: Scalars['ObjectId']['input'];
};

export type __SellerProductUpdateInputInformation = {
  groupId: Scalars['ObjectId']['input'];
  info: __InputProductExtra;
};

export type __SellerProfile = {
  _id: Scalars['ObjectId']['output'];
  _user?: Maybe<__User>;
  bio?: Maybe<Scalars['String']['output']>;
  contacts?: Maybe<__SellerContacts>;
  email?: Maybe<Scalars['String']['output']>;
  handle?: Maybe<Scalars['String']['output']>;
  image?: Maybe<__Image>;
  modelBust?: Maybe<Scalars['Float']['output']>;
  modelHeight?: Maybe<Scalars['Float']['output']>;
  modelHip?: Maybe<Scalars['Float']['output']>;
  modelWaist?: Maybe<Scalars['Float']['output']>;
  publicName?: Maybe<Scalars['String']['output']>;
  sellerId?: Maybe<Scalars['ObjectId']['output']>;
  tel?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  type?: Maybe<__EnumSellerProfileType>;
  userId?: Maybe<Scalars['ObjectId']['output']>;
};

export type __SellerProfiles = {
  info?: Maybe<__PaginationInfo>;
  items?: Maybe<Array<__SellerProfile>>;
};

export type __SellerPublic = {
  _id: Scalars['ObjectId']['output'];
  doc?: Maybe<__SellerDoc>;
  productCount?: Maybe<Scalars['Int']['output']>;
};

export type __SellerPublicList = {
  letters: Array<Scalars['String']['output']>;
  sellers: Array<__SellerListEntry>;
};

export type __SellerQuoteAdmin = {
  _variants?: Maybe<Array<__SellerOrderProductsVariant>>;
  adminNote?: Maybe<Scalars['String']['output']>;
  buyer?: Maybe<__SellerQuoteAdminBuyer>;
  cancelReasonAdmin?: Maybe<Scalars['String']['output']>;
  cancelReasonCustomer?: Maybe<Scalars['String']['output']>;
  customerViewdAt?: Maybe<Scalars['MongoDate']['output']>;
  discounts: Array<__OrderDocDiscount>;
  lastMessageId?: Maybe<Scalars['ObjectId']['output']>;
  orderIds?: Maybe<Array<Scalars['String']['output']>>;
  paymentDelayDays?: Maybe<Scalars['Int']['output']>;
  productsManual: Array<__SellerOrderDocProduct>;
  skipProductsReservedStock?: Maybe<Scalars['Boolean']['output']>;
  updatedSellerAt?: Maybe<Scalars['MongoDate']['output']>;
  user?: Maybe<__User>;
};

export type __SellerQuoteAdminBuyer = {
  email?: Maybe<Scalars['String']['output']>;
  userId?: Maybe<Scalars['ObjectId']['output']>;
};

export type __SellerQuoteAdminOriginal = {
  _variants?: Maybe<Array<__SellerOrderProductsVariant>>;
  buyer?: Maybe<__SellerQuoteAdminBuyer>;
  invoice?: Maybe<__BuyerInvoice>;
  productsManual: Array<__SellerOrderDocProduct>;
  shippingAddress?: Maybe<__BuyerAddress>;
  user?: Maybe<__User>;
};

export type __SellerQuoteDelivery = {
  deliveryAt?: Maybe<Scalars['MongoDate']['output']>;
  deliveryId?: Maybe<Scalars['ObjectId']['output']>;
  incotermsAndDuties?: Maybe<__EnumIncoterms>;
  price: Scalars['Float']['output'];
  weightGrams?: Maybe<Scalars['Int']['output']>;
};

export type __SellerQuoteUpdateProductsCalcRetailDiscountProduct = {
  discountPercentage: Scalars['Float']['output'];
  productId: Scalars['ObjectId']['output'];
  qty: Scalars['Float']['output'];
};

export type __SellerResponse = __MutationResponeMsg & {
  responseInfo: __ResponseInfo;
  seller?: Maybe<__SellerPublic>;
};

export type __SellerReturn = {
  _id: Scalars['ObjectId']['output'];
  _orderAdmin?: Maybe<__SellerOrderDoc>;
  _orderBuyer?: Maybe<__SellerOrderDoc>;
  _paymentInvoice?: Maybe<__PaymentInvoiceDoc>;
  _products?: Maybe<Array<__SellerReturnProductUi>>;
  _user?: Maybe<__User>;
  _variants?: Maybe<Array<__SellerReturnVariant>>;
  bank?: Maybe<__SellerPayoutBank>;
  bankEdit?: Maybe<__SellerPayoutBank>;
  cancelationReason?: Maybe<__SellerReturnReason>;
  canceledAt?: Maybe<Scalars['MongoDate']['output']>;
  createdAt?: Maybe<Scalars['MongoDate']['output']>;
  deliveryAddress?: Maybe<__BuyerAddress>;
  history: Array<__SellerReturnHisto>;
  orderId: Scalars['ObjectId']['output'];
  orderPrettyId: Scalars['String']['output'];
  paymentId?: Maybe<Scalars['ObjectId']['output']>;
  products?: Maybe<Array<__SellerReturnProduct>>;
  ran: Scalars['String']['output'];
  refundTotal: __Price2;
  sellerId: Scalars['ObjectId']['output'];
  status: __EnumSellerReturnType;
  trackingNumbers?: Maybe<Array<__BuyerReturnTrackingNumberDetail>>;
  userId: Scalars['ObjectId']['output'];
};

export type __SellerReturnFiles = {
  en?: Maybe<__SellerFile>;
  lt?: Maybe<__SellerFile>;
};

export type __SellerReturnHisto = {
  at: Scalars['MongoDate']['output'];
  status?: Maybe<__EnumSellerReturnType>;
};

export type __SellerReturnProduct = {
  cancelReason?: Maybe<__SellerReturnReason>;
  comment?: Maybe<Scalars['String']['output']>;
  priceTotal: Scalars['Float']['output'];
  priceUnit: Scalars['Float']['output'];
  productId: Scalars['ObjectId']['output'];
  qty: Scalars['Float']['output'];
  returnReason?: Maybe<__SellerReturnReason>;
};

export type __SellerReturnProductUi = {
  item: __SellerReturnProduct;
  listing?: Maybe<__ProductListingBox>;
  total: __Price2;
};

export type __SellerReturnReason = {
  code: Scalars['String']['output'];
  txt: __Text;
};

export type __SellerReturnVariant = {
  item: __SellerReturnProduct;
  priceUnit: __Price2;
  qtyAccepted: Scalars['Float']['output'];
  restock: Scalars['Float']['output'];
  total: __Price2;
  variant?: Maybe<__ProductVariant>;
};

export type __SellerReturns = __PaginatedResults & {
  info?: Maybe<__PaginationInfo>;
  items?: Maybe<Array<__SellerReturn>>;
};

export type __SellerShipment = {
  _id: Scalars['ObjectId']['output'];
  _urls?: Maybe<__SellerTrackingValuesUrl>;
  billedPrice?: Maybe<Scalars['Float']['output']>;
  billedWeightKg?: Maybe<Scalars['Float']['output']>;
  deliveryCourierName?: Maybe<Scalars['String']['output']>;
  deliveryId?: Maybe<Scalars['ObjectId']['output']>;
  differencePrice?: Maybe<Scalars['Float']['output']>;
  differencePricePercent?: Maybe<Scalars['Float']['output']>;
  differenceWeightKg?: Maybe<Scalars['Float']['output']>;
  differenceWeightPercent?: Maybe<Scalars['Float']['output']>;
  estimatedDeliveryDate?: Maybe<Scalars['MongoDate']['output']>;
  isFullShipment?: Maybe<Scalars['Boolean']['output']>;
  lastUpdate?: Maybe<Scalars['MongoDate']['output']>;
  lockerInfo?: Maybe<__OrderLockerInfo>;
  number?: Maybe<__SellerOrderTrackingNumber>;
  orderId?: Maybe<Scalars['ObjectId']['output']>;
  orderedAt?: Maybe<Scalars['MongoDate']['output']>;
  productCount?: Maybe<Scalars['Int']['output']>;
  products?: Maybe<Array<__SellerOrderTrackingOneProduct>>;
  quotedPrice?: Maybe<Scalars['Float']['output']>;
  quotedTotalPrice?: Maybe<Scalars['Float']['output']>;
  quotedTotalWeightKg?: Maybe<Scalars['Float']['output']>;
  quotedWeightKg?: Maybe<Scalars['Float']['output']>;
  shipped?: Maybe<Scalars['Boolean']['output']>;
  status?: Maybe<__EnumSellerShipmentTrackStatus>;
  trackingProvider?: Maybe<__EnumDeliveryTrackingProvider>;
  trackingType?: Maybe<__EnumTrackingType>;
  update?: Maybe<__SellerOrderTrackingUpdate>;
};

export type __SellerShipmentHistory = {
  _id: Scalars['ObjectId']['output'];
  history?: Maybe<Array<__SellerShipmentHistoryItem>>;
};

export type __SellerShipmentHistoryItem = {
  at?: Maybe<Scalars['MongoDate']['output']>;
  locationString?: Maybe<Scalars['String']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  status?: Maybe<__EnumSellerShipmentTrackStatus>;
};

export type __SellerShipments = __PaginatedResults & {
  info?: Maybe<__PaginationInfo>;
  items?: Maybe<Array<__SellerShipment>>;
};

export type __SellerShippingDelay = {
  end?: Maybe<Scalars['MongoDate']['output']>;
  start?: Maybe<Scalars['MongoDate']['output']>;
};

export type __SellerSizeGuide = {
  _id: Scalars['ObjectId']['output'];
  areas?: Maybe<Array<__SellerGuideArea>>;
  image?: Maybe<__Image>;
  instructionsNote?: Maybe<__Text>;
  measurmentsNote?: Maybe<__Text>;
  sellerId: Scalars['ObjectId']['output'];
  sizes?: Maybe<Array<__SellerGuideSize>>;
  title: __Text;
  units?: Maybe<Array<__SellerGuideUnit>>;
  values?: Maybe<Array<__SellerGuideValue>>;
};

export type __SellerSizeGuideInput = {
  create?: InputMaybe<__SellerSizeGuideInputCreate>;
  delete?: InputMaybe<__InputId>;
  sellerId: Scalars['ObjectId']['input'];
  update?: InputMaybe<__SellerSizeGuideInputUpdate>;
};

export type __SellerSizeGuideInputCreate = {
  title: __InputText;
};

export type __SellerSizeGuideInputUpdate = {
  areas?: InputMaybe<Array<__InputSellerGuideArea>>;
  image?: InputMaybe<__ImageInput>;
  instructionsNote?: InputMaybe<__InputText>;
  measurmentsNote?: InputMaybe<__InputText>;
  sizeGuideId: Scalars['ObjectId']['input'];
  sizes?: InputMaybe<Array<__InputSellerGuideSize>>;
  title: __InputText;
  units?: InputMaybe<Array<__InputSellerGuideUnit>>;
  values?: InputMaybe<Array<__InputSellerGuideValue>>;
};

export type __SellerSizeGuideResponse = __MutationResponeMsg & {
  deleted?: Maybe<Scalars['Boolean']['output']>;
  responseInfo: __ResponseInfo;
  sizeGuide?: Maybe<__SellerSizeGuide>;
};

export type __SellerSizeGuides = {
  info?: Maybe<__PaginationInfo>;
  items?: Maybe<Array<__SellerSizeGuide>>;
};

export type __SellerSocialItem = {
  fullUrl: Scalars['String']['output'];
  handle: Scalars['String']['output'];
  type: __SocialLinkType;
};

export type __SellerSubscription = {
  _id: Scalars['ObjectId']['output'];
  createdAt?: Maybe<Scalars['MongoDate']['output']>;
  deviceId?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  isSubscribed?: Maybe<Scalars['Boolean']['output']>;
  lang?: Maybe<Scalars['String']['output']>;
  newsletterUpdatedAt?: Maybe<Scalars['MongoDate']['output']>;
  reviewRemindersEnabled?: Maybe<Scalars['Boolean']['output']>;
  reviewRemindersUpdatedAt?: Maybe<Scalars['MongoDate']['output']>;
  sellerId: Scalars['ObjectId']['output'];
  syncedAt?: Maybe<Scalars['MongoDate']['output']>;
  updatedAt?: Maybe<Scalars['MongoDate']['output']>;
  userId?: Maybe<Scalars['ObjectId']['output']>;
};

export type __SellerSubscriptions = __PaginatedResults & {
  _profiles?: Maybe<Array<__SellerSubscriptionsSubscriptions>>;
  _users?: Maybe<Array<__User>>;
  info?: Maybe<__PaginationInfo>;
  items?: Maybe<Array<__SellerSubscription>>;
};

export type __SellerSubscriptionsSubscriptions = {
  _id: Scalars['ObjectId']['output'];
  profile: __SellerProfile;
};

export type __SellerTextLink = {
  link?: Maybe<__SellerLink>;
  text?: Maybe<__Text>;
};

export type __SellerTrackingValuesUrl = {
  code: Scalars['String']['output'];
  full: Scalars['String']['output'];
};

export type __Sellers = __PaginatedResults & {
  info?: Maybe<__PaginationInfo>;
  items?: Maybe<Array<__Seller>>;
};

export type __SeoProblem = {
  _id: Scalars['ObjectId']['output'];
  allowRepeating?: Maybe<Scalars['Boolean']['output']>;
  checked: Scalars['String']['output'];
  disableDescriptionCheck?: Maybe<Scalars['Boolean']['output']>;
  disableKeywordMatch?: Maybe<Scalars['Boolean']['output']>;
  field: Scalars['String']['output'];
  hash: Scalars['String']['output'];
  ids?: Maybe<Array<Scalars['ObjectId']['output']>>;
  keywordMatch?: Maybe<Array<Scalars['String']['output']>>;
  keywordMatchedSize?: Maybe<Scalars['Int']['output']>;
  lang: Scalars['String']['output'];
  repeated: Scalars['Int']['output'];
  target?: Maybe<__EnumSeoProblemTarget>;
  text: Scalars['String']['output'];
  tooLong?: Maybe<Scalars['Boolean']['output']>;
  tooShort?: Maybe<Scalars['Boolean']['output']>;
};

export type __SeoProblemKeyword = {
  _id: Scalars['ObjectId']['output'];
  keyword: Scalars['String']['output'];
};

export type __SeoProblems = __PaginatedResults & {
  info?: Maybe<__PaginationInfo>;
  items?: Maybe<Array<__SeoProblem>>;
};

export type __SeoProblemsKeywords = __PaginatedResults & {
  info?: Maybe<__PaginationInfo>;
  items?: Maybe<Array<__SeoProblemKeyword>>;
};

export type __SeoProblemsSettings = {
  _id: Scalars['ObjectId']['output'];
  descriptionMax: Scalars['Int']['output'];
  descriptionMin: Scalars['Int']['output'];
};

export type __SignInInput = {
  email: Scalars['String']['input'];
  password: Scalars['String']['input'];
};

export const __SocialLinkType = {
  Facebook: 'Facebook',
  FbMessenger: 'FbMessenger',
  Instagram: 'Instagram',
  Pinterest: 'Pinterest',
  Spotify: 'Spotify',
  Tiktok: 'Tiktok',
  Twitter: 'Twitter',
  Website: 'Website',
  Youtube: 'Youtube'
} as const;

export type __SocialLinkType = typeof __SocialLinkType[keyof typeof __SocialLinkType];
export const __StockMsg = {
  SoldOut: 'SoldOut',
  Soon: 'Soon'
} as const;

export type __StockMsg = typeof __StockMsg[keyof typeof __StockMsg];
export type __StoreConfig = {
  paypalClientId: Scalars['String']['output'];
  uploadFormatImage?: Maybe<Array<Scalars['String']['output']>>;
  uploadFormatVideo?: Maybe<Array<Scalars['String']['output']>>;
};

export type __StringTranslateInput = {
  lang: Scalars['String']['input'];
  value: Scalars['String']['input'];
};

export type __System = {
  _id: Scalars['String']['output'];
};

export type __SystemActionsInput = {
  getActions?: InputMaybe<Scalars['Boolean']['input']>;
  trigetAction?: InputMaybe<__SystemActionsInputAction>;
};

export type __SystemActionsInputAction = {
  action: Scalars['String']['input'];
};

export type __SystemBankDetails = {
  banks?: Maybe<Array<__SystemBankDetailsItem>>;
  id: Scalars['String']['output'];
  message?: Maybe<__Text>;
};

export type __SystemBankDetailsInput = {
  addBank?: InputMaybe<__SystemBankDetailsInputItem>;
  removeBank?: InputMaybe<__InputId>;
  setMessage?: InputMaybe<__InputText>;
  updateBank?: InputMaybe<__SystemBankDetailsInputItemUpdate>;
};

export type __SystemBankDetailsInputItem = {
  SWIFT: Scalars['String']['input'];
  accountName: __InputText;
  accountNr: Scalars['String']['input'];
  bankName: __InputText;
  legalEntityIdentifier: __InputText;
};

export type __SystemBankDetailsInputItemUpdate = {
  _id: Scalars['ObjectId']['input'];
  doc: __SystemBankDetailsInputItem;
};

export type __SystemBankDetailsItem = {
  SWIFT: Scalars['String']['output'];
  _id: Scalars['ObjectId']['output'];
  accountName: __Text;
  accountNr: Scalars['String']['output'];
  bankName: __Text;
  legalEntityIdentifier: __Text;
};

export type __SystemBanksResponse = __MutationResponeMsg & {
  deleted?: Maybe<Scalars['Boolean']['output']>;
  doc?: Maybe<__SystemBankDetails>;
  responseInfo: __ResponseInfo;
};

export type __SystemUploadProducts = {
  fileId?: Maybe<Scalars['ObjectId']['output']>;
  uploadUrl?: Maybe<Scalars['String']['output']>;
};

export type __Text = {
  translations: Array<__TextTranslate>;
  value?: Maybe<Scalars['String']['output']>;
};

export type __TextTranslate = {
  lang: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

export type __UiPreviewBox = {
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  image?: Maybe<__Image>;
  title?: Maybe<Scalars['String']['output']>;
  type: __UiPreviewBoxType;
};

export const __UiPreviewBoxType = {
  Factory: 'Factory',
  Profile: 'Profile',
  Seller: 'Seller',
  SellerArticle: 'SellerArticle',
  SellerListing: 'SellerListing'
} as const;

export type __UiPreviewBoxType = typeof __UiPreviewBoxType[keyof typeof __UiPreviewBoxType];
export type __UiSellerDeliveryProductView = {
  courier?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  pricingType?: Maybe<__EnumSellerDeliveryPricing>;
  title: Scalars['String']['output'];
  type: __SellerDeliveryType;
};

export type __UiWeight = {
  forHumans?: Maybe<Scalars['String']['output']>;
  value: Scalars['Float']['output'];
};

export type __UpcomingEntries = __PaginatedResults & {
  info?: Maybe<__PaginationInfo>;
  items?: Maybe<Array<__UpcomingEntry>>;
};

export type __UpcomingEntry = {
  _id: Scalars['ObjectId']['output'];
  _paymentInvoice?: Maybe<__PaymentInvoiceDoc>;
  address?: Maybe<__BuyerAddress>;
  isOn?: Maybe<Scalars['Boolean']['output']>;
  paymentId?: Maybe<Scalars['ObjectId']['output']>;
  productId: Scalars['ObjectId']['output'];
  userId: Scalars['ObjectId']['output'];
};

export type __UpcomingEntryPreEnter = {
  allowed: Scalars['Boolean']['output'];
  priceDelivery?: Maybe<__Price2>;
  priceFull?: Maybe<__Price2>;
  priceProduct?: Maybe<__Price2>;
};

export type __User = {
  _b2b?: Maybe<Array<__UserB2B>>;
  _id: Scalars['ObjectId']['output'];
  _profile?: Maybe<__SellerProfile>;
  doc: __UserDoc;
  isEmailVerified?: Maybe<Scalars['Boolean']['output']>;
  isMe?: Maybe<Scalars['Boolean']['output']>;
};

export type __UserB2B = {
  hasPricing?: Maybe<Scalars['Boolean']['output']>;
  sellerId: Scalars['ObjectId']['output'];
};

export type __UserDoc = {
  _id: Scalars['ObjectId']['output'];
  _statsOrders?: Maybe<__UserDocStatsOrders>;
  address?: Maybe<__BuyerAddressDefault>;
  adminNote?: Maybe<Scalars['String']['output']>;
  birthdate?: Maybe<Scalars['MongoDate']['output']>;
  blocked?: Maybe<Scalars['Boolean']['output']>;
  buyerCartSize?: Maybe<Scalars['Int']['output']>;
  buyerNotifications?: Maybe<Scalars['Boolean']['output']>;
  buyerType?: Maybe<__EnumBuyerType>;
  createdAt?: Maybe<Scalars['MongoDate']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  gender?: Maybe<__EnumBuyerGender>;
  isPublic?: Maybe<Scalars['Boolean']['output']>;
  lang: Scalars['String']['output'];
  lastname?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  publicName?: Maybe<Scalars['String']['output']>;
  roles?: Maybe<Array<__UserType>>;
};

export type __UserDocStatsOrders = {
  orders?: Maybe<Scalars['Int']['output']>;
  products?: Maybe<Scalars['Int']['output']>;
  qty?: Maybe<Scalars['Float']['output']>;
  sales?: Maybe<Scalars['Float']['output']>;
};

export type __UserLanguageUpdateInput = {
  lang: Scalars['String']['input'];
};

export type __UserProductBoardInputCreate = {
  isPublic: Scalars['Boolean']['input'];
  name: Scalars['String']['input'];
};

export type __UserProductBoardInputProduct = {
  boardId: Scalars['ObjectId']['input'];
  productId: Scalars['ObjectId']['input'];
  quantity?: InputMaybe<Scalars['Float']['input']>;
};

export type __UserProductBoardInputUpdate = {
  boardId: Scalars['ObjectId']['input'];
  isPublic: Scalars['Boolean']['input'];
  name: Scalars['String']['input'];
};

export type __UserProductBoards = {
  cursorNext?: Maybe<Scalars['String']['output']>;
  items: Array<__BuyerProductBoard>;
};

export const __UserType = {
  Admin: 'Admin',
  Client: 'Client',
  God: 'God',
  New: 'New',
  User: 'User'
} as const;

export type __UserType = typeof __UserType[keyof typeof __UserType];
export type __Users = __PaginatedResults & {
  info?: Maybe<__PaginationInfo>;
  items?: Maybe<Array<__UserDoc>>;
  users?: Maybe<Array<__User>>;
};

export type __MarketCountryFragment = { id?: string | null, iso2: string, continent?: __EnumCountryContinent | null, priority?: boolean | null, telCode?: string | null, isEu?: boolean | null, altname?: Array<string> | null, title: { value?: string | null }, img?: { isVideo?: boolean | null, alt?: { value?: string | null } | null, image2?: { _id?: string | null, alt?: string | null, url?: string | null, height?: number | null, width?: number | null, videoHls?: string | null, video?: string | null, isVideo?: boolean | null, noProxy?: boolean | null, audio?: boolean | null, type?: string | null, fallbackUrl?: string | null, img?: string | null, hsla?: { h: number, s: number, l: number, a?: number | null } | null, aspect?: { x: number, y: number } | null } | null } | null };

export type __DocumentColorHslaFragment = { h: number, s: number, l: number, a?: number | null };

export type __ImageItemFragment = { _id?: string | null, alt?: string | null, url?: string | null, height?: number | null, width?: number | null, videoHls?: string | null, video?: string | null, isVideo?: boolean | null, noProxy?: boolean | null, audio?: boolean | null, type?: string | null, fallbackUrl?: string | null, img?: string | null, hsla?: { h: number, s: number, l: number, a?: number | null } | null, aspect?: { x: number, y: number } | null };

export type __ImageFragment = { isVideo?: boolean | null, alt?: { value?: string | null } | null, image2?: { _id?: string | null, alt?: string | null, url?: string | null, height?: number | null, width?: number | null, videoHls?: string | null, video?: string | null, isVideo?: boolean | null, noProxy?: boolean | null, audio?: boolean | null, type?: string | null, fallbackUrl?: string | null, img?: string | null, hsla?: { h: number, s: number, l: number, a?: number | null } | null, aspect?: { x: number, y: number } | null } | null };

export type __UiPreviewBoxFragment = { id: string, title?: string | null, description?: string | null, type: __UiPreviewBoxType, image?: { isVideo?: boolean | null, alt?: { value?: string | null } | null, image2?: { _id?: string | null, alt?: string | null, url?: string | null, height?: number | null, width?: number | null, videoHls?: string | null, video?: string | null, isVideo?: boolean | null, noProxy?: boolean | null, audio?: boolean | null, type?: string | null, fallbackUrl?: string | null, img?: string | null, hsla?: { h: number, s: number, l: number, a?: number | null } | null, aspect?: { x: number, y: number } | null } | null } | null };

export type __OpeningHoursHourFragment = { hour: number, min: number };

export type __OpeningHoursDayFragment = { open24?: boolean | null, close?: boolean | null, hours?: Array<{ open: { hour: number, min: number }, close: { hour: number, min: number } }> | null };

export type __OpeningHoursFragment = { timezone?: string | null, mon?: { open24?: boolean | null, close?: boolean | null, hours?: Array<{ open: { hour: number, min: number }, close: { hour: number, min: number } }> | null } | null, tue?: { open24?: boolean | null, close?: boolean | null, hours?: Array<{ open: { hour: number, min: number }, close: { hour: number, min: number } }> | null } | null, wed?: { open24?: boolean | null, close?: boolean | null, hours?: Array<{ open: { hour: number, min: number }, close: { hour: number, min: number } }> | null } | null, thu?: { open24?: boolean | null, close?: boolean | null, hours?: Array<{ open: { hour: number, min: number }, close: { hour: number, min: number } }> | null } | null, fri?: { open24?: boolean | null, close?: boolean | null, hours?: Array<{ open: { hour: number, min: number }, close: { hour: number, min: number } }> | null } | null, sat?: { open24?: boolean | null, close?: boolean | null, hours?: Array<{ open: { hour: number, min: number }, close: { hour: number, min: number } }> | null } | null, sun?: { open24?: boolean | null, close?: boolean | null, hours?: Array<{ open: { hour: number, min: number }, close: { hour: number, min: number } }> | null } | null };

export type __SellerContactsFragment = { emails?: Array<string> | null, tels?: Array<string> | null, openingHours?: { timezone?: string | null, mon?: { open24?: boolean | null, close?: boolean | null, hours?: Array<{ open: { hour: number, min: number }, close: { hour: number, min: number } }> | null } | null, tue?: { open24?: boolean | null, close?: boolean | null, hours?: Array<{ open: { hour: number, min: number }, close: { hour: number, min: number } }> | null } | null, wed?: { open24?: boolean | null, close?: boolean | null, hours?: Array<{ open: { hour: number, min: number }, close: { hour: number, min: number } }> | null } | null, thu?: { open24?: boolean | null, close?: boolean | null, hours?: Array<{ open: { hour: number, min: number }, close: { hour: number, min: number } }> | null } | null, fri?: { open24?: boolean | null, close?: boolean | null, hours?: Array<{ open: { hour: number, min: number }, close: { hour: number, min: number } }> | null } | null, sat?: { open24?: boolean | null, close?: boolean | null, hours?: Array<{ open: { hour: number, min: number }, close: { hour: number, min: number } }> | null } | null, sun?: { open24?: boolean | null, close?: boolean | null, hours?: Array<{ open: { hour: number, min: number }, close: { hour: number, min: number } }> | null } | null } | null, links?: Array<{ type: __SocialLinkType, handle: string }> | null };

export type __ImageTaggedFragment = { ratio?: __ImageTaggedRatio | null, type?: __ImageProductType | null, img: { isVideo?: boolean | null, alt?: { value?: string | null } | null, image2?: { _id?: string | null, alt?: string | null, url?: string | null, height?: number | null, width?: number | null, videoHls?: string | null, video?: string | null, isVideo?: boolean | null, noProxy?: boolean | null, audio?: boolean | null, type?: string | null, fallbackUrl?: string | null, img?: string | null, hsla?: { h: number, s: number, l: number, a?: number | null } | null, aspect?: { x: number, y: number } | null } | null }, tags?: Array<{ x?: number | null, y?: number | null, productId?: string | null, profileId?: string | null }> | null };

export type __SellerLinkFragment = { alt?: string | null, type: __SellerLinkType, slug: string, sellerId: string };

export type __SellerTextLinkFragment = { text?: { value?: string | null } | null, link?: { alt?: string | null, type: __SellerLinkType, slug: string, sellerId: string } | null };

export type __DiscountUiFragment = { msg: string, amount: string };

export type __ProductListingValuesFragment = { variantCount?: number | null, variantAvailableCount?: number | null, stock?: number | null, inStock?: boolean | null, variantBoxList?: Array<{ id: string, slug: string, imageBox?: { _id?: string | null, alt?: string | null, url?: string | null, height?: number | null, width?: number | null, videoHls?: string | null, video?: string | null, isVideo?: boolean | null, noProxy?: boolean | null, audio?: boolean | null, type?: string | null, fallbackUrl?: string | null, img?: string | null, hsla?: { h: number, s: number, l: number, a?: number | null } | null, aspect?: { x: number, y: number } | null } | null }> | null, options?: Array<{ key: string, name: string, guideProductId?: string | null, guideBodyId?: string | null, values: Array<{ name?: string | null, hsla?: { h: number, s: number, l: number, a?: number | null } | null, image?: { _id?: string | null, alt?: string | null, url?: string | null, height?: number | null, width?: number | null, videoHls?: string | null, video?: string | null, isVideo?: boolean | null, noProxy?: boolean | null, audio?: boolean | null, type?: string | null, fallbackUrl?: string | null, img?: string | null, hsla?: { h: number, s: number, l: number, a?: number | null } | null, aspect?: { x: number, y: number } | null } | null, product?: { productId: string, inStock: boolean, slug: string, image?: { _id?: string | null, alt?: string | null, url?: string | null, height?: number | null, width?: number | null, videoHls?: string | null, video?: string | null, isVideo?: boolean | null, noProxy?: boolean | null, audio?: boolean | null, type?: string | null, fallbackUrl?: string | null, img?: string | null, hsla?: { h: number, s: number, l: number, a?: number | null } | null, aspect?: { x: number, y: number } | null } | null } | null }> }> | null, _uiPrice?: { endAt?: string | null, price: { priceForHumans: string, number: number }, priceOld?: { priceForHumans: string, number: number } | null, lineItems: Array<{ qty: number, price: { priceForHumans: string, number: number }, ui?: Array<{ msg: string, amount: string }> | null }> } | null };

export type __ProductListingBoxFragment = { id: string, slug: string, groupId: string, departmentName?: string | null, isNew: boolean, title: string, availabilityType?: __ProductAvailabilityType | null, availableAt?: string | null, quantityLimit?: number | null, img1?: string | null, _values?: { variantCount?: number | null, variantAvailableCount?: number | null, stock?: number | null, inStock?: boolean | null, variantBoxList?: Array<{ id: string, slug: string, imageBox?: { _id?: string | null, alt?: string | null, url?: string | null, height?: number | null, width?: number | null, videoHls?: string | null, video?: string | null, isVideo?: boolean | null, noProxy?: boolean | null, audio?: boolean | null, type?: string | null, fallbackUrl?: string | null, img?: string | null, hsla?: { h: number, s: number, l: number, a?: number | null } | null, aspect?: { x: number, y: number } | null } | null }> | null, options?: Array<{ key: string, name: string, guideProductId?: string | null, guideBodyId?: string | null, values: Array<{ name?: string | null, hsla?: { h: number, s: number, l: number, a?: number | null } | null, image?: { _id?: string | null, alt?: string | null, url?: string | null, height?: number | null, width?: number | null, videoHls?: string | null, video?: string | null, isVideo?: boolean | null, noProxy?: boolean | null, audio?: boolean | null, type?: string | null, fallbackUrl?: string | null, img?: string | null, hsla?: { h: number, s: number, l: number, a?: number | null } | null, aspect?: { x: number, y: number } | null } | null, product?: { productId: string, inStock: boolean, slug: string, image?: { _id?: string | null, alt?: string | null, url?: string | null, height?: number | null, width?: number | null, videoHls?: string | null, video?: string | null, isVideo?: boolean | null, noProxy?: boolean | null, audio?: boolean | null, type?: string | null, fallbackUrl?: string | null, img?: string | null, hsla?: { h: number, s: number, l: number, a?: number | null } | null, aspect?: { x: number, y: number } | null } | null } | null }> }> | null, _uiPrice?: { endAt?: string | null, price: { priceForHumans: string, number: number }, priceOld?: { priceForHumans: string, number: number } | null, lineItems: Array<{ qty: number, price: { priceForHumans: string, number: number }, ui?: Array<{ msg: string, amount: string }> | null }> } | null } | null, settingsQty?: { min?: number | null, max?: number | null, step?: number | null, unit?: __EnumProductQtyUnit | null, stockMsg?: __StockMsg | null } | null, option?: Array<{ key: string, uiKey?: string | null, uiValue?: string | null }> | null, images?: Array<{ _id?: string | null, alt?: string | null, url?: string | null, height?: number | null, width?: number | null, videoHls?: string | null, video?: string | null, isVideo?: boolean | null, noProxy?: boolean | null, audio?: boolean | null, type?: string | null, fallbackUrl?: string | null, img?: string | null, hsla?: { h: number, s: number, l: number, a?: number | null } | null, aspect?: { x: number, y: number } | null }> | null, rating?: { count?: number | null, rating?: number | null } | null };


      export interface PossibleTypesResultData {
        possibleTypes: {
          [key: string]: string[]
        }
      }
      const result: PossibleTypesResultData = {
  "possibleTypes": {
    "MutationResponeMsg": [
      "BuyerBoardResponse",
      "BuyerCheckoutResponse",
      "BuyerSellerOrderResponse",
      "EmailBlacklistinResponse",
      "GodActionsResponse",
      "ImageUploadFileResponse",
      "ImageUploadUrlResponse",
      "MessageResponse",
      "PaymentProviderResponse",
      "PostResponse",
      "ResponsProductType",
      "ResponsSellerAdminInvitation",
      "ResponsSellerBuyer",
      "ResponsSellerColors",
      "ResponsSellerDeliveryZones",
      "ResponsSellerDocumentTemplates",
      "ResponsSellerLinks",
      "ResponsSellerSubs",
      "ResponsSellerTextHelp",
      "ResponsSeoProblems",
      "ResponseAuthBuyer",
      "ResponseBuyerAddress",
      "ResponseBuyerB2b",
      "ResponseBuyerCart",
      "ResponseBuyerEverypayCard",
      "ResponseBuyerInformation",
      "ResponseBuyerLikes",
      "ResponseBuyerNotify",
      "ResponseBuyerProductHistory",
      "ResponseBuyerSubscription",
      "ResponseCheckoutQuote",
      "ResponseGiftcard",
      "ResponseMarketCountry",
      "ResponseSellerArticle",
      "ResponseSellerBusiness",
      "ResponseSellerCatalogVisibility",
      "ResponseSellerDepartments",
      "ResponseSellerPayouts",
      "ResponseSellerPriceGroup",
      "ResponseSellerProduct",
      "ResponseSellerQuote",
      "ResponseSellerReturn",
      "ResponseSellerSubscription",
      "ResponseUpcomingEntry",
      "ResposeSellerProfile",
      "SellerBundleResponse",
      "SellerCatalogUiResponse",
      "SellerDeliveryResponse",
      "SellerDiscountResponse",
      "SellerDocumentResponse",
      "SellerFaqResponse",
      "SellerOrderResponse",
      "SellerPageResponse",
      "SellerProductFieldResponse",
      "SellerProductInfoResponse",
      "SellerResponse",
      "SellerSizeGuideResponse",
      "SystemBanksResponse"
    ],
    "PaginatedResults": [
      "BuyerEverypayCards",
      "BuyerOrderPaymentList",
      "BuyerReturnOrders",
      "CheckoutQuotes",
      "DocumentColorSearch",
      "Giftcards",
      "Listings",
      "LoggingDocs",
      "MarketCountries",
      "PaymentInvoicesPagination",
      "PaymentProvidersPagination",
      "PostsPagination",
      "ProductVariants",
      "SellerAdminInvitations",
      "SellerArticles",
      "SellerBundles",
      "SellerBusinessRequests",
      "SellerBusinesses",
      "SellerBuyers",
      "SellerCatalogUis",
      "SellerCatalogVisibilityList",
      "SellerCheckoutPagination",
      "SellerDeliveries",
      "SellerDeliveryZones",
      "SellerDepartments",
      "SellerDiscountCodes",
      "SellerDiscounts",
      "SellerDocumentTemplates",
      "SellerDocuments",
      "SellerFaqList",
      "SellerFiles",
      "SellerGiftcards",
      "SellerImages",
      "SellerLockerItems",
      "SellerOrderPagination",
      "SellerPageSections",
      "SellerPages",
      "SellerPayouts",
      "SellerPriceGroups",
      "SellerProductFieldValuesUis",
      "SellerProductFields",
      "SellerProductInfoList",
      "SellerProductTypes",
      "SellerReturns",
      "SellerShipments",
      "SellerSubscriptions",
      "Sellers",
      "SeoProblems",
      "SeoProblemsKeywords",
      "UpcomingEntries",
      "Users"
    ]
  }
};
      export default result;
    